var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJustSayYesMonetta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 436,
    height: 168,
    viewBox: "0 0 436 168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 434.603,
    height: 140.752,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436,
    height: 168
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 27.248)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1032.478,392.019c-.016-.016-.026-.034-.042-.049l-.014-.011c-.016-.016-.026-.034-.042-.049l-.013-.011c-.016-.016-.027-.034-.042-.049l-.014-.012c-.016-.016-.026-.034-.042-.049l-.014-.011c-.015-.016-.026-.033-.042-.049l-.014-.011c-.016-.016-.026-.033-.042-.049a.119.119,0,0,1-.013-.011c-.015-.015-.026-.034-.042-.049a.116.116,0,0,1-.014-.01c-.016-.015-.026-.034-.042-.049a.153.153,0,0,0-.014-.011c-.016-.015-.026-.033-.042-.049s-.009-.007-.014-.012-.026-.033-.042-.049a.111.111,0,0,1-.013-.011c-.016-.015-.027-.033-.042-.049l-.014-.01c-.016-.016-.026-.034-.042-.05l-.014-.011c-.015-.015-.026-.034-.042-.049l-.013-.011c-.016-.016-.026-.034-.042-.049l-.013-.01c-.016-.016-.026-.034-.042-.05l-.014-.011c-.016-.016-.026-.034-.042-.049l-.014-.011c-.016-.016-.026-.034-.042-.05l-.013-.011c-.015-.016-.026-.034-.042-.049l-.014-.011c-.016-.016-.026-.034-.042-.049l-.014-.011c-.016-.016-.026-.034-.042-.049a.116.116,0,0,0-.014-.011c-.016-.016-.026-.034-.042-.049l-.014-.011c-.016-.016-.026-.034-.042-.049a.119.119,0,0,0-.013-.011c-.016-.016-.026-.034-.042-.049l-.014-.012c-.016-.016-.026-.034-.042-.049a.166.166,0,0,1-.013-.011c-.016-.016-.026-.033-.042-.049a.1.1,0,0,1-.014-.011c-.016-.016-.026-.033-.042-.049s-.009-.007-.014-.012-.026-.033-.042-.049l-.014-.011c-.016-.015-.026-.033-.042-.049l-.013-.011c-.016-.015-.026-.033-.042-.049a.11.11,0,0,1-.014-.011c-.016-.015-.026-.034-.042-.049l-.014-.01c-.016-.015-.026-.034-.042-.049s-.01-.007-.014-.011-.026-.033-.042-.049l-.013-.011c-.015-.016-.026-.034-.042-.049a.082.082,0,0,1-.014-.011c-.016-.016-.026-.034-.042-.049l-.014-.01c-.016-.016-.026-.034-.042-.05s-.009-.007-.013-.011-.026-.034-.042-.049l-.013-.011c-.016-.016-.026-.034-.042-.049l-.014-.011c-.016-.016-.026-.034-.042-.049l-.013-.01c-.016-.016-.026-.034-.042-.05l-.014-.011c-.016-.016-.026-.034-.041-.049l-.014-.011c-.016-.016-.026-.034-.042-.049l-.014-.011c-.015-.015-.026-.034-.042-.049s-.01-.007-.014-.011-.026-.034-.042-.049l-.013-.011c-.016-.016-.026-.034-.042-.049a.121.121,0,0,0-.014-.011c-.015-.015-.026-.034-.042-.049a.087.087,0,0,0-.014-.011c-.016-.016-.026-.033-.042-.049s-.009-.007-.013-.011-.027-.034-.043-.049l-.013-.01c-.016-.015-.026-.034-.042-.049l-.014-.011c-.015-.015-.026-.033-.041-.049l-.014-.012c-.015-.015-.026-.033-.042-.049a.122.122,0,0,1-.013-.011c-.016-.015-.026-.033-.042-.049a8.527,8.527,0,0,1,0,12.06,9.1,9.1,0,0,1-.789.632l2.569,3.269a8.912,8.912,0,0,0,1.048-.84,8.526,8.526,0,0,0,0-12.06.172.172,0,0,0-.014-.012",
    transform: "translate(-703.109 -265.813)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.277,241.964h-.06l.005-.06h-.061l.005-.06h-.061l.005-.06h-.06l0-.06h-.06l.005-.06h-.061l.005-.06h-.061l.005-.06h-.06l0-.06h-.061l.005-.06h-.06l.005-.06h-.061l.005-.06h-.061l.005-.06h-.06l0-.06h-.061l.005-.06h-.061l.005-.06h-.061l.005-.06h-.06l0-.06h-.06l.005-.06h-.061l.005-.06h-.061l.005-.06h-.06l.005-.06h-.06l0-.06H1036l0-.06h-.061l.005-.06h-.061l.005-.06h-.06l0-.06h-.06l.005-.06h-.061l.005-.06h-.061l.005-.06h-.06l.005-.06h-.061l.005-.06h-.06l0-.06h-.061l.005-.06h-.061l.005-.06h-.06l0-.06h-.06l.005-.06h-.061l.005-.06h-.061l.005-.06h-.06l.005-.06h-.06l.005-.06H1035l0-.06h-.061l.005-.06h-.06l.005-.06h-.061l0-.06h-.06l.005-.06h-.061l.005-.06h-.061l.005-.06h-.06l.005-.06h-.06l.005-.06h-.061l0-.06h-.061l-3.355,40.862,2.829,3.061Z",
    transform: "translate(-704.622 -163.301)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.981,77.877a8.633,8.633,0,0,0,0-12.06l-.016-.013c-.015-.015-.024-.032-.039-.047l-.016-.013c-.014-.015-.024-.032-.039-.047l-.016-.013c-.015-.015-.024-.032-.039-.047a.2.2,0,0,1-.017-.013c-.015-.015-.024-.032-.039-.047l-.016-.013c-.015-.015-.024-.032-.039-.047l-.016-.013c-.015-.015-.025-.032-.039-.047l-.016-.013c-.015-.015-.024-.033-.039-.047l-.016-.013c-.015-.015-.024-.033-.04-.047l-.016-.013c-.015-.015-.024-.032-.039-.047l-.016-.013c-.015-.015-.025-.032-.039-.047l-.016-.013c-.015-.015-.025-.032-.039-.047s-.011-.008-.016-.013-.024-.032-.04-.047-.011-.008-.016-.013-.024-.032-.039-.047l-.016-.013c-.015-.015-.024-.032-.039-.047s-.011-.008-.016-.013-.024-.032-.039-.047l-.016-.013c-.014-.014-.024-.032-.039-.046a.19.19,0,0,0-.016-.013c-.015-.016-.025-.033-.04-.048s-.011-.008-.016-.013-.024-.032-.039-.047-.011-.009-.016-.014-.024-.032-.039-.046l-.016-.014c-.014-.015-.024-.032-.039-.047l-.016-.013c-.015-.015-.024-.032-.039-.047s-.012-.009-.017-.014-.024-.032-.039-.046-.011-.009-.016-.013-.024-.032-.04-.048l-.016-.013c-.015-.015-.025-.032-.039-.047l-.016-.013c-.015-.015-.024-.032-.039-.047s-.011-.008-.016-.013-.024-.032-.04-.048-.011-.008-.016-.013-.024-.032-.039-.047l-.016-.013c-.015-.015-.025-.032-.039-.047l-.016-.013c-.015-.015-.025-.032-.039-.047s-.011-.008-.016-.013-.024-.033-.04-.048L47.3,64c-.015-.015-.024-.032-.039-.047s-.011-.008-.016-.013-.025-.032-.039-.047l-.016-.013c-.015-.015-.024-.032-.039-.047l-.016-.013c-.015-.015-.024-.032-.039-.047l-.016-.013c-.015-.015-.024-.032-.04-.047l-.016-.013c-.015-.015-.024-.032-.039-.046s-.011-.009-.016-.014-.025-.032-.039-.047-.011-.008-.016-.013-.024-.032-.039-.047l-.015-.012c-.016-.016-.025-.033-.04-.047s-.012-.009-.017-.014-.024-.032-.039-.047-.012-.008-.017-.013-.024-.032-.039-.047l-.016-.014c-.015-.014-.024-.032-.039-.046l-.016-.014c-.015-.015-.024-.032-.039-.047l-.016-.013c-.015-.015-.024-.032-.04-.047l-.016-.014c-.015-.014-.024-.032-.039-.046l-.016-.014c-.014-.015-.024-.032-.039-.047a.1.1,0,0,1-.016-.013c-.016-.014-.024-.032-.04-.047a.152.152,0,0,1-.016-.013c-.015-.015-.024-.032-.04-.047s-.011-.008-.016-.014-.024-.032-.039-.047a.2.2,0,0,1-.016-.013c-.015-.015-.025-.032-.039-.047l-.016-.012a8.624,8.624,0,0,1-.039,12.012,8.622,8.622,0,0,1-1.118.908L47.552,79a8.5,8.5,0,0,0,1.429-1.124",
    transform: "translate(-30.776 -42.919)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.392,124.753l-.005-.06h-.05l-.005-.06h-.051l0-.06h-.051l-.005-.06h-.05l-.005-.06h-.051l0-.06h-.051l0-.06H50l-.005-.06h-.05l-.005-.06h-.05l-.005-.06h-.05l-.005-.06h-.051l0-.06h-.051l-.005-.06h-.05l-.005-.06h-.05l-.005-.06h-.051l0-.06H49.5l-.005-.06h-.05l-.005-.06h-.05l-.005-.06h-.05l-.005-.06h-.051l0-.06h-.051l-.005-.06h-.05l-.005-.06h-.05l-.005-.06H49.06l0-.06H49l-.005-.06h-.05l-.005-.06h-.05l-.005-.06h-.05l-.005-.06h-.051l0-.06h-.051l0-.06h-.051l-.005-.06h-.05l-.005-.06h-.051l0-.06h-.051l-.005-.06h-.05l-.005-.06H48.4l-.005-.06h-.05l-.005-.06h-.05l-.005-.06h-.051l0-.06h-.051l-.005-.06h-.05l-.005-.06h-.051l0-.06h-.051l-.005-.06h-.05l-.005-.06H47.9l-.005-.06h-.05l-.005-.06h-.05l-.005-.06h-.051l0-.06h-.051l-.005-.06h-.05l-.005-.06,3.445,40.921,2.828,3.062-3.445-40.922Z",
    transform: "translate(-32.538 -83.162)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.906,381.346a8.323,8.323,0,0,0-6.073,2.414,8.1,8.1,0,0,0-2.457,6.029,8.923,8.923,0,0,0,.194,1.875c0,.015.01.029.013.044a8.375,8.375,0,0,0,.549,1.664h0l0,.005a8.278,8.278,0,0,0,.717,1.273,8.4,8.4,0,0,0,.981,1.169l.016.013h0a8.74,8.74,0,0,0,11.3.619,9.041,9.041,0,0,0,.789-.632,8.526,8.526,0,0,0,0-12.06,8.374,8.374,0,0,0-6.031-2.414",
    transform: "translate(-673.383 -260.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.207,238.774l3.445,40.922h11.715l3.355-40.862.005-.06Z",
    transform: "translate(-671.901 -163.173)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.358,121.693,0,162.615l18.516-.006,0,.005-3.445-40.921Z",
    transform: "translate(0 -83.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.013,66.6c.012.032.016.066.028.1a8.008,8.008,0,0,0,1.724,2.6c.066.067.111.146.18.212a8.355,8.355,0,0,0,6.031,2.414,8.418,8.418,0,0,0,4.955-1.505,8.622,8.622,0,0,0,1.117-.908A8.625,8.625,0,0,0,17.087,57.5c-.015-.016-.024-.033-.039-.047a8.323,8.323,0,0,0-6.072-2.411,8.363,8.363,0,0,0-6.031,2.411,8.029,8.029,0,0,0-2.5,6.031A9.174,9.174,0,0,0,2.6,65.172,7.893,7.893,0,0,0,3.013,66.6",
    transform: "translate(-1.672 -37.612)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.246,429.5a8.329,8.329,0,0,1-6.056-2.4c.015.014.024.032.039.046a.184.184,0,0,0,.016.013c.015.016.024.032.04.047s.01.008.016.013.024.032.04.047l.015.012c.015.016.024.033.04.047l.016.013c.016.015.024.032.04.047l.016.013c.015.015.024.032.039.047l.016.013c.015.015.025.032.039.047s.011.008.016.013.024.032.04.047.011.008.016.013.024.032.039.047.011.008.016.013.024.032.039.047.011.008.016.013.025.032.04.047l.016.014c.015.014.024.032.04.046s.01.008.015.013.025.033.041.048.011.008.016.013.024.032.039.047l.016.013c.015.014.024.032.039.047l.016.013c.015.015.024.032.039.047l.016.013c.015.015.024.032.04.047s.011.008.016.013.025.032.039.047l.016.013c.015.015.024.032.039.047s.011.008.016.013.024.032.04.047.01.008.016.013.024.032.04.047a.172.172,0,0,0,.015.013c.015.015.025.032.04.047s.011.008.016.013.024.032.039.047a.18.18,0,0,0,.016.013c.015.015.024.032.039.047a.134.134,0,0,0,.016.013c.015.016.024.032.039.047l.016.012c.015.015.025.033.04.047a.182.182,0,0,0,.016.013c.015.015.024.032.039.047l.016.013c.015.015.024.032.039.047l.016.012c.015.015.025.033.039.047a.151.151,0,0,1,.016.013c.015.015.024.032.04.047s.01.008.016.013.024.032.04.047.011.008.016.013.024.032.039.047.011.008.016.013.025.032.039.047.011.008.016.013.024.032.039.047.011.008.016.013.024.033.04.048.011.008.016.013.024.032.039.047.011.008.015.013.025.032.04.047l.016.013c.015.014.024.032.039.047l.016.013c.015.015.024.032.04.047l.016.013c.015.015.024.032.039.047l.016.014c.015.014.024.032.039.046s.011.008.016.014.024.032.039.047.011.008.016.013.024.032.039.047l.016.013c.015.015.025.032.04.047a.142.142,0,0,0,.016.013c.015.016.024.033.04.048s.011.008.016.013.024.032.039.047a.18.18,0,0,0,.016.013c.015.015.024.032.039.047l.016.013c.015.016.025.032.04.047l.015.012c.015.015.024.033.04.047l.016.013c.015.015.024.032.039.047l.016.013c.015.015.025.032.039.047a8.78,8.78,0,0,0,11.056.84l-2.569-3.269a8.353,8.353,0,0,1-5.243,1.779",
    transform: "translate(-678.723 -291.871)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.392,100.8l.014.011c.016.015.026.033.042.049s.009.007.013.012.027.033.042.049l.013.01c.016.016.026.034.042.05s.009.006.013.011.026.034.042.049l.014.011c.016.016.026.034.042.049l.013.011c.016.016.027.034.042.049l.014.011c.016.016.026.034.042.049l.014.011c.016.016.026.034.042.049l.014.011c.015.016.026.034.042.049l.013.011c.016.016.027.034.042.049s.009.007.013.011.026.034.042.05l.012.009c.016.016.026.035.043.05a.089.089,0,0,0,.013.011c.016.016.026.034.042.049l.014.011c.016.016.026.034.042.049l.014.01c.016.016.026.034.042.049l.014.01c.016.016.026.034.042.049l.013.011c.016.016.026.034.042.049l.014.01c.016.015.026.034.042.049a.115.115,0,0,1,.014.011c.016.015.026.033.042.049l.013.01c.016.015.026.034.043.049s.009.007.013.011.027.033.042.049.009.006.014.011.026.033.042.049l.014.011c.016.015.026.033.042.049l.013.011c.016.016.027.034.042.049l.014.011c.016.016.026.034.042.05l.014.011c.016.016.026.034.042.049l.014.011c.015.016.026.034.042.049l.013.011c.016.016.026.034.042.05a.093.093,0,0,1,.014.011c.016.016.026.034.042.049s.009.006.013.011.026.034.042.049a.171.171,0,0,0,.014.011c.015.016.026.034.042.049l.013.011c.016.016.027.034.042.049l.014.011c.016.016.026.034.042.049l.014.011c.016.016.026.034.042.049l.013.011c.016.016.026.034.042.049l.013.01c.016.016.026.034.042.049a.14.14,0,0,0,.014.011c.016.016.026.034.042.049l.014.01c.016.016.026.034.042.049l.013.01c.016.016.027.034.042.049s.009.007.014.011.026.034.042.049l.014.01c.016.015.026.034.042.049l.014.011c.016.015.026.033.042.049l.013.01c.016.016.027.034.042.05l.013.01c.016.015.026.034.042.049l.014.011c.015.016.026.034.042.049l.013.011c.016.016.026.034.042.049l.013.011c.016.016.026.034.042.049s.009.007.013.011.026.034.042.05l.014.011c.015.016.026.034.042.049l.013.011c.016.016.027.034.042.049a8.355,8.355,0,0,0,6.031,2.413,8.488,8.488,0,0,0,4.644-1.29l-2.517-3.276a8.417,8.417,0,0,1-4.955,1.505,8.355,8.355,0,0,1-6.031-2.414.111.111,0,0,1,.014.011c.016.015.026.033.042.049",
    transform: "translate(-7.064 -68.845)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.641,250.935H.18l-.005.06h.06l0,.06h.06l-.005.06h.06l-.005.06H.4l-.005.06h.06l-.005.06h.06l-.005.059h.06l0,.06h.06l-.005.06h.06l-.005.06h.06l0,.06h.06l-.005.06h.06l-.005.06H.9l-.005.06h.06l-.005.06h.06l-.005.059h.06l0,.06h.06l-.005.06h.06l-.005.059h.06l0,.06h.06l0,.06h.06l-.005.06H1.4l-.005.06h.06l-.005.06h.06l-.005.06h.06l0,.06h.06l-.005.06h.06l-.005.06h.06l-.005.06h.06l0,.06h.06l-.005.06H1.9l-.005.06h.06l-.005.059h.06l-.005.06h.06l0,.06h.06l-.005.06h.06l-.005.06h.06l-.005.06h.06l0,.06h.06l-.005.06H2.4l-.005.06h.06l-.005.059h.06l-.005.06h.06l0,.06h.06l0,.059h.06l-.005.06h.06l-.005.06h.06l0,.06h.06l-.005.06H2.9l-.005.06h.06l-.005.06H21.469l-2.828-3.062Z",
    transform: "translate(-0.12 -171.482)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.3,368.079l.005.06h.05l.005.06h.05l.005.06h.05l.005.06h.05l.005.059h.051l0,.06h.051l.005.06h.05l.005.06h.051l0,.06h.051l.005.06h.05l.005.06h.05l.005.06h.05l.005.06h.05l.005.06h.051l0,.061h.051l.005.06h.05l.005.06h.051l0,.06h.051l.005.06h.05l.005.06h.05l.005.06h.05l.005.06h.05l.005.06h.051l0,.06h.051l.005.06h.05l.005.06h.051l0,.06h.051l0,.06h.051l.005.06h.05l.005.06h.05l.005.06h.05l.005.06h.051l0,.06h.051l.005.06h.05l0,.06h.05l.005.06h.051l0,.06h.051l.005.061h.05l.005.06h.05l.005.06h.05l.005.06h.051l0,.06h.051l.005.06h.05l.005.06h.05l.005.06h.051l0,.06h.051l.005.061h.05l.005.06h.05l.005.06h.05l.005.06h11.715l-2.828-3.061H994.249l0,.06Z",
    transform: "translate(-679.447 -251.496)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.563,45.258a7.655,7.655,0,0,1-1.379,4.7,5.113,5.113,0,0,1-4.395,1.85A5.927,5.927,0,0,1,93.4,50.168a6.794,6.794,0,0,1-1.637-5v-6.2L77.03,41.3v4.135a23.559,23.559,0,0,0,1.549,8.744,18.415,18.415,0,0,0,10.9,10.812,23.609,23.609,0,0,0,8.483,1.464,22.549,22.549,0,0,0,8.574-1.593,21.21,21.21,0,0,0,6.847-4.436,20.025,20.025,0,0,0,4.568-6.806,22.823,22.823,0,0,0,1.636-8.787V4.079H103.563Z",
    transform: "translate(-52.641 -2.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.8,42.243q0,4.566-2.154,6.893a8.038,8.038,0,0,1-6.2,2.326,8.183,8.183,0,0,1-6.247-2.326Q267,46.81,267,42.243V4.08H250.89V42.761a26.3,26.3,0,0,0,1.85,10.208,20.91,20.91,0,0,0,5.128,7.454,21.833,21.833,0,0,0,7.753,4.565,31.854,31.854,0,0,0,19.64,0,21.862,21.862,0,0,0,7.755-4.565,20.478,20.478,0,0,0,5.082-7.454,26.839,26.839,0,0,0,1.809-10.208V4.08H283.8Z",
    transform: "translate(-171.453 -2.788)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.818,65.159V19.327h17.659V4.079h-51.43V19.327h17.574V65.159Z",
    transform: "translate(-412.792 -2.788)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.2,187.316a22.551,22.551,0,0,1-8.574,1.593,23.607,23.607,0,0,1-8.483-1.464,18.837,18.837,0,0,1-6.581-4.169l.006.006.01.009.006.007.011.01.005.006.009.008.008.008.01.009.006.007.011.009.006.006.009.009.006.007.011.01s0,0,.006.006a.05.05,0,0,0,.01.008l.006.008.01.008a.025.025,0,0,1,.007.007l.01.009.007.007.01.01.006.006.01.009.006.007.011.009.005.007.01.009a.028.028,0,0,0,.007.007l.01.01.007.007.011.009.006.006.01.009.006.007a.081.081,0,0,1,.011.01l.006.007.009.008.007.007a.063.063,0,0,0,.011.01l.006.006.009.009.006.008.01.008.006.007.01.009.006.007.011.009.005.006.01.009.007.007.01.009.006.007.01.009.006.007.009.008.007.008.011.009a.022.022,0,0,0,.006.006l.01.009.007.007.011.009.006.007.01.008a.043.043,0,0,1,.006.007l.011.01.006.007.009.008.007.008.011.009.005.007.01.009.006.008.01.009.006.006.01.01.006.007a.048.048,0,0,1,.01.008l.006.007.011.009.006.007.009.008.007.008.011.009.006.006.01.009a.046.046,0,0,1,.006.007.06.06,0,0,1,.011.009l.006.006.009.008.007.007a.062.062,0,0,0,.011.01l.006.006.009.008.007.008.01.009.006.007.01.009.006.007.01.009.007.007a.076.076,0,0,1,.011.009l.006.006.009.009.007.007.01.009.006.008.01.008.006.008.011.009.006.007.009.009.007.007.011.01.006.006.01.008.006.008.011.01.006.006.01.008.007.007.009.009.007.007.011.009.006.006.01.009.007.008a.069.069,0,0,1,.01.01l.006.006.01.009.006.007.01.009.007.007a.039.039,0,0,0,.01.008l.006.008.011.009.006.006.01.009.006.007.011.01.006.006.01.009a.037.037,0,0,1,.006.006l.009.008.007.009.011.009.006.006.01.009.007.007.01.009.006.007.01.009.007.007.011.009.006.007.009.008.007.007a.09.09,0,0,0,.01.009l.006.007.01.008.006.008.011.009.006.006.01.01.006.006.009.009.007.008.01.01.006.006.009.008.008.009.01.009.006.006.009.009.007.007.011.009.006.006.01.009.007.007.01.009.006.007.009.008.007.007.011.01s0,0,.006.006a.1.1,0,0,1,.01.01l.006.006.01.008.007.007.01.01.006.007.01.008.006.008.01.009.006.006.009.008.007.008.011.009.006.007.01.009.007.007.01.01.006.006.011.01.005.006.01.008.006.008.01.008.006.007s.007.006.01.009l.007.007.01.01.006.006.01.009.007.007.01.01a.055.055,0,0,1,.006.007l.01.008.007.008.01.009.006.007.01.009.007.007.01.009.006.007.011.009.005.007.01.008.006.007a.1.1,0,0,0,.01.01l.006.006.01.009.006.008.009.008.007.007.01.009a.044.044,0,0,0,.007.007l.01.01.006.006.01.009.007.007.01.009.006.007.01.008.007.008.009.008.007.007.011.009.005.006.01.009.006.007.01.009.006.007.009.008.007.007a.063.063,0,0,0,.011.01l.005.006a.073.073,0,0,1,.009.009l.008.008.01.009.006.007.01.009.007.007.01.009.006.006.01.009.007.007.01.01.006.006.011.009.006.007.009.008.007.008.01.009.006.006.009.009.007.007.011.009.005.007.01.008.006.007.01.009.006.006a.06.06,0,0,0,.009.009l.007.008.01.009.006.006.01.009a.064.064,0,0,0,.006.007l.01.01.006.006.011.009.006.006.01.009.006.007.01.008.007.007.009.009.007.007.011.009.005.006.01.009.006.007.01.01.006.006.009.008.007.007a.076.076,0,0,0,.011.01l.005.006.009.009.008.008.01.009.006.006a.084.084,0,0,0,.011.01l.006.006.01.008.007.008.011.009a.037.037,0,0,0,.006.006.09.09,0,0,0,.009.009l.006.007.01.009.006.007.01.009.006.007.01.009.007.006a.087.087,0,0,0,.009.009l.007.007.011.01.005.006.01.008.006.007.01.009.006.007.011.01.006.006.009.009.007.007.011.01.006.006.01.008.006.008.011.009.006.007.01.009.006.007.01.009.007.007.009.009.006.007.011.009.005.007.01.009.006.007.01.01.006.006.01.009.006.006.009.008.007.008a.065.065,0,0,1,.011.009l.006.007.01.008.006.007a.066.066,0,0,0,.011.01l.006.006.009.008.007.008.011.009a.039.039,0,0,0,.006.007l.009.008.007.008.011.009.005.006.01.009.006.007.01.009.007.007.01.01.006.007.01.008.006.008.011.009.006.006.009.008.007.008.011.009.006.007.009.008.007.007.011.01.006.006.01.009.006.008.011.009.006.007.009.008.007.009.01.009.007.006a18.83,18.83,0,0,0,6.592,4.179,23.606,23.606,0,0,0,8.483,1.464,22.551,22.551,0,0,0,8.574-1.593c.338-.138.655-.3.982-.453l-3.219-3.216c-.351.163-.692.338-1.055.486",
    transform: "translate(-65.304 -125.247)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.821,7.295V7.279H188.8V7.263h-.017V7.248h-.016V7.232h-.017V7.216h-.016V7.2h-.017V7.184h-.016V7.168h-.016V7.153h-.016V7.137h-.016V7.12h-.017V7.105h-.017V7.089h-.016V7.074h-.016V7.057h-.017V7.042h-.016V7.026h-.017V7.01h-.016V6.994h-.017V6.978h-.016V6.962h-.016V6.947h-.017V6.931h-.017V6.915h-.016V6.9h-.016V6.883H188.4V6.868h-.016V6.852h-.017V6.836h-.016V6.82h-.017V6.8h-.016V6.789H188.3V6.772h-.016V6.757h-.016V6.741h-.016V6.725h-.016V6.709h-.017V6.693H188.2V6.677h-.016V6.662h-.016V6.646h-.017V6.63h-.016V6.614h-.017V6.6H188.1V6.583h-.017V6.567h-.016V6.55h-.016V6.535h-.017V6.519h-.016V6.5H188V6.487h-.016V6.472h-.017V6.456h-.016V6.44h-.017V6.424h-.016V6.408H187.9V6.392h-.016V6.377h-.016V6.361h-.017V6.345h-.016V6.329h-.016V6.313h-.016V6.3h-.017V6.282h-.016V6.266h-.016V6.25h-.016V6.234h-.017V6.219h-.016V6.2h-.017V6.186h-.016V6.171h-.017V6.155h-.016V6.139h-.016V6.123h-.017V6.108h-.016V6.091h-.016V6.076h-.016V6.06h-.017V6.044h-.016V6.028h-.016V6.013h-.016V6h-.017V5.981h-.016V5.965h-.016V5.949h-.016V5.933h-.017V5.918H187.4V5.9h-.016V5.886h-.017V5.87h-.016V5.855h-.017V5.838h-.016V5.823H187.3V5.807h-.016V5.791h-.017V5.775h-.016V5.759h-.017V5.743h-.016V5.727H187.2V5.712h-.017V5.7h-.016V5.68h-.016V5.664h-.016V5.649h-.017V5.633H187.1V5.616h-.016V5.6h-.016V5.585h-.017V5.569h-.016V5.553h-.016V5.538H187V5.521h-.017V5.506h-.016V5.49h-.016V5.474h-.017V5.458h-.016V5.443H186.9V5.427h-.016V5.411h-.017V5.4h-.016V5.379h-.016V5.363h-.017V5.348h-.017V5.331h-.016V5.316h-.016V5.3h-.017V5.284h-.016V5.268h-.016V5.253h-.016V5.237h-.017V5.221h-.016V5.2h-.016V5.189h-.016V5.173h-.017V5.157h-.016V5.142h-.016V5.126h-.016V5.11h-.017V5.094h-.016V5.078h-.016V5.063h-.017V5.047H186.5V5.031h-.017V5.015h-.016V5h-.017V4.984h-.016V4.968h-.016V4.952H186.4V4.936h-.017V4.92h-.016V4.9h-.016V4.889h-.016V4.873h-.016V4.857H186.3V4.841h-.016V4.826h-.017V4.809h-.016V4.793h-.017V4.778h-.016V4.762H186.2V4.746h-.016V4.73h-.016V4.714h-.017V4.7h-.017V4.683h-.016V4.667H186.1V4.651h-.017V4.635h-.016V4.619h-.017V4.6h-.016V4.587h-.017V4.572H186V4.556h-.016V4.54h-.017V4.524h-.017V4.508h-.016V4.493h-.016V4.477h-.016V4.461h-.016V4.445h-.017V4.429h-.016V4.414h-.017V4.4h-.016V4.382h-.017V4.366h-.016V4.35h-.017V4.334h-.016V4.319h-.016V4.3h-.017V4.287h-.017V4.271h-.016V4.255h-.016V4.239h-.016V4.223h-.016V4.208h-.017V4.192h-.016V4.176h-.017V4.16h-.016V4.144h-.016V4.128h-.017V44.862a22.812,22.812,0,0,1-1.637,8.787,20.019,20.019,0,0,1-4.567,6.806,21.052,21.052,0,0,1-5.792,3.95l3.219,3.216a21.071,21.071,0,0,0,5.865-3.983,20.022,20.022,0,0,0,4.567-6.806,22.812,22.812,0,0,0,1.637-8.787V7.295Z",
    transform: "translate(-118.6 -2.821)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.847,117.491l-.017,0v-.018l-.016,0v-.019l-.016,0v-.018l-.016,0v-.019l-.017,0v-.019l-.016,0V117.4l-.017,0v-.018l-.016,0v-.019l-.017,0v-.018l-.016,0v-.019l-.016,0v-.019l-.017,0V117.3l-.016,0v-.019l-.016,0v-.018l-.016,0v-.019l-.017,0v-.018l-.016,0v-.019l-.017,0v-.019l-.016,0v-.018l-.017,0v-.019l-.016,0v-.019l-.016,0v-.018l-.017,0v-.019l-.016,0v-.019l-.016,0V117.1l-.016,0v-.019l-.017,0v-.018l-.016,0v-.019l-.016,0v-.018l-.016,0v-.019l-.017,0V117l-.016,0v-.018l-.017,0v-.019l-.016,0v-.019l-.017,0v-.018l-.016,0v-.019l-.016,0V116.9l-.017,0v-.018l-.016,0v-.019l-.016,0v-.018l-.016,0v-.019l-.017,0v-.018l-.016,0v-.018l-.016,0v-.019l-.016,0v-.018l-.017,0v-.019l-.016,0v-.019l-.016,0v-.018l-.016,0v-.019l-.017,0V116.7l-.016,0v-.018l-.016,0v-.018l-.017,0v-.018l-.016,0v-.019l-.016,0v-.018l-.016,0V116.6l-.017,0v-.019l-.016,0v-.018l-.016,0v-.019l-.016,0v-.019l-.017,0v-.018l-.016,0v-.019l-.016,0v-.019l-.017,0v-.018l-.016,0v-.019l-.017,0v-.018l-.016,0v-.019l-.017,0v-.018l-.016,0V116.4l-.016,0v-.019l-.016,0v-.018l-.017,0v-.019l-.016,0v-.019l-.016,0v-.018l-.016,0V116.3l-.017,0v-.019l-.016,0v-.018l-.016,0v-.018l-.017,0v-.019l-.016,0v-.019l-.017,0v-.018l-.016,0v-.019l-.017,0v-.019l-.016,0v-.018l-.016,0v-.019l-.017,0v-.019l-.017,0v-.018l-.016,0V116.1l-.016,0v-.018l-.017,0v-.019l-.016,0v-.018l-.017,0v-.019l-.016,0v-.018l-.017,0V116l-.016,0v-.019l-.016,0v-.019l-.016,0v-.018l-.017,0v-.019l-.016,0v-.019l-.016,0v-.018l-.016,0v-.019l-.017,0v-.018l-.016,0v-.019l-.016,0v-.018l-.017,0v-.019l-.016,0v-.019l-.017,0V115.8l-.016,0v-.019l-.017,0v-.019l-.016,0v-.018l-.016,0v-.018l-.017,0v-.019l-.017,0V115.7l-.016,0v-.019l-.016,0v-.018l-.016,0v-.019l-.016,0v-.018l-.017,0v-.019l-.016,0v-.019l-.017,0v-.018l-.016,0v-.019l-.016,0v-.019l-.017,0v-.018l-.017,0v-.019l-.016,0v-.019l-.016,0V115.5l-.016,0v-.019l-.017,0v-.018l-.016,0v-.018l-.016,0v-.018l-.017,0v-.019l-.016,0V115.4l-.017,0v-.018l-.016,0v-.019l-.017,0v-.019l-.016,0v-.018l-.016,0v-.019l-.017,0v-.018l-.017,0v-.018l-.016,0v-.019l-.016,0v-.018l-.016,0v-.019l-.016,0v-.018l-.017,0v-.019l-.016,0V115.2l-.017,0v-.018l-.016,0v-.018l-.016,0v-.019l-.017,0v-.018l-.017,0v-.019l-.016,0V115.1l-.016,0v-.018l-.017,0v-.018l-.016,0v-.019l-.017,0v-.019l-.016,0v-.018l-.017,0v-.019l-.016,0v-.019l-.017,0v-.018l-.016,0v-.019l-.017,0v-.019l-.016,0v-.018l-.016,0v-.019l-.017,0v-.018l-.017,0v-.019l-.016,0v-.018l-.016,0v-.019l-.016,0v-.019l-.016,0v-.018l-.017,0V114.8l-.016,0v-.019l-.017,0v-.018l-.016,0v-.019l-.016,0v-.019l-.017,0v-.018l-.017,0V114.7l-.016,0v-.018l-.016,0v-.019l-.017,0v-.018l-.016,0v-.019l-.017,0v-.019l-.016,0v-.018l-.016,0v-.019l-.016,0v-.019l-.017,0v-.018l-.016,0v-.019l-.017,0v-.019l-.016,0v-.018l-.016,0V114.5l-.017,0v-.018l-.017,0v-.019l-.016,0v-.018l-.016,0v-.019l-.017,0v-.019l-.016,0V114.4l-.017,0v-.019l-.016,0v-.018l-.017,0v-.018l-.016,0v-.019l-.016,0v-.019l-.017,0v6.183a6.793,6.793,0,0,0,1.637,5,5.268,5.268,0,0,0,2.125,1.223,9.1,9.1,0,0,1-.47-3.037Z",
    transform: "translate(-84.435 -78.126)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.452,153.569a6.857,6.857,0,0,0,1.062.257,6.139,6.139,0,0,1-1.078-.321c.007.02.009.044.016.064",
    transform: "translate(-92.554 -104.902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.52,188.157a29.815,29.815,0,0,1-9.821-1.551,21.831,21.831,0,0,1-7.745-4.558l.009.009,0,0,.011.012.006,0,.01.011,0,0,.012.012.005.005.011.011.006,0,.011.012,0,0,.011.012.006.005.011.011,0,0,.012.012.005,0,.011.012.005,0,.011.012.006,0,.011.011,0,0,.012.011.006,0,.01.011.005,0,.012.012.005,0,.011.012.006,0,.011.011,0,0,.012.012.006,0,.011.012,0,0,.012.012.006.005.011.011,0,0,.011.012.005,0,.012.012,0,0,.012.012.006,0,.01.011.005,0,.011.011.006,0,.011.011.005.005.011.011,0,0,.012.013.006,0,.011.011,0,0,.011.012.006,0,.011.012,0,0,.012.012.006.005.011.011,0,0,.012.013.006,0,.01.011.005,0,.011.012.006,0,.011.011.005,0,.011.012,0,0,.012.011.006.005.011.011,0,0,.012.013.006,0,.011.011,0,0,.012.012.006,0,.011.011,0,0,.012.012.006.005.011.011,0,0,.012.013.006,0,.011.011.005,0,.011.011,0,0s.008.009.012.012l.006,0,.011.012.005,0a.1.1,0,0,0,.011.011l0,0,.012.011,0,0,.012.012.006,0,.011.011,0,0a.132.132,0,0,1,.011.012l.006,0,.011.011,0,0,.012.012.006.005.011.011,0,0,.012.012,0,0a.1.1,0,0,1,.011.011l.006,0,.011.011.005,0a.133.133,0,0,0,.011.012l.005,0,.011.012,0,0,.012.012.005,0,.011.011,0,0,.011.012.006,0,.011.011,0,0,.012.012.006,0,.011.011.005,0,.011.011,0,0,.011.013.006,0,.011.011.005,0,.012.012.005,0,.011.011,0,0s.008.008.012.011l.006,0,.011.012.005,0a.13.13,0,0,0,.011.012l0,0,.012.011,0,0,.012.012.006,0,.011.011.005.005.011.011.005,0,.011.012.006,0a.111.111,0,0,1,.01.011l0,0,.013.013.005,0,.011.011,0,0a.08.08,0,0,1,.011.012l.006,0,.011.011s0,0,.005,0,.007.008.012.011l.005,0,.011.012,0,0,.012.012.006.005.011.011.005,0,.011.011.005,0,.012.011.006.005.01.011.005,0,.012.012.005,0,.011.011,0,0,.011.013.006,0,.011.011.005,0,.012.012.005,0,.011.011.006.005.01.011.005,0,.011.012.005,0,.011.012.005,0,.012.012.006,0,.01.011.005,0,.012.011.005.005.011.011.005,0,.011.012,0,0,.012.012.005,0,.012.012.005,0,.011.011.006,0,.01.012.005,0,.011.012.006.005.011.011,0,0,.012.012,0,0,.012.012.005,0,.011.012.005,0,.011.012.005,0,.012.011.006.005.01.011.005,0,.012.012,0,0,.011.012.006,0,.01.011.005,0,.012.011.006,0,.011.012,0,0,.012.012.006.005.01.011,0,0,.012.013.005,0,.011.011.005,0,.012.012.006,0,.01.012.005,0,.011.011.005.005.011.011.006,0,.011.011,0,0,.012.013.006,0,.011.011,0,0,.011.011.006,0,.01.011.005,0,.011.012.006.005.011.011,0,0,.012.013.006,0s.006.008.01.011l.005,0,.011.012.005,0,.011.012.006,0,.011.011,0,0,.012.012.005,0a.079.079,0,0,0,.012.011l0,0,.011.012.006,0s.006.008.01.011l.005,0,.012.012.006,0,.011.011,0,0,.012.012.006.005s.006.008.01.011l0,0,.012.013.005,0,.011.011.006.005.011.011,0,0,.012.012.006,0,.011.011,0,0a.134.134,0,0,1,.011.012l.005,0,.011.011s0,0,.005,0l.012.011.006,0,.011.011,0,0,.011.012.006,0,.01.011.005,0,.012.011.005,0,.011.012.006,0,.011.012,0,0,.011.012.006.005.011.011,0,0a.135.135,0,0,1,.012.012l.006,0,.011.011,0,0,.012.012.005,0a.1.1,0,0,0,.011.011l0,0,.011.011.006,0,.01.011.005,0,.012.012.006,0,.011.012.005,0,.011.011,0,0,.012.012.006,0,.011.012,0,0,.012.012.006.005.011.011,0,0,.012.012.006,0,.011.011,0,0,.012.013.006,0,.01.011.005,0,.012.011.006,0,.011.011.005.005.011.011,0,0,.011.012.006,0,.011.011,0,0,.012.012.006,0,.011.012,0,0,.011.012.006.005.011.011,0,0a.14.14,0,0,1,.012.012l.006,0,.011.011,0,0,.012.013.006,0,.011.011a21.832,21.832,0,0,0,7.753,4.564,31.759,31.759,0,0,0,19.239.118l-3.209-3.207a29.944,29.944,0,0,1-9.5,1.458",
    transform: "translate(-186.531 -124.407)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.063,45.459V7.3h-.017V7.28h-.016V7.264h-.016V7.249H305V7.233h-.017V7.217h-.016V7.2h-.017V7.185h-.016V7.169h-.017V7.154H304.9V7.138h-.016V7.121h-.017V7.106h-.016V7.09h-.016V7.075h-.016V7.058H304.8V7.043h-.016V7.027h-.017V7.011h-.016V7h-.017V6.979h-.016V6.963H304.7V6.948h-.017V6.932h-.016V6.916h-.016V6.9h-.016V6.884h-.017V6.869H304.6V6.853h-.016V6.837h-.016V6.821h-.017V6.805h-.016V6.79h-.017V6.773h-.016V6.757h-.017V6.742h-.016V6.726h-.016V6.71h-.017V6.694h-.016V6.678h-.016V6.663h-.016V6.647h-.017V6.631h-.016V6.615h-.016V6.6h-.016V6.584h-.017V6.568h-.016V6.551h-.016V6.536h-.016V6.52h-.017V6.5h-.016V6.488h-.016V6.472h-.017V6.457h-.016V6.441h-.017V6.425h-.016V6.409h-.017V6.393h-.016V6.378H304.1V6.362h-.016V6.346h-.017V6.33h-.016V6.314h-.016V6.3h-.017V6.283H304V6.267h-.017V6.251h-.016V6.235h-.017V6.22h-.016V6.2h-.016V6.187H303.9V6.172h-.017V6.156h-.016V6.14h-.016V6.124h-.017V6.108h-.017V6.092H303.8V6.077h-.016V6.061h-.017V6.045h-.016V6.029h-.017V6.014h-.016V6H303.7V5.982h-.016V5.966h-.016V5.95h-.017V5.934h-.017V5.919h-.016V5.9h-.016V5.887h-.017V5.871h-.016V5.856h-.017V5.839h-.016V5.823h-.017V5.808h-.016V5.792h-.016V5.776h-.016V5.76h-.017V5.744h-.016V5.728h-.016V5.713h-.016V5.7h-.017V5.681h-.016V5.665h-.016V5.65h-.017V5.634h-.016V5.617h-.017V5.6h-.016V5.586h-.017V5.57h-.016V5.554h-.016V5.538h-.017V5.522h-.017V5.507H303.2V5.491h-.016V5.475h-.016V5.459h-.016V5.444h-.017V5.428h-.016V5.412H303.1V5.4h-.016V5.38h-.016V5.364h-.017V5.349h-.017V5.332h-.016V5.316H303V5.3h-.016V5.285h-.017V5.269h-.016V5.253h-.016V5.238h-.017V5.222H302.9V5.206h-.017V5.19h-.016V5.174h-.017V5.158h-.016V5.143h-.016V5.127H302.8V5.111h-.017V5.1h-.016V5.079h-.016V5.064h-.016V5.048h-.016V5.032H302.7V5.016h-.016V5h-.017V4.985h-.016V4.968h-.016V4.952h-.017V4.937h-.017V4.921h-.016V4.9h-.016V4.889h-.017V4.874h-.016V4.858h-.017V4.842h-.016V4.826h-.016V4.81h-.016V4.794h-.017V4.779h-.016V4.763h-.017V4.746h-.016V4.731h-.016V4.715h-.017V4.7h-.017V4.683h-.016V4.668h-.016V4.652h-.016V4.636H302.3V4.62h-.017V4.6h-.016V4.588h-.017V4.573h-.016V4.557h-.016V4.541H302.2V4.525h-.017V4.509h-.016V4.494h-.016V4.478h-.017V4.462h-.016V4.446H302.1V4.43h-.016V4.415h-.016V4.4h-.016V4.382h-.017V4.367h-.016V4.351H302V4.335h-.016V4.319h-.016V4.3h-.017V4.288h-.017V4.272h-.016V4.256H301.9V4.24h-.017V4.224h-.016V4.209h-.017V4.193h-.016V4.176h-.017V4.161H301.8V4.145h-.016V4.129h-.017V42.277q0,4.566,2.195,6.894a6.708,6.708,0,0,0,2.152,1.457,11.528,11.528,0,0,1-1.055-5.169",
    transform: "translate(-206.223 -2.822)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.319,151.615a8.4,8.4,0,0,1-1.818-.627c.006.012.008.026.013.037a8.788,8.788,0,0,0,1.806.59",
    transform: "translate(-215.606 -103.182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.68,7.295V7.279h-.016V7.263h-.017V7.248h-.016V7.232h-.017V7.216H376.6V7.2h-.017V7.184h-.016V7.168h-.016V7.153h-.016V7.137h-.016V7.12H376.5V7.105h-.017V7.089h-.016V7.074h-.016V7.057h-.017V7.042h-.016V7.026H376.4V7.01h-.016V6.994h-.017V6.978h-.016V6.962h-.016V6.947h-.017V6.931H376.3V6.915h-.016V6.9h-.016V6.883h-.017V6.868h-.016V6.852h-.017V6.836h-.016V6.82h-.017V6.8h-.016V6.789h-.017V6.772h-.016V6.757h-.016V6.741h-.016V6.725h-.016V6.709h-.017V6.693h-.017V6.677h-.016V6.662h-.016V6.646h-.017V6.63h-.016V6.614h-.017V6.6h-.016V6.583h-.017V6.567h-.016V6.55h-.016V6.535h-.017V6.519h-.016V6.5h-.016V6.487h-.016V6.472h-.017V6.456h-.016V6.44H375.8V6.424h-.016V6.408h-.017V6.392h-.016V6.377h-.016V6.361h-.017V6.345H375.7V6.329h-.016V6.313h-.016V6.3h-.017V6.282h-.016V6.266h-.017V6.25H375.6V6.234h-.017V6.219h-.016V6.2h-.017V6.186h-.016V6.171h-.017V6.155H375.5V6.139h-.016V6.123h-.017V6.108h-.016V6.091h-.016V6.076h-.016V6.06H375.4V6.044h-.016V6.028h-.016V6.013h-.016V6h-.017V5.981h-.016V5.965H375.3V5.949h-.016V5.933h-.017V5.918h-.016V5.9h-.016V5.886h-.017V5.87h-.016V5.855h-.017V5.838h-.016V5.823h-.017V5.807h-.016V5.791h-.017V5.775h-.016V5.759h-.017V5.743h-.016V5.727h-.016V5.712h-.017V5.7h-.016V5.68h-.016V5.664h-.016V5.649h-.017V5.633h-.016V5.616h-.016V5.6h-.016V5.585h-.017V5.569H374.9V5.553h-.016V5.538h-.016V5.521h-.017V5.506h-.016V5.49h-.016V5.474H374.8V5.458h-.016V5.443h-.017V5.427h-.016V5.411h-.017V5.4h-.016V5.379H374.7V5.363h-.017V5.348h-.017V5.331h-.016V5.316h-.016V5.3h-.017V5.284H374.6V5.268h-.016V5.253h-.016V5.237h-.017V5.221h-.016V5.2h-.016V5.189H374.5V5.173h-.017V5.157h-.016V5.142h-.016V5.126h-.016V5.11h-.017V5.094H374.4V5.078h-.016V5.063h-.017V5.047h-.016V5.031h-.017V5.015h-.016V5h-.017V4.984h-.016V4.968h-.016V4.952h-.017V4.936h-.017V4.92h-.016V4.9h-.016V4.889h-.016V4.873h-.016V4.857h-.017V4.841h-.016V4.826h-.017V4.809h-.016V4.793h-.017V4.778h-.016V4.762h-.017V4.746h-.016V4.73h-.016V4.714h-.017V4.7h-.017V4.683h-.016V4.667h-.016V4.651h-.017V4.635h-.016V4.619h-.017V4.6H373.9V4.587h-.017V4.572h-.016V4.556h-.016V4.54h-.017V4.524h-.017V4.508H373.8V4.493h-.016V4.477h-.016V4.461h-.016V4.445h-.017V4.429h-.016V4.414H373.7V4.4h-.016V4.382h-.017V4.366h-.016V4.35h-.017V4.334h-.016V4.319H373.6V4.3h-.017V4.287h-.017V4.271h-.016V4.255h-.016V4.239h-.016V4.223H373.5V4.208h-.017V4.192h-.016V4.176h-.017V4.16h-.016V4.144h-.016V4.128H373.4V42.793A26.843,26.843,0,0,1,371.6,53a20.48,20.48,0,0,1-5.082,7.454,21.866,21.866,0,0,1-7.755,4.565c-.1.036-.213.06-.318.094l3.21,3.207c.131-.043.27-.073.4-.118a21.871,21.871,0,0,0,7.756-4.564,20.488,20.488,0,0,0,5.082-7.454A26.845,26.845,0,0,0,376.7,45.976V7.295Z",
    transform: "translate(-244.95 -2.821)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.8,63.663a26.561,26.561,0,0,0,9.909-1.721,22.924,22.924,0,0,0,7.279-4.523,19.266,19.266,0,0,0,4.521-6.332,17.816,17.816,0,0,0,1.551-7.235,17.294,17.294,0,0,0-4.48-12.019Q474.1,26.88,465.23,25.154l-7.668-1.464a7.136,7.136,0,0,1-4.006-1.853,4.549,4.549,0,0,1-1.251-3.229,5.066,5.066,0,0,1,1.94-3.921,7.287,7.287,0,0,1,4.953-1.678,9.838,9.838,0,0,1,3.79.646,7.738,7.738,0,0,1,2.542,1.637A6.556,6.556,0,0,1,467,17.445a10.555,10.555,0,0,1,.646,2.2l14.473-2.671a20.5,20.5,0,0,0-1.9-5.946,17.993,17.993,0,0,0-4.178-5.47,21.1,21.1,0,0,0-6.847-4A28.262,28.262,0,0,0,459.284,0,25.5,25.5,0,0,0,450.5,1.508a23.567,23.567,0,0,0-7.236,4.135,19.422,19.422,0,0,0-4.909,6.288A17.734,17.734,0,0,0,436.54,19.9a16.935,16.935,0,0,0,4.48,11.975q4.481,4.825,12.665,6.374l7.58,1.467a7.621,7.621,0,0,1,4.223,1.937,4.717,4.717,0,0,1,1.379,3.4,4.937,4.937,0,0,1-1.9,3.921,7.781,7.781,0,0,1-5.169,1.593,12.106,12.106,0,0,1-4.436-.731,9.854,9.854,0,0,1-3.144-1.94,8.135,8.135,0,0,1-1.981-2.843,9.8,9.8,0,0,1-.775-3.358l-14.646,2.5a20.568,20.568,0,0,0,6.332,12.922,23.471,23.471,0,0,0,7.58,4.693A29.661,29.661,0,0,0,459.8,63.663",
    transform: "translate(-297.145 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.376,185.218a26.568,26.568,0,0,1-9.909,1.721,29.666,29.666,0,0,1-11.069-1.853,23.477,23.477,0,0,1-7.58-4.693l.007.006.009.009s0,0,.006.006l.01.01.007.007.009.01.006,0,.011.011.007.006.009.01.007.006.009.009.006.005.01.01.008.006.009.01.006.005.009.011.007.005.01.01.007.005.01.011.007.006.01.009.006.006.01.01.007.006.009.009.007.006.01.01.007.006.01.01.007.006.01.009.006.006.01.01.008.006.009.009.007.005.01.01.007.007.01.01.006.005.01.011.006.005.01.01.006.005.009.011.007.006.009.01.007.006.01.01.007.006s.006.007.01.009l.007.006.009.009.006,0,.01.011.008.007.009.009.007.006.01.01.007.006.01.01.006.005.01.01.008.007.009.01.005,0,.011.012.007.006.009.01.006.005.01.011.007.006.01.009.007.007.009.01.006.005.009.01.008.006.009.01.005,0,.011.011.007.007a.085.085,0,0,1,.01.009l.006.006.01.01.008.006.009.01.007.005.009.01.007.007.01.009.005,0,.011.011.007.006.01.01.007.006.009.009.007.006.009.01.008.007.009.009.006.005.01.01s0,0,.006.006l.01.01.006.006.009.01.008.006.009.009.007.006.01.01.007.006.01.01.006.005.01.01.008.006.009.009.006.005.009.01.007.006.009.01.008.006.009.009.006.006.01.01.007.007.009.009.006.005.009.01.007.006.01.01.006.006.01.01.007.006.01.009.006.006.01.01.008.007.009.009.007.006.009.01.006,0,.01.012.008.006.009.009.006.006.01.01.007.006.009.009.007.006.01.01.008.006.009.01.006.005.01.01s0,0,.006.006a.073.073,0,0,0,.01.01l.006.006.009.01.008.006.009.009.007.006.009.01.006.005a.115.115,0,0,1,.01.011l.007.006.009.01.006,0,.011.012.007.006.009.01.007.006.009.01.008.007.009.009.006.006.01.01.007.006.009.01.006,0,.01.011.008.007.009.009.007.006.009.01.006.005.01.01.007.006.009.01.006.005.01.011.007.006.009.009.006,0,.01.012.008.006.009.01.006.006.01.01.007.007.009.009.007.006.009.01s.005,0,.006.006l.01.01.006.005.01.01.006.006.01.01.007.007.009.01.007.005.01.01.007.006.009.01.006.005.01.011.006.005a.1.1,0,0,0,.01.01l.006.005.01.011.007.006.009.01.007.006.009.009.006.005.01.01.007.007.01.009.006.006.009.01.007.005.009.01.007.006.01.01.007.007.009.01.006.005.01.01.007.006.009.01.007.005.01.011.007.005.01.01a.043.043,0,0,1,.007.007l.009.009.006.006.01.01.007.006.01.01.006.005.009.01.007.007.009.01.006,0,.011.012.007.006.009.009.006.006.01.01.007.007.009.009.007.005.01.01.007.006.009.01.007.006.01.01.005,0,.011.011.007.007s.006.006.009.009,0,0,.007.006l.009.01.007.006.009.01.006.005.01.01.007.007.01.01.005,0,.011.012.007.006.009.009.006.006.01.01.007.006.009.009.007.006.01.009.006.005.01.011.007.005.01.01.007.006.009.01.007.007.009.009.006.006.01.01.007.006.009.01.007.005.01.01.007.006.009.009.006,0,.011.011a.045.045,0,0,1,.007.007l.009.009.007.006.009.01.007.005.009.011.008.006.009.009.006.005.01.011.006.005.01.01.006.006.01.01.007.006a.12.12,0,0,0,.009.009s0,0,.007.006l.01.01.007.006.009.01.006.005.01.01.006.006.01.01.007.006.009.01.007.005.009.01.008.006.009.01.006.005.01.011.007.006.01.01.006.005.009.011.007.005.01.01.006.006.01.01.007.006.009.009.006.006.01.01.007.007.01.009.007.006.009.009.006.005a.089.089,0,0,1,.01.011l.008.006.009.01.006.005.01.01.007.007.009.009.007.005.01.011.008.006.009.01.005,0,.011.011.007.006.009.01.006.006.01.01.007.006s.006.007.009.009l.007.006.009.01.006.006.01.01.008.007.009.009.005.005.011.011.007.006.009.01.007.005.01.01.008.007.009.009.006.005.01.011.007.006.01.01.005,0,.011.011.007.006.009.01a23.477,23.477,0,0,0,7.58,4.693,29.66,29.66,0,0,0,11.069,1.853,26.569,26.569,0,0,0,9.909-1.721c.5-.2.971-.426,1.445-.649l-3.219-3.215c-.5.235-.992.471-1.518.682",
    transform: "translate(-310.812 -123.277)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.976,139.833a10.9,10.9,0,0,1-1.314-.654,8.092,8.092,0,0,1-.519-.948,9.8,9.8,0,0,1-.774-3.358l-.014,0c0-.006,0-.012,0-.018l-.014,0a.154.154,0,0,1,0-.018l-.014,0a.145.145,0,0,0,0-.018l-.013,0a.175.175,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.164.164,0,0,0,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0a.152.152,0,0,0,0-.018l-.013,0c0-.006,0-.013,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.177.177,0,0,0,0-.019l-.013,0c0-.006,0-.012,0-.018l-.013,0a.151.151,0,0,1,0-.018l-.014,0a.139.139,0,0,0,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.013,0a.122.122,0,0,1,0-.018l-.014,0a.168.168,0,0,0,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.019l-.013,0c0-.006,0-.012,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0a.176.176,0,0,0,0-.018l-.014,0a.139.139,0,0,1,0-.018l-.014,0a.17.17,0,0,0,0-.018l-.013,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0a.172.172,0,0,0,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0a.162.162,0,0,1,0-.019l-.014,0c0-.006,0-.011,0-.018l-.014,0a.183.183,0,0,0,0-.019l-.013,0a.183.183,0,0,0,0-.018l-.013,0a.146.146,0,0,1,0-.018l-.014,0a.163.163,0,0,0,0-.018l-.014,0a.176.176,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.018l-.013,0c0-.006,0-.012,0-.018l-.014,0a.167.167,0,0,0,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.019l-.013,0c0-.006,0-.011,0-.018l-.014,0a.181.181,0,0,1,0-.018l-.014,0a.163.163,0,0,0,0-.018l-.014,0a.16.16,0,0,1,0-.018l-.014,0a.162.162,0,0,0,0-.018l-.013,0a.164.164,0,0,1,0-.018l-.014,0a.183.183,0,0,0,0-.019l-.014,0c0-.007,0-.012,0-.018l-.014,0c0-.006,0-.013,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0a.168.168,0,0,0,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0a.171.171,0,0,1,0-.019l-.014,0c0-.006,0-.011,0-.018l-.014,0a.175.175,0,0,1,0-.019l-.014,0a.179.179,0,0,0,0-.018l-.014,0a.179.179,0,0,1,0-.018l-.014,0a.153.153,0,0,0,0-.018l-.014,0a.171.171,0,0,1,0-.018l-.014,0a.181.181,0,0,0,0-.018l-.013,0c0-.007,0-.012,0-.018l-.014,0a.173.173,0,0,0,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0a.163.163,0,0,1,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.019l-.013,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.161.161,0,0,0,0-.018l-.014,0a.165.165,0,0,1,0-.018l-.014,0a.16.16,0,0,0,0-.018l-.013,0a.172.172,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.007,0-.012,0-.018l-.014,0c0-.007,0-.013,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.013,0a.138.138,0,0,1,0-.018l-.014,0a.178.178,0,0,0,0-.018l-.014,0a.163.163,0,0,1,0-.018l-.014,0a.144.144,0,0,0,0-.018l-.014,0a.174.174,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.019l-.013,0c0-.006,0-.012,0-.018l-.014,0a.155.155,0,0,0,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0a.157.157,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0a.156.156,0,0,0,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.153.153,0,0,1,0-.018l-.014,0a.1.1,0,0,0,0-.018l-.013,0a.166.166,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0a.178.178,0,0,1,0-.018l-.014,0a.18.18,0,0,0,0-.018l-.013,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.145.145,0,0,1,0-.018l-.014,0a.15.15,0,0,0,0-.018l-.014,0c0-.007,0-.013,0-.019l-.013,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0a.154.154,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.011,0-.018l-.014,0c0-.007,0-.012,0-.018l-.014,0a.173.173,0,0,0,0-.018l-.014,0a.167.167,0,0,1,0-.019l-.014,0a.153.153,0,0,0,0-.018l-.014,0c0-.007,0-.013,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0a.174.174,0,0,1,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0a.155.155,0,0,1,0-.018l-.014,0c0-.006,0-.011,0-.018l-.013,0c0-.007,0-.012,0-.018l-.014,0a.166.166,0,0,0,0-.018l-.014,0a.187.187,0,0,1,0-.019l-.014,0a.172.172,0,0,0,0-.018l-.014,0c0-.007,0-.013,0-.019l-.013,0c0-.007,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0a.163.163,0,0,1,0-.018l-.014,0c0-.007,0-.012,0-.018l-.013,0a.176.176,0,0,1,0-.018l-.014,0c0-.006,0-.011,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.179.179,0,0,0,0-.018l-.013,0c0-.006,0-.012,0-.019l-.014,0a.156.156,0,0,0,0-.018l-.014,0c0-.006,0-.013,0-.019l-.014,0a.183.183,0,0,0,0-.019l-.014,0c0-.006,0-.012,0-.018l-.013,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.011,0-.018l-.014,0c0-.007,0-.012,0-.018l-.014,0a.182.182,0,0,1,0-.018l-.014,0c0-.006,0-.011,0-.018l-.013,0c0-.006,0-.012,0-.018l-.014,0a.163.163,0,0,0,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0a.161.161,0,0,0,0-.018l-.014,0c0-.006,0-.013,0-.019l-.013,0a.181.181,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0a.144.144,0,0,1,0-.018l-.014,0a.109.109,0,0,0,0-.018l-.013,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.163.163,0,0,0,0-.018l-.013,0c0-.007,0-.012,0-.019l-.014,0a.161.161,0,0,0,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.013,0c0-.007,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.011,0-.018l-.014,0a.141.141,0,0,0,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.013,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0a.162.162,0,0,0,0-.018l-.013,0c0-.006,0-.012,0-.019l-.013,0a.161.161,0,0,1,0-.019l-.014,0c0-.006,0-.011,0-.018a9.8,9.8,0,0,0,.775,3.358,8.14,8.14,0,0,0,1.981,2.843,9.863,9.863,0,0,0,3.144,1.94",
    transform: "translate(-328.756 -89.995)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.273,43.37a7.742,7.742,0,0,0-2.542-1.637,9.839,9.839,0,0,0-3.79-.646,7.288,7.288,0,0,0-4.953,1.677,5.067,5.067,0,0,0-1.94,3.921c0,.064.014.122.016.185a4.526,4.526,0,0,0,1.235,3.045,5.685,5.685,0,0,0,2.26,1.37,4.9,4.9,0,0,1-.218-1.417,4.754,4.754,0,0,1,1.062-3,6.663,6.663,0,0,1,.879-.924,7.287,7.287,0,0,1,4.953-1.678,9.838,9.838,0,0,1,3.79.646c.2.082.353.188.536.279.054.111.131.215.178.329a6.561,6.561,0,0,0-1.464-2.154",
    transform: "translate(-334.887 -28.079)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.384,122.976a17.816,17.816,0,0,0,1.551-7.235,17.293,17.293,0,0,0-4.48-12.019l-.015-.013,0,0s-.009-.008-.014-.012l0,0-.015-.013,0,0c0-.005-.01-.009-.014-.013l0,0-.014-.013,0,0s-.01-.008-.014-.012l0,0a.173.173,0,0,0-.015-.013l0,0s-.009-.008-.013-.012l0,0s-.01-.008-.014-.013l0,0-.014-.013,0,0a.181.181,0,0,1-.014-.013l0,0s-.01-.008-.015-.013l0,0s-.01-.008-.014-.013l0,0-.014-.013,0,0s-.01-.008-.014-.012l0,0s-.01-.008-.014-.013l0,0a.172.172,0,0,0-.014-.013l0,0-.015-.013,0,0-.013-.012,0,0c0-.005-.01-.008-.014-.013l0,0-.013-.012,0,0a.16.16,0,0,1-.014-.013l0,0a.178.178,0,0,0-.015-.013l0,0s-.009-.008-.014-.012l0,0s-.01-.008-.014-.013l0,0a.132.132,0,0,1-.014-.013l0,0-.014-.012,0,0-.013-.013a.005.005,0,0,1,0,0l-.015-.013,0,0c0-.005-.01-.008-.014-.013l0,0-.014-.013,0,0s-.01-.008-.014-.012l0,0c0-.005-.01-.008-.015-.013l0,0s-.009-.008-.013-.012l0,0-.014-.012,0,0a.1.1,0,0,0-.014-.013l0,0-.014-.012,0,0s-.01-.008-.015-.013l0,0s-.01-.008-.014-.013l0,0-.013-.012,0,0-.014-.013,0,0-.014-.013,0,0a.172.172,0,0,0-.014-.013l0,0-.015-.013,0,0s-.009-.008-.014-.013l0,0-.014-.012,0,0-.014-.013,0,0-.014-.012,0,0c0-.005-.01-.008-.015-.013l0,0s-.01-.008-.014-.012l0,0s-.01-.008-.014-.013l0,0a.106.106,0,0,1-.014-.013.006.006,0,0,1,0,0l-.014-.012,0,0s-.01-.009-.013-.013l0,0-.015-.013,0,0c0-.005-.01-.008-.014-.013l0,0-.014-.012,0,0s-.01-.008-.014-.013l0,0-.013-.012,0,0-.015-.013,0,0-.014-.012,0,0a.132.132,0,0,0-.014-.013l0,0s-.01-.008-.014-.012l0,0-.015-.013,0,0-.013-.012,0,0-.015-.013,0,0s-.01-.008-.014-.013l0,0-.014-.012,0,0a.163.163,0,0,0-.014-.013l0,0-.014-.012,0,0s-.01-.008-.014-.013l0,0s-.01-.008-.014-.012l0,0-.014-.013,0,0a.119.119,0,0,1-.014-.012l0,0c0-.005-.01-.008-.015-.013l0,0s-.01-.008-.014-.012l0,0s-.01-.008-.014-.013l0,0-.014-.012,0,0-.014-.013,0,0s-.01-.008-.014-.013l0,0-.014-.012,0,0c0-.005-.01-.009-.014-.013l0,0-.014-.012,0,0s-.009-.008-.014-.012l0,0-.013-.013,0,0-.015-.013,0,0-.014-.012,0,0c0-.005-.01-.008-.014-.013l0,0-.014-.013,0,0-.014-.013s0,0,0,0l-.013-.012,0,0-.014-.013,0,0-.014-.013,0,0-.014-.012,0,0c0-.005-.01-.009-.014-.013l0,0-.014-.012,0,0s-.01-.008-.014-.012l0,0s-.01-.008-.014-.013l0,0a.164.164,0,0,0-.014-.013l0,0a.125.125,0,0,1-.014-.013l0,0a.1.1,0,0,1-.014-.013l0,0s-.01-.008-.014-.013l0,0-.013-.012,0,0s-.01-.009-.014-.013l0,0a.172.172,0,0,0-.014-.013l0,0s-.01-.008-.014-.013l0,0-.014-.012,0,0a.108.108,0,0,0-.014-.013l0,0-.014-.013,0,0-.013-.012,0,0c0-.005-.01-.008-.014-.013l0,0a.186.186,0,0,1-.014-.012l0,0s-.01-.008-.014-.013l0,0-.014-.013,0,0s-.01-.008-.014-.013l0,0s-.01-.008-.013-.012l0,0s-.01-.008-.014-.013l0,0c0-.005-.01-.009-.014-.013l0,0s-.01-.008-.014-.013l0,0a.19.19,0,0,1-.014-.013l0,0-.013-.013,0,0-.013-.012,0,0a.11.11,0,0,1-.014-.012l0,0c0-.005-.01-.008-.014-.013l0,0a.159.159,0,0,0-.014-.012l0,0a.133.133,0,0,1-.014-.013l0,0a.187.187,0,0,1-.014-.013l0,0s-.01-.008-.014-.013l0,0-.013-.012,0,0a.175.175,0,0,0-.014-.013l0,0c0-.005-.01-.009-.014-.013l0,0-.013-.012,0,0a.143.143,0,0,1-.015-.013l0,0-.014-.013,0,0s-.01-.008-.014-.012l0,0-.014-.012,0,0c0-.005-.01-.008-.014-.013l0,0a.183.183,0,0,1-.014-.012l0,0s-.01-.008-.014-.013l0,0s-.009-.008-.014-.013l0,0s-.009-.008-.014-.012l0,0a.186.186,0,0,1-.014-.013l0,0s-.01-.008-.014-.012l0,0c0-.005-.01-.008-.015-.013l0,0a.151.151,0,0,0-.014-.012l0,0a.136.136,0,0,1-.014-.013l0,0-.013-.013,0,0s-.01-.008-.014-.012l0,0a.175.175,0,0,1-.014-.012l0,0c0-.005-.01-.009-.014-.013l0,0s-.009-.008-.014-.012l0,0a.142.142,0,0,1-.014-.013l0,0-.015-.013,0,0-.014-.012,0,0-.015-.013,0,0s-.009-.008-.014-.012l0,0c0-.005-.01-.008-.014-.013l0,0a.142.142,0,0,0-.013-.012l0,0a.19.19,0,0,1-.015-.013l0,0-.014-.012,0,0s-.01-.008-.014-.013,0,0,0,0l-.013-.012,0,0c0-.005-.01-.009-.014-.013l0,0-.015-.013,0,0-.014-.013,0,0a.179.179,0,0,0-.014-.013l0,0s-.009-.008-.013-.012l0,0-.014-.013,0,0s-.01-.008-.014-.012l0,0c0-.005-.01-.008-.015-.013l0,0a.172.172,0,0,0-.014-.012l0,0a.188.188,0,0,1-.014-.013l0,0s-.009-.008-.013-.012l0,0a.139.139,0,0,1-.014-.013l0,0s-.01-.008-.015-.013l0,0s-.01-.008-.014-.013l0,0-.014-.013,0,0a.167.167,0,0,1-.013-.013l0,0s-.01-.008-.014-.012,0,0,0,0-.01-.008-.014-.013l0,0-.015-.013,0,0-.014-.012,0,0c0-.005-.01-.008-.014-.013s0,0,0,0l-.013-.012,0,0s-.01-.008-.015-.013l0,0s-.01-.008-.014-.013l0,0s-.01-.008-.014-.012l0,0s-.009-.008-.014-.013l0,0a.115.115,0,0,1-.013-.013.006.006,0,0,1,0,0l-.015-.013,0,0s-.01-.009-.014-.013l0,0-.014-.012,0,0c0-.005-.01-.008-.013-.013l0,0-.014-.013,0,0s-.01-.008-.014-.012l0,0c0-.005-.01-.008-.015-.013l0,0s-.01-.008-.014-.013l0,0-.013-.011,0,0a.11.11,0,0,0-.014-.013l0,0-.014-.012,0,0a.193.193,0,0,1-.015-.013,17.3,17.3,0,0,1,4.478,12.016,17.813,17.813,0,0,1-1.552,7.235,19.264,19.264,0,0,1-4.521,6.332,22.155,22.155,0,0,1-5.761,3.842l3.219,3.215a22.182,22.182,0,0,0,5.834-3.875,19.262,19.262,0,0,0,4.521-6.332",
    transform: "translate(-375.728 -68.708)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.072,137.276l-.054-.018a4.688,4.688,0,0,1,.247.769,5.313,5.313,0,0,0-.194-.751",
    transform: "translate(-365.62 -93.799)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.4,100.672l.014.013h0s-.01-.008-.014-.012",
    transform: "translate(-310.529 -68.797)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.9,110.478a7.617,7.617,0,0,0-4.222-1.937l-7.58-1.467a25.5,25.5,0,0,1-8.812-3.32,18.47,18.47,0,0,1-3.838-3.041l0,0,.013.012,0,0,.014.012,0,0,.013.012,0,0c0,.005.009.008.013.013l0,0a.128.128,0,0,1,.014.012l0,0,.014.011,0,0,.014.012,0,0s.009.007.013.012l0,0a.094.094,0,0,1,.013.012l0,0,.014.011,0,0s.01.008.014.012l0,0s.009.008.013.012l0,0,.014.012,0,0a.166.166,0,0,1,.013.012l0,0,.013.012,0,0s.01.008.014.012l0,0,.014.012,0,0,.014.012,0,0s.009.007.013.011l0,0,.013.012,0,0s.009.007.014.012l0,0,.014.012,0,0a.15.15,0,0,0,.013.011l0,0,.013.012,0,0,.013.012,0,0,.014.012,0,0c0,.005.009.008.014.013l0,0s.009.007.013.011l0,0,.014.012,0,0s.009.008.013.012l0,0,.014.012,0,0,.014.012,0,0,.014.012,0,0,.013.011,0,.005.013.012,0,0,.014.012,0,0s.01.008.014.012l0,0a.172.172,0,0,0,.014.012l0,0,.013.012,0,0,.014.013,0,0s.009.007.013.012l0,0s.01.008.014.012l0,0a.169.169,0,0,0,.014.012l0,0,.014.012,0,0a.142.142,0,0,1,.013.012l0,0a.174.174,0,0,1,.014.012l0,0,.013.011,0,.005.014.012,0,0a.172.172,0,0,0,.014.012l0,0s.009.008.013.012l0,0,.014.012,0,0,.014.011,0,0s.009.008.013.012l0,0,.014.012,0,0,.014.012,0,0,.013.012,0,0,.014.012,0,0,.014.012,0,0,.014.012,0,0s.009.007.013.011l0,0s.009.008.013.012l0,0,.014.012,0,0s.009.008.014.012l0,0a.164.164,0,0,0,.014.012l0,0,.013.011,0,0,.013.012,0,0,.013.012,0,0a.17.17,0,0,1,.014.012l0,0a.173.173,0,0,0,.014.012l0,0,.014.012,0,0,.013.012,0,0a.114.114,0,0,1,.013.012l0,0,.014.012a.006.006,0,0,0,0,0,.177.177,0,0,0,.014.012l0,0a.128.128,0,0,0,.014.012l0,0,.013.012,0,0,.014.012,0,0,.014.011,0,0,.013.012,0,0a.126.126,0,0,0,.014.012l0,0,.014.012,0,0,.014.012,0,0s.01.007.014.011l0,0,.014.012,0,0,.013.012,0,0,.013.012,0,0s.01.008.013.012l0,0,.014.012,0,0a.173.173,0,0,0,.014.012l0,0,.014.012,0,0s.009.007.013.011l0,0c0,.005.009.008.014.013l0,0s.009.008.014.012l0,0a.127.127,0,0,1,.014.012l0,0s.01.008.014.012l0,0s.01.007.013.011l0,0,.013.011,0,0s.009.007.013.012l0,0,.014.012,0,0s.009.008.014.012l0,0,.013.012,0,0c0,.005.009.008.013.013l0,0,.014.012,0,0a.147.147,0,0,1,.013.012l0,0,.014.012,0,0s.01.008.013.012l0,0s.009.007.013.012l0,0,.014.012,0,0s.01.007.014.011l0,0,.013.011,0,0a.079.079,0,0,0,.014.012l0,0,.013.012,0,0a.131.131,0,0,1,.014.012l0,0,.014.011,0,0c0,.005.01.008.014.013l0,0s.009.008.013.012l0,0,.013.012,0,0s.01.008.014.012l0,0s.009.008.014.012l0,0a.153.153,0,0,1,.014.012l0,0,.014.012,0,0s.009.007.013.012l0,0s.009.007.013.011l0,0a.176.176,0,0,1,.014.012l0,0,.014.012,0,0,.014.012,0,0,.013.012,0,0c0,.005.01.008.013.013l0,0s.009.007.013.012l0,0,.014.012,0,0s.009.008.014.012l0,0s.009.008.013.012l0,0s.01.007.013.011l0,0,.014.012,0,0,.014.012,0,0s.009.007.013.012l0,0s.01.008.013.012l0,0s.009.008.013.012l0,0a.163.163,0,0,1,.014.012l0,0,.014.012,0,0c0,.005.009.008.014.013l0,0s.009.007.013.011l0,0s.01.008.013.012l0,0,.014.012,0,0,.014.012,0,0,.014.011,0,0a.082.082,0,0,0,.014.012l0,0a.164.164,0,0,0,.013.012l0,0s.009.008.013.012l0,0s.01.008.014.012l0,0s.01.008.014.012l0,0s.009.008.014.012l0,0,.013.012,0,0a.13.13,0,0,1,.014.013l0,0s.009.007.013.011l0,0s.009.008.014.012l0,0,.014.012,0,0s.009.007.013.012a.011.011,0,0,0,0,0l.014.011,0,0,.013.011,0,0s.01.007.014.012l0,0,.014.012,0,0s.009.008.013.012l0,0,.013.012,0,0a.177.177,0,0,1,.014.012l0,0,.014.012,0,0,.013.012,0,0,.013.012,0,0,.013.011,0,0,.014.012,0,0s.009.007.013.012l0,0,.014.012,0,0a.116.116,0,0,0,.013.011l0,0s.009.007.013.011l0,0,.013.012,0,0a.164.164,0,0,1,.014.012l0,0,.014.012,0,0s.009.008.013.012l0,0a.163.163,0,0,0,.013.012l0,0,.013.012,0,0,.014.012,0,0,.013.011,0,0,.014.012,0,0a.169.169,0,0,0,.013.012l0,0,.014.012,0,0s.009.007.013.011l0,0s.01.008.014.012l0,0,.014.012,0,0,.013.012,0,0c0,.005.009.008.014.013l0,0s.01.008.014.012l0,0,.014.012,0,0a.112.112,0,0,0,.013.012l0,0a.164.164,0,0,1,.013.012l0,0,.013.011,0,0,.014.012,0,0s.009.007.013.012l0,0,.014.012,0,0a.153.153,0,0,1,.013.012l0,0s.01.008.013.012l0,0a18.384,18.384,0,0,0,3.576,2.884,25.257,25.257,0,0,0,9.089,3.489l7.58,1.467a10.72,10.72,0,0,1,1.988.562,4.684,4.684,0,0,0-1.058-1.806",
    transform: "translate(-310.56 -68.825)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.111,55.432l-4.591.847a.123.123,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.019l.012,0a.158.158,0,0,1,0,.018l.013,0a.143.143,0,0,0,0,.019l.012,0a.146.146,0,0,0,0,.018l.012,0a.177.177,0,0,1,0,.018l.012,0c0,.006,0,.013,0,.018l.013,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.019l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.018l.012,0c0,.006,0,.012,0,.018l.013,0a.128.128,0,0,0,0,.018l.012,0a.137.137,0,0,0,0,.018l.012,0a.159.159,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0a.153.153,0,0,1,0,.019l.012,0c0,.006,0,.012,0,.018l.013,0c0,.006,0,.013,0,.019l.012,0c0,.006,0,.012,0,.018l.012,0a.182.182,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.013,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.019l.012,0a.176.176,0,0,0,0,.018l.012,0c0,.006,0,.013,0,.018l.012,0a.112.112,0,0,1,0,.018l.013,0a.171.171,0,0,0,0,.018l.012,0a.143.143,0,0,0,0,.018l.012,0,0,.018.012,0c0,.006,0,.011,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.011,0a.144.144,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.013,0a.132.132,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.007,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.019l.013,0a.168.168,0,0,0,0,.018l.012,0a.159.159,0,0,0,0,.018l.012,0c0,.006,0,.013,0,.018l.012,0a.157.157,0,0,1,0,.018l.013,0c0,.006,0,.012,0,.018l.012,0a.151.151,0,0,0,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.019l.012,0c0,.006,0,.012,0,.018l.012,0a.146.146,0,0,0,0,.019l.011,0a.159.159,0,0,1,0,.018l.012,0a.173.173,0,0,1,0,.018l.013,0a.123.123,0,0,0,0,.018l.012,0a.177.177,0,0,0,0,.018l.012,0a.158.158,0,0,1,0,.018l.012,0c0,.006,0,.013,0,.018l.012,0,0,.018.012,0c0,.005,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.019l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.019l.013,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.007,0,.013,0,.018l.012,0c0,.006,0,.012,0,.018l.013,0c0,.006,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0a.171.171,0,0,0,0,.018l.012,0a.166.166,0,0,0,0,.019l.011,0c0,.006,0,.012,0,.018l.012,0a.171.171,0,0,1,0,.018l.013,0a.133.133,0,0,0,0,.018l.012,0a.158.158,0,0,0,0,.018l.012,0a.184.184,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.005,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0a.192.192,0,0,1,0,.019l.011,0c0,.006,0,.012,0,.018l.012,0c0,.007,0,.013,0,.018l.013,0a.172.172,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.011,0a.168.168,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0a.158.158,0,0,1,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0a.127.127,0,0,0,0,.018l.011,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.013,0a.157.157,0,0,0,0,.018l.012,0a.171.171,0,0,0,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.005,0,.011,0,.018l.012,0,0,.018.012,0c0,.006,0,.013,0,.019l.012,0a.178.178,0,0,0,0,.018l.011,0c0,.006,0,.012,0,.018l.012,0c0,.007,0,.013,0,.018l.013,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.011,0a.184.184,0,0,1,0,.018l.012,0a.171.171,0,0,1,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.019l.012,0,0,.018.012,0c0,.007,0,.013,0,.019l.012,0c0,.006,0,.012,0,.018l.013,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.018l.011,0a.181.181,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.013,0a.156.156,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.019l.012,0,0,.018.012,0c0,.007,0,.013,0,.019l.012,0a.141.141,0,0,0,0,.018l.011,0a.162.162,0,0,1,0,.018l.012,0c0,.006,0,.013,0,.018l.013,0c0,.006,0,.012,0,.018l.012,0a.172.172,0,0,0,0,.018l.011,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.019l.012,0,0,.018.012,0c0,.006,0,.013,0,.018l.012,0c0,.006,0,.012,0,.018l.013,0c0,.006,0,.012,0,.018l.012,0a.119.119,0,0,0,0,.018l.011,0a.146.146,0,0,1,0,.018l.012,0a.171.171,0,0,1,0,.018l.013,0a.157.157,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0a.167.167,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.019l.012,0,0,.018.012,0c0,.006,0,.013,0,.019l.012,0a.173.173,0,0,0,0,.018l14.365-2.651-3.2-3.2Z",
    transform: "translate(-368.012 -36.639)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.056,30.784a21.133,21.133,0,0,0-1.578-4.585,18,18,0,0,0-4.179-5.47l0,0-.014-.013h0l-.016-.016,0,0a.151.151,0,0,0-.014-.014h0l-.015-.015,0,0-.014-.014h0l-.015-.014,0,0-.014-.014h0l-.016-.016,0,0-.014-.014h0l-.015-.015,0,0-.014-.014,0,0-.014-.014h0l-.016-.015,0,0-.013-.014h0l-.015-.015,0,0c-.005,0-.009-.01-.014-.014h0l-.015-.015,0,0L568,20.443h0l-.015-.014,0,0-.014-.013h0l-.016-.016,0,0-.014-.014,0,0c-.005,0-.009-.009-.014-.014h0l-.015-.015,0,0-.013-.014h0c-.005,0-.009-.01-.014-.015h0l-.015-.014h0l-.015-.015,0,0a.168.168,0,0,0-.014-.013h0l-.015-.015,0,0-.014-.014h0l-.015-.014,0,0-.014-.013h0l-.015-.015h0l-.015-.014,0,0-.013-.014h0a.2.2,0,0,1-.014-.015s0,0,0,0l-.014-.013h0l-.016-.015h0l-.015-.014h0l-.015-.015,0,0-.014-.013h0l-.015-.015,0,0-.014-.014,0,0-.013-.014h0L567.545,20l0,0-.014-.014h0l-.014-.014,0,0c-.005,0-.009-.009-.014-.014h0l-.015-.015,0,0-.013-.013h0l-.014-.015h0l-.015-.014h0l-.015-.015,0,0c-.005,0-.009-.009-.014-.013l0,0-.013-.013h0l-.015-.015,0,0-.014-.014h0l-.015-.016,0,0-.014-.014h0l-.015-.014,0,0-.014-.014h0l-.014-.015,0,0-.014-.013h0l-.016-.015,0,0-.014-.014,0,0-.014-.014h0l-.015-.014,0,0-.014-.013h0l-.015-.015,0,0-.013-.014h0l-.016-.016,0,0-.014-.014h0l-.014-.014,0,0-.014-.014h0l-.015-.015,0,0-.013-.014h0l-.014-.014h0L567,19.478l0,0-.014-.014h0l-.015-.014,0,0-.013-.014h0l-.015-.015h0l-.015-.014h0a.2.2,0,0,0-.014-.015l0,0-.014-.014h0l-.015-.014,0,0-.014-.013,0,0-.014-.014h0l-.015-.015h0l-.015-.014,0,0-.015-.015,0,0-.014-.014h0l-.015-.014,0,0-.014-.014h0l-.015-.015,0,0-.015-.014h0l-.016-.015,0,0-.014-.014,0,0-.014-.014h0l-.015-.015,0,0-.014-.014h0l-.016-.016,0,0-.014-.014h0l-.015-.015s0,0,0,0l-.014-.014h0l-.015-.014,0,0-.013-.014,0,0a.145.145,0,0,1-.014-.014h0l-.016-.015,0,0-.014-.014h0l-.015-.015,0,0-.014-.014h0l-.015-.015,0,0-.014-.013h0c-.005-.005-.009-.01-.016-.016l0,0-.013-.014h0l-.015-.015,0,0-.014-.014,0,0-.014-.014h0l-.015-.015h0L566.3,18.8h0l-.015-.014,0,0c-.005,0-.009-.009-.014-.013h0l-.015-.015,0,0-.014-.014h0l-.015-.015,0,0L566.2,18.7h0l-.016-.016,0,0a.148.148,0,0,0-.014-.014l0,0-.014-.014h0l-.015-.015,0,0-.014-.013h0l-.015-.015h0l-.015-.015h0l-.015-.014,0,0-.014-.013h0l-.015-.015,0,0-.014-.014h0l-.015-.015h0l-.014-.014,0,0-.014-.014h0l-.015-.014,0,0-.014-.014h0l-.015-.015,0,0-.014-.013h0l-.015-.015h0c-.005,0-.009-.01-.014-.015h0l-.015-.014,0,0c-.005,0-.009-.009-.014-.013v0l-.015-.015,0,0-.014-.014,0,0c-.005,0-.009-.01-.014-.014h0a.179.179,0,0,1-.016-.015l0,0-.014-.014h0l-.015-.014,0,0-.014-.014h0l-.015-.015,0,0-.014-.013h0l-.016-.015,0,0-.014-.014h0l-.015-.014,0,0-.013-.014,0,0-.014-.013h0l-.016-.015,0,0a.14.14,0,0,0-.014-.014h0l-.016-.015,0,0-.014-.014h0l-.015-.014,0,0-.014-.014h0l-.015-.015,0,0-.014-.014h0l-.016-.015,0,0-.013-.014,0,0-.014-.014h0l-.016-.015,0,0-.014-.013,0,0c-.005,0-.009-.01-.014-.015h0l-.015-.014h0l-.015-.015,0,0-.014-.014h0l-.015-.014,0,0-.014-.013h0l-.015-.015,0,0-.014-.014h0l-.015-.015h0l-.016-.015,0,0-.014-.014h0l-.014-.015,0,0-.014-.014h0l-.016-.015h0l-.015-.014h0l-.015-.015,0,0-.014-.014h0l-.015-.014,0,0-.014-.013,0,0-.014-.014h0l-.016-.016,0,0-.013-.014h0l-.014-.015s0,0,0,0l-.014-.013a17.991,17.991,0,0,1,4.179,5.47,20.494,20.494,0,0,1,1.9,5.946l-.018,0,3.2,3.2.109-.02c-.066-.45-.216-.908-.318-1.361",
    transform: "translate(-386.113 -11.991)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.1,52.253h.016v.016h.016v.016h.016V52.3h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.016V52.4h.017v.016h.017v.016h.016v.016h.016v.016h.017v.016h.016v.016h.017v.015h.016v.016h.016v.016h.016v.016h.017v.016h.016v.016h.017V52.6h.016v.016h.016v.016h.017v.016h.017v.016h.016v.016h.016V52.7h.017v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.016v.015h.017v.016h.017v.016h.016v.016h.016v.015h.017v.016h.016V52.9h.017v.016h.016v.016h.016v.016h.016v.016h.017v.016h.016V53h.017v.015h.016v.016h.016v.016h.017v.016h.017v.015h.016v.016h.016v.016H605v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016V53.2h.016v.016h.017v.015h.017v.016h.016v.016h.016v.016h.017V53.3h.016v.016h.017v.016h.016v.016h.016v.016h.016v.015h.016v.016h.017v.016h.017v.016h.016v.015h.016v.016h.017v.016h.017v.016h.016V53.5h.016v.016h.017v.016h.016v.016h.017v.016h.016v.015h.016V53.6h.016v.016h.016v.016h.017v.016h.017v.016h.016v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.016v.016h.017v.016h.017v.016h.016v.016h.016v.016h.017v.016h.016V53.9h.017v.016h.016v.016h.017v.015h.016v.016h.017v.016h.016V54h.016v.016h.016v.016h.016v.016h.017v.016h.017v.016H606v.016h.016v.016h.017v.016h.016v.016h.017v.015h.016v.016h.017v.016h.016V54.2h.016v.016h.017v.016h.017v.016h.016v.016h.016v.016h.017V54.3h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.016v.016h.016v.016h.016v.016h.017v.016h.017v.016h.016V54.5h.016v.015h.017v.016h.016v.016h.017v.016h.016v.016h.017V54.6h.016v.016h.016v.016h.017v.016h.016v.016h.016v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.016V54.8h.016v.016h.017v.016h.016v.016h.016v.016h.017v.015h.016V54.9h.017v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.016v.016H607v.016h.016v.016h.016v.015h.016V55.1h.017v.016h.016v.016h.016v.016h.016v.016h.017v.016h.016V55.2h.016v.016h.016v.016h.017v.016h.016v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016V55.4h.017v.016h14.282V52.237H604.1Z",
    transform: "translate(-412.828 -35.698)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.6,196.988V197h.016v.016h.016v.016h.016v.016h.016v.016h.017v.016h.016v.015h.017v.016h.016v.016h.016v.016h.017v.016h.017v.015h.016v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016H660v.015h.017v.016h.017v.016h.016v.016h.016v.016h.016v.015h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.016v.016h.017v.016h.017v.016h.016v.016h.016v.016h.017v.016h.016v.016h.017v.015h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.016v.016h.017v.016h.017v.015h.016v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.015h.016v.016h.017v.016h.017V198h.016v.016h.016v.015h.017v.016h.016v.016h.017v.016h.016v.016h.016v.016h.016v.016h.016v.016h.017v.016h.017v.016h.016v.016h.016v.016h.017v.016h.017v.016h.016v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016H661v.016h.016v.016h.016v.016h.017v.015h.017v.016h.016v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.016v.016h.016v.015h.016v.016h.017v.016h.017v.016h.016v.015h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.015h.016v.016h.016v.016h.016v.016h.017v.016h.017v.016h.016v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.016v.016h.016v.016h.016v.015h.017v.016h.017V199h.016v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.017v.015h.016v.016h.017v.016h.016v.016h.016v.015h.016v.016h.016v.016h.017v.016h.017v.016h.016v.016h.016v.016h.017v.016h.016v.016H662v.015h.016v.016h.017v.016h.016v.016h.016v.016h.017v.016h.016v.016h.016v.016h.016v.016h.017v.016h.016v.015h.016v.016h.016v.016h.017v.016h.016v.016h.016v.016h.017v.016h.016v.016h.016v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.015h.017v.016h.016v.016h.017v.016h.016v.016h.017v.015h.016v.016h.016v.016h.017v.016h.016v.016h.016v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.016v.015h.016v.016h.017V200h.016v.016h.016v.016h.017v.015h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.017v.016h16.2l-3.292-3.182Z",
    transform: "translate(-450.758 -134.617)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.756,7.3V7.28h-.016V7.263h-.017V7.248h-.016V7.232h-.017V7.216h-.016V7.2h-.017V7.185h-.016V7.168h-.016V7.153h-.016V7.137h-.016V7.121h-.017V7.105h-.017V7.089h-.016V7.074h-.016V7.058h-.017V7.042h-.016V7.026h-.017V7.01h-.016V6.995h-.017V6.978h-.016V6.963h-.016V6.947H769.4V6.931h-.017V6.915h-.016V6.9h-.016V6.883h-.017V6.868h-.016V6.852H769.3V6.836h-.016V6.82h-.017V6.8h-.016V6.789h-.017V6.773h-.016V6.757H769.2V6.741h-.016V6.725h-.016V6.709h-.017V6.693h-.017V6.678h-.016V6.662H769.1V6.646h-.017V6.63h-.016V6.615h-.017V6.6h-.016V6.583h-.017V6.567H769V6.551h-.016V6.535h-.017V6.519h-.017V6.5h-.016V6.488h-.016V6.472H768.9V6.456h-.016V6.44h-.017V6.425h-.016V6.408h-.017V6.393h-.016V6.377h-.016V6.361h-.017V6.345h-.016V6.33h-.016V6.314h-.016V6.3h-.017V6.282h-.016V6.266h-.016V6.25h-.016V6.234h-.017V6.219h-.016V6.2h-.017V6.187h-.016V6.171h-.017V6.155h-.016V6.139h-.016V6.124h-.017V6.108h-.016V6.092h-.016V6.076H768.5V6.061h-.017V6.044h-.016V6.029h-.016V6.013h-.016V6h-.017V5.981H768.4V5.966h-.016V5.949h-.016V5.933h-.017V5.918h-.016V5.9h-.016V5.886H768.3V5.87h-.016V5.855h-.017V5.839h-.016V5.823h-.017V5.807h-.016V5.791H768.2V5.775h-.016V5.759h-.017V5.744h-.016V5.727h-.016V5.712h-.017V5.7H768.1V5.681h-.016V5.664h-.016V5.649h-.017V5.633h-.016V5.617h-.016V5.6H768V5.585h-.017V5.569h-.016V5.554h-.016V5.538h-.017V5.522h-.017V5.506h-.016V5.49h-.016V5.474h-.017V5.459h-.016V5.443h-.017V5.427h-.016V5.411h-.017V5.4h-.016V5.379h-.016V5.363h-.017V5.348h-.017V5.332h-.016V5.316h-.016V5.3h-.017V5.284h-.016V5.269h-.016V5.253h-.016V5.237h-.017V5.221h-.016V5.205h-.017V5.189h-.016V5.174h-.017V5.158h-.016V5.142h-.016V5.126h-.016V5.11H767.5V5.095h-.016V5.078h-.016V5.063h-.017V5.047h-.016V5.032h-.017V5.015H767.4V5h-.017V4.984h-.016V4.968h-.016V4.952h-.017V4.936h-.017V4.92H767.3V4.9h-.016V4.889h-.016V4.873h-.016V4.857h-.017V4.841h-.016V4.826H767.2V4.81h-.016V4.793h-.017V4.778h-.016V4.762h-.017V4.746h-.016V4.73H767.1V4.714h-.017V4.7h-.017V4.683h-.016V4.667h-.016V4.651h-.017V4.635h-.016V4.62h-.017V4.6h-.016V4.588h-.017V4.572h-.016V4.556h-.016V4.54h-.017V4.525h-.017V4.508h-.016V4.493h-.016V4.477h-.016V4.462h-.016V4.445h-.017V4.429h-.016V4.414h-.017V4.4h-.016V4.382h-.017V4.366h-.016V4.35h-.017V4.334h-.016V4.319h-.016V4.3h-.017V4.287h-.017V4.271h-.016V4.255h-.016V4.24H766.6V4.223h-.016V4.208h-.017V4.192h-.016V4.176h-.017V4.16h-.016V4.144H766.5V4.128h-.017V19.361l3.292,3.182V7.3Z",
    transform: "translate(-523.796 -2.821)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.708,98.069,714,101.251V55.42l-3.292-3.182Z",
    transform: "translate(-485.682 -35.698)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.367,52.238H710.708L714,55.42h17.659Z",
    transform: "translate(-485.681 -35.698)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.236,4.218,1002.785,65.3h16.37l3.7-11.543h20.935L1047.5,65.3h17.229L1043.362,4.218Zm2.843,36.355,6.374-19.643,6.2,19.643Z",
    transform: "translate(-685.28 -2.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.7,63.663a26.561,26.561,0,0,0,9.909-1.721,22.924,22.924,0,0,0,7.279-4.523,19.267,19.267,0,0,0,4.521-6.332,17.817,17.817,0,0,0,1.551-7.235,17.294,17.294,0,0,0-4.48-12.019Q881,26.88,872.127,25.154l-7.668-1.464a7.136,7.136,0,0,1-4.006-1.853,4.549,4.549,0,0,1-1.251-3.229,5.066,5.066,0,0,1,1.94-3.921,7.287,7.287,0,0,1,4.953-1.678,9.839,9.839,0,0,1,3.79.646,7.738,7.738,0,0,1,2.542,1.637,6.556,6.556,0,0,1,1.464,2.153,10.553,10.553,0,0,1,.646,2.2l14.474-2.671a20.508,20.508,0,0,0-1.9-5.946,17.992,17.992,0,0,0-4.178-5.47,21.1,21.1,0,0,0-6.847-4A28.262,28.262,0,0,0,866.181,0a25.5,25.5,0,0,0-8.787,1.508,23.569,23.569,0,0,0-7.235,4.135,19.422,19.422,0,0,0-4.909,6.288,17.737,17.737,0,0,0-1.811,7.969,16.935,16.935,0,0,0,4.48,11.975q4.481,4.825,12.665,6.374l7.58,1.467a7.621,7.621,0,0,1,4.222,1.937,4.717,4.717,0,0,1,1.379,3.4,4.937,4.937,0,0,1-1.9,3.921,7.781,7.781,0,0,1-5.169,1.593,12.106,12.106,0,0,1-4.436-.731,9.858,9.858,0,0,1-3.144-1.94,8.135,8.135,0,0,1-1.981-2.843,9.8,9.8,0,0,1-.774-3.358l-14.646,2.5a20.568,20.568,0,0,0,6.333,12.922,23.47,23.47,0,0,0,7.58,4.693A29.66,29.66,0,0,0,866.7,63.663",
    transform: "translate(-575.209 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.274,185.218a26.568,26.568,0,0,1-9.909,1.721,29.666,29.666,0,0,1-11.069-1.853,23.478,23.478,0,0,1-7.58-4.693l.007.006a.122.122,0,0,0,.01.009s0,0,.006.006l.01.01.007.007.009.01.006,0,.011.011.007.006.009.01.007.006.01.009.006.005.01.01.008.006.009.01.006.005.01.011.007.005.009.01.006.005.01.011.007.006.01.009.006.006.01.01.007.006.009.009.007.006.01.01.007.006.009.01.007.006.01.009.006.006.01.01.008.006.009.009.007.005.009.01.007.007.009.01.006.005.01.011.006.005.01.01.006.005.01.011.007.006.009.01.007.006.01.01.007.006s.006.007.01.009l.007.006.009.009.006,0,.01.011.008.007.009.009.007.006.009.01.007.006.01.01.006.005.01.01.008.007.009.01,0,0,.011.012.007.006.009.01.006.005.01.011.007.006.01.009.007.007.009.01.006.005.01.01.008.006.009.01.005,0,.011.011.007.007a.086.086,0,0,1,.01.009l.006.006.01.01.008.006.009.01.007.005.009.01.007.007.009.009.005,0,.011.011.007.006.01.01.007.006.009.009.007.006.01.01.008.007.009.009.006.005.01.01a.02.02,0,0,0,.006.006.1.1,0,0,0,.01.01l.006.006.009.01.008.006.009.009.007.006.01.01.007.006.01.01.006.005.01.01.008.006.009.009.007.005.009.01.007.006.01.01.008.006.009.009.006.006.01.01.007.007.009.009.006.005.009.01.007.006.01.01.006.006.01.01.007.006.01.009.006.006.01.01.008.007.009.009.007.006.009.01.006,0,.01.012.008.006.009.009.006.006.01.01.007.006.009.009.007.006.009.01.008.006.009.01.006.005.01.01a.018.018,0,0,0,.006.006.083.083,0,0,0,.01.01l.006.006.009.01.008.006.009.009.007.006.009.01.006.005a.122.122,0,0,1,.01.011l.007.006.009.01.006,0,.011.012.007.006.009.01.007.006.01.01.008.007.009.009.006.006.01.01.007.006.009.01.006,0,.01.011.008.007.009.009.007.006.009.01.006.005.01.01.007.006.009.01.007.005.01.011.007.006.009.009.006,0,.01.012.008.006.009.01.006.006.011.01.007.007.009.009.007.006.009.01s.005,0,.006.006l.01.01.006.005.01.01.006.006.01.01.007.007.009.01.007.005.01.01.007.006.009.01.006.005.01.011.006.005a.089.089,0,0,0,.01.01l.006.005a.118.118,0,0,0,.01.011l.007.006.009.01.007.006.009.009.006.005.01.01.007.007.01.009.006.006.01.01.007.005.01.01.007.006.01.01.007.007.009.01.006.005s.006.007.01.01l.007.006.009.01.007.005.01.011.007.005.01.01a.042.042,0,0,1,.007.007l.009.009.006.006.01.01.007.006.01.01.007.005.01.01.007.007.009.01.006,0,.011.012.007.006.009.009.006.006.01.01.007.007.009.009.007.005.01.01.007.006.009.01.007.006.01.01.005,0,.011.011.007.007a.126.126,0,0,0,.01.009s0,0,.007.006l.01.01.007.006.009.01.006.005.01.01.007.007.01.01.005,0,.011.012.007.006.009.009.006.006.01.01.007.006.009.009.007.006.01.009.006.005.009.011.007.005.01.01.006.006.01.01.007.007.009.009.006.006.01.01.007.006.01.01.007.005.009.01.007.006.009.009.006,0,.011.011a.045.045,0,0,1,.007.007l.009.009.007.006.009.01.007.005.009.011.008.006.009.009.006.005.01.011.006.005.01.01.006.006.01.01.007.006s.006.006.009.009,0,0,.007.006l.009.01.007.006.009.01.006.005.01.01.006.006.01.01.007.006.009.01.007.005.009.01.008.006.009.01.006.005.01.011.007.006.01.01.006.005.009.011.007.005.01.01.006.006.01.01.007.006.009.009.006.006.01.01.007.007.01.009.007.006.009.009.006.005a.088.088,0,0,1,.01.011l.008.006.009.01.006.005.01.01.007.007.01.009.007.005.009.011.008.006.009.01.005,0,.011.011.007.006.009.01.006.006.01.01.007.006s.006.007.009.009l.007.006.009.01.006.006.01.01.008.007.009.009.005.005.011.011.007.006.01.01.007.005.01.01.008.007.009.009.006.005.01.011.007.006.009.01.005,0,.011.011.007.006.01.01a23.478,23.478,0,0,0,7.58,4.693,29.659,29.659,0,0,0,11.069,1.853,26.57,26.57,0,0,0,9.909-1.721c.5-.2.971-.426,1.445-.649l-3.219-3.215c-.5.235-.992.471-1.518.682",
    transform: "translate(-588.877 -123.277)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.873,139.833a10.893,10.893,0,0,1-1.314-.654,8.106,8.106,0,0,1-.519-.948,9.8,9.8,0,0,1-.774-3.358l-.014,0c0-.006,0-.012,0-.018l-.014,0a.142.142,0,0,1,0-.018l-.014,0a.151.151,0,0,0,0-.018l-.013,0a.166.166,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.163.163,0,0,1,0-.018l-.014,0a.171.171,0,0,0,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0a.159.159,0,0,0,0-.018l-.013,0c0-.006,0-.013,0-.019l-.014,0a.172.172,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.013,0c0-.006,0-.012,0-.018l-.013,0a.139.139,0,0,1,0-.018l-.014,0a.139.139,0,0,0,0-.018l-.014,0a.18.18,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.018l-.013,0a.131.131,0,0,1,0-.018l-.014,0a.16.16,0,0,0,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.019l-.013,0c0-.006,0-.012,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0a.15.15,0,0,1,0-.018l-.014,0a.17.17,0,0,0,0-.018l-.013,0a.177.177,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0a.111.111,0,0,0,0-.018l-.013,0c0-.006,0-.012,0-.019l-.014,0a.176.176,0,0,1,0-.019l-.014,0c0-.006,0-.011,0-.018l-.014,0a.183.183,0,0,0,0-.019l-.013,0c0-.006,0-.012,0-.018l-.013,0a.146.146,0,0,1,0-.018l-.014,0a.171.171,0,0,0,0-.018l-.014,0a.176.176,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.018l-.013,0c0-.006,0-.012,0-.018l-.014,0a.183.183,0,0,0,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.019l-.013,0c0-.006,0-.011,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.17.17,0,0,0,0-.018l-.014,0a.16.16,0,0,1,0-.018l-.014,0a.169.169,0,0,0,0-.018l-.013,0a.172.172,0,0,1,0-.018l-.014,0a.183.183,0,0,0,0-.019l-.014,0c0-.007,0-.012,0-.018l-.014,0c0-.006,0-.013,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0a.177.177,0,0,0,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0a.188.188,0,0,1,0-.019l-.014,0c0-.006,0-.011,0-.018l-.014,0a.183.183,0,0,1,0-.019l-.014,0a.17.17,0,0,0,0-.018l-.014,0a.17.17,0,0,1,0-.018l-.014,0a.16.16,0,0,0,0-.018l-.014,0a.171.171,0,0,1,0-.018l-.014,0a.173.173,0,0,0,0-.018l-.013,0c0-.007,0-.012,0-.018l-.014,0a.172.172,0,0,0,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0a.156.156,0,0,1,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0a.13.13,0,0,0,0-.019l-.013,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.161.161,0,0,0,0-.018l-.014,0a.158.158,0,0,1,0-.018l-.014,0a.147.147,0,0,0,0-.018l-.013,0a.172.172,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.007,0-.012,0-.018l-.014,0c0-.007,0-.013,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.179.179,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.018l-.013,0a.129.129,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.171.171,0,0,1,0-.018l-.014,0a.139.139,0,0,0,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.013,0c0-.006,0-.012,0-.018l-.014,0a.162.162,0,0,0,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0a.139.139,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0a.178.178,0,0,0,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.179.179,0,0,0,0-.018l-.014,0a.154.154,0,0,1,0-.018l-.014,0a.1.1,0,0,0,0-.018l-.013,0a.166.166,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0a.148.148,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.018l-.013,0c0-.006,0-.012,0-.018l-.014,0a.166.166,0,0,0,0-.018l-.014,0a.13.13,0,0,1,0-.018l-.014,0a.139.139,0,0,0,0-.018l-.014,0c0-.007,0-.013,0-.019l-.013,0a.18.18,0,0,1,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0a.148.148,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0a.177.177,0,0,0,0-.018l-.014,0c0-.006,0-.011,0-.018l-.014,0c0-.007,0-.012,0-.018l-.014,0a.182.182,0,0,0,0-.018l-.014,0a.167.167,0,0,1,0-.019l-.014,0a.141.141,0,0,0,0-.018l-.014,0c0-.007,0-.013,0-.019l-.014,0a.178.178,0,0,0,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0a.183.183,0,0,1,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0a.178.178,0,0,0,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0a.169.169,0,0,1,0-.018l-.014,0c0-.006,0-.011,0-.018l-.013,0c0-.007,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.179.179,0,0,1,0-.019l-.014,0a.172.172,0,0,0,0-.018l-.014,0c0-.007,0-.013,0-.019l-.013,0c0-.007,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0a.171.171,0,0,1,0-.018l-.014,0c0-.007,0-.012,0-.018l-.013,0a.168.168,0,0,1,0-.018l-.014,0c0-.006,0-.011,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.171.171,0,0,0,0-.018l-.013,0a.132.132,0,0,1,0-.019l-.014,0a.171.171,0,0,0,0-.018l-.014,0c0-.006,0-.013,0-.019l-.014,0a.183.183,0,0,0,0-.019l-.014,0c0-.006,0-.012,0-.018l-.013,0a.181.181,0,0,1,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.011,0-.018l-.014,0c0-.007,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.011,0-.018l-.013,0c0-.006,0-.012,0-.018l-.014,0a.171.171,0,0,0,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0a.161.161,0,0,0,0-.018l-.014,0c0-.006,0-.013,0-.019l-.013,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0a.15.15,0,0,1,0-.018l-.014,0a.1.1,0,0,0,0-.018l-.013,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.162.162,0,0,0,0-.018l-.013,0c0-.007,0-.012,0-.019l-.014,0a.161.161,0,0,0,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.013,0c0-.007,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.011,0-.018l-.014,0a.142.142,0,0,0,0-.018l-.014,0a.18.18,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.018l-.013,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0a.155.155,0,0,0,0-.018l-.013,0c0-.006,0-.012,0-.019l-.013,0a.161.161,0,0,1,0-.019l-.014,0c0-.006,0-.011,0-.018a9.8,9.8,0,0,0,.775,3.358,8.138,8.138,0,0,0,1.981,2.843,9.862,9.862,0,0,0,3.144,1.94",
    transform: "translate(-606.82 -89.995)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.17,43.37a7.742,7.742,0,0,0-2.542-1.637,9.839,9.839,0,0,0-3.79-.646,7.287,7.287,0,0,0-4.953,1.677,5.066,5.066,0,0,0-1.94,3.921c0,.064.014.122.016.185a4.525,4.525,0,0,0,1.235,3.045,5.686,5.686,0,0,0,2.26,1.37,4.9,4.9,0,0,1-.218-1.417,4.754,4.754,0,0,1,1.062-3,6.654,6.654,0,0,1,.879-.924,7.287,7.287,0,0,1,4.953-1.678,9.839,9.839,0,0,1,3.79.646c.2.082.353.188.536.279.054.111.131.215.178.329a6.561,6.561,0,0,0-1.464-2.154",
    transform: "translate(-612.951 -28.079)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.281,122.976a17.815,17.815,0,0,0,1.551-7.235,17.293,17.293,0,0,0-4.479-12.019l-.015-.013,0,0s-.009-.008-.014-.012l0,0-.015-.013,0,0c0-.005-.01-.009-.014-.013l0,0-.014-.013,0,0s-.01-.008-.014-.012l0,0c0-.005-.01-.008-.015-.013l0,0s-.009-.008-.013-.012l0,0s-.01-.008-.014-.013l0,0-.014-.013,0,0s-.01-.008-.014-.013l0,0s-.01-.008-.015-.013l0,0s-.009-.008-.014-.013l0,0-.014-.013,0,0s-.01-.008-.014-.012l0,0-.014-.013,0,0a.171.171,0,0,0-.014-.013l0,0-.015-.013,0,0-.013-.012,0,0c0-.005-.01-.008-.014-.013s0,0,0,0l-.013-.012,0,0s-.01-.008-.014-.013l0,0a.179.179,0,0,0-.015-.013l0,0s-.01-.008-.014-.012l0,0s-.01-.008-.014-.013l0,0a.144.144,0,0,1-.014-.013l0,0-.014-.012,0,0-.013-.013a.005.005,0,0,1,0,0l-.015-.013,0,0c0-.005-.01-.008-.014-.013l0,0s-.01-.008-.014-.013l0,0s-.009-.008-.014-.012l0,0c0-.005-.01-.008-.015-.013l0,0s-.01-.008-.013-.012l0,0-.014-.012,0,0a.1.1,0,0,0-.014-.013l0,0-.014-.012,0,0s-.01-.008-.015-.013l0,0s-.01-.008-.014-.013l0,0-.014-.012a.006.006,0,0,0,0,0s-.01-.009-.013-.013a.006.006,0,0,1,0,0l-.014-.013,0,0a.162.162,0,0,0-.014-.013l0,0-.015-.013,0,0s-.01-.008-.014-.013l0,0s-.01-.008-.014-.012l0,0-.014-.013,0,0-.014-.012,0,0c0-.005-.01-.008-.015-.013l0,0s-.01-.008-.014-.012l0,0s-.01-.008-.014-.013l0,0a.1.1,0,0,1-.014-.013.006.006,0,0,1,0,0l-.014-.012,0,0s-.01-.009-.013-.013l0,0-.015-.013,0,0c0-.005-.01-.008-.014-.013l0,0-.014-.012,0,0s-.01-.008-.014-.013l0,0-.013-.012,0,0-.015-.013,0,0-.014-.012,0,0a.144.144,0,0,0-.014-.013l0,0-.014-.012,0,0s-.01-.008-.015-.013l0,0-.013-.012,0,0-.015-.013,0,0-.014-.013,0,0-.014-.012,0,0a.182.182,0,0,0-.014-.013l0,0-.014-.012,0,0s-.01-.008-.014-.013l0,0s-.01-.008-.014-.012l0,0-.014-.013,0,0a.114.114,0,0,1-.014-.012l0,0c0-.005-.01-.008-.015-.013l0,0-.014-.012,0,0s-.01-.008-.014-.013l0,0s-.01-.008-.014-.012l0,0-.014-.013,0,0-.014-.013,0,0-.014-.012,0,0a.134.134,0,0,0-.014-.013l0,0-.014-.012,0,0s-.01-.008-.014-.012l0,0-.013-.013,0,0-.015-.013,0,0-.014-.012,0,0c0-.005-.01-.008-.014-.013l0,0-.014-.013,0,0-.014-.013,0,0-.013-.012,0,0-.014-.013,0,0s-.01-.008-.014-.013l0,0-.014-.012,0,0c0-.005-.01-.009-.014-.013l0,0-.014-.012,0,0s-.01-.008-.014-.012l0,0s-.01-.008-.014-.013l0,0a.142.142,0,0,0-.014-.013l0,0a.131.131,0,0,1-.014-.013l0,0a.1.1,0,0,1-.014-.013s0,0,0,0-.01-.008-.014-.013l0,0-.013-.012,0,0a.139.139,0,0,0-.014-.013l0,0c0-.005-.009-.009-.014-.013l0,0s-.01-.008-.014-.013l0,0-.014-.012,0,0a.112.112,0,0,0-.014-.013l0,0L965.57,102l0,0-.013-.012,0,0c0-.005-.01-.008-.014-.013l0,0s-.01-.008-.014-.012l0,0s-.01-.008-.014-.013l0,0-.014-.013,0,0s-.01-.008-.014-.013l0,0-.013-.012,0,0s-.01-.008-.014-.013l0,0c0-.005-.01-.009-.014-.013l0,0-.014-.013,0,0a.18.18,0,0,1-.014-.013l0,0-.013-.013,0,0-.013-.012,0,0a.109.109,0,0,1-.014-.012l0,0c0-.005-.01-.008-.014-.013l0,0a.149.149,0,0,0-.014-.012l0,0a.128.128,0,0,1-.014-.013l0,0s-.01-.008-.014-.013l0,0s-.01-.008-.014-.013l0,0-.013-.012,0,0a.176.176,0,0,0-.014-.013l0,0c0-.005-.01-.009-.014-.013s0,0,0,0l-.013-.012,0,0a.142.142,0,0,1-.015-.013l0,0-.014-.013,0,0a.163.163,0,0,0-.014-.012l0,0-.013-.012,0,0c0-.005-.01-.008-.014-.013l0,0s-.01-.008-.014-.012l0,0s-.01-.008-.014-.013l0,0s-.009-.008-.014-.013l0,0-.014-.012,0,0s-.01-.008-.014-.013l0,0s-.01-.008-.014-.012l0,0c0-.005-.01-.008-.015-.013l0,0a.159.159,0,0,0-.014-.012l0,0a.136.136,0,0,1-.014-.013l0,0-.013-.013,0,0s-.01-.008-.014-.012l0,0s-.01-.008-.014-.012l0,0c0-.005-.01-.009-.014-.013l0,0-.014-.012,0,0a.136.136,0,0,1-.014-.013l0,0-.015-.013,0,0a.154.154,0,0,0-.014-.012l0,0-.015-.013,0,0s-.01-.008-.014-.012l0,0c0-.005-.01-.008-.014-.013s0,0,0,0a.17.17,0,0,0-.013-.012l0,0s-.01-.008-.015-.013l0,0s-.009-.008-.014-.012l0,0-.014-.013s0,0,0,0l-.013-.012,0,0c0-.005-.01-.009-.014-.013l0,0-.015-.013,0,0s-.01-.008-.014-.013l0,0a.188.188,0,0,0-.014-.013l0,0s-.01-.008-.013-.012l0,0-.014-.013,0,0s-.01-.008-.014-.012l0,0c0-.005-.01-.008-.015-.013l0,0a.162.162,0,0,0-.014-.012l0,0a.178.178,0,0,1-.014-.013l0,0s-.009-.008-.013-.012l0,0a.14.14,0,0,1-.014-.013l0,0s-.01-.008-.015-.013l0,0s-.009-.008-.014-.013l0,0-.014-.013,0,0a.147.147,0,0,1-.013-.013.006.006,0,0,1,0,0,.174.174,0,0,1-.014-.012.007.007,0,0,0,0,0c0-.005-.01-.008-.014-.013l0,0-.015-.013,0,0-.014-.012,0,0c0-.005-.01-.008-.014-.013l0,0-.014-.012,0,0s-.01-.008-.015-.013l0,0s-.01-.008-.014-.013,0,0,0,0-.009-.008-.014-.012l0,0s-.01-.008-.014-.013l0,0a.11.11,0,0,1-.013-.013.006.006,0,0,1,0,0l-.015-.013,0,0-.014-.013,0,0-.014-.012,0,0c0-.005-.01-.008-.013-.013l0,0-.014-.013,0,0s-.01-.008-.014-.012l0,0c0-.005-.01-.008-.015-.013l0,0s-.009-.008-.014-.013l0,0-.013-.011,0,0a.113.113,0,0,0-.014-.013l0,0a.146.146,0,0,1-.014-.012l0,0a.163.163,0,0,1-.015-.013,17.3,17.3,0,0,1,4.478,12.016,17.814,17.814,0,0,1-1.552,7.235,19.265,19.265,0,0,1-4.521,6.332,22.152,22.152,0,0,1-5.761,3.842l3.219,3.215a22.182,22.182,0,0,0,5.834-3.875,19.26,19.26,0,0,0,4.521-6.332",
    transform: "translate(-653.792 -68.708)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.971,137.276l-.054-.018a4.682,4.682,0,0,1,.247.769,5.313,5.313,0,0,0-.194-.751",
    transform: "translate(-643.685 -93.799)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.3,100.672l.014.013h0s-.01-.008-.014-.012",
    transform: "translate(-588.594 -68.797)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.8,110.478a7.618,7.618,0,0,0-4.223-1.937L874,107.074a25.5,25.5,0,0,1-8.812-3.32,18.471,18.471,0,0,1-3.838-3.041l0,0,.013.012,0,0,.014.012,0,0,.013.012,0,0c0,.005.009.008.013.013l0,0a.128.128,0,0,1,.014.012l0,0,.014.011,0,0,.014.012,0,0,.013.012,0,0a.09.09,0,0,1,.013.012l0,0,.014.011,0,0s.01.008.014.012l0,0s.009.008.013.012l0,0,.014.012,0,0a.151.151,0,0,1,.013.012l0,0,.013.012,0,0,.014.012,0,0,.014.012,0,0,.014.012,0,0s.009.007.013.011l0,0a.17.17,0,0,1,.014.012l0,0a.179.179,0,0,0,.014.012l0,0,.014.012,0,0a.17.17,0,0,0,.013.011l0,0s.01.008.013.012l0,0,.013.012,0,0,.014.012,0,0c0,.005.009.008.014.013l0,0s.009.007.013.011l0,0,.014.012,0,0s.009.008.013.012l0,0a.17.17,0,0,1,.014.012l0,0,.014.012,0,0,.014.012,0,0,.013.011,0,.005.013.012,0,0,.014.012,0,0s.01.008.014.012l0,0s.009.008.014.012l0,0,.013.012,0,0,.014.013,0,0s.009.007.013.012l0,0s.01.008.014.012l0,0a.126.126,0,0,0,.014.012l0,0,.014.012,0,0a.142.142,0,0,1,.013.012l0,0a.159.159,0,0,1,.014.012l0,0,.013.011,0,.005.014.012,0,0a.163.163,0,0,0,.014.012l0,0s.009.008.013.012l0,0,.014.012,0,0,.014.011,0,0s.009.008.013.012l0,0s.009.008.014.012l0,0,.014.012,0,0,.013.012,0,0,.014.012,0,0,.014.012,0,0,.014.012,0,0s.009.007.013.011l0,0s.009.008.013.012l0,0,.014.012,0,0,.014.012,0,0a.159.159,0,0,0,.014.012l0,0,.013.011,0,0,.013.012,0,0,.013.012,0,0a.165.165,0,0,1,.014.012l0,0a.163.163,0,0,0,.014.012l0,0,.014.012,0,0,.013.012,0,0a.111.111,0,0,1,.013.012l0,0,.014.012a.006.006,0,0,0,0,0,.17.17,0,0,0,.014.012l0,0a.151.151,0,0,0,.013.012l0,0,.013.012,0,0,.014.012,0,0,.014.011,0,0,.013.012,0,0a.121.121,0,0,0,.014.012l0,0,.014.012,0,0,.014.012,0,0s.01.007.014.011l0,0,.014.012,0,0,.013.012,0,0,.013.012,0,0s.01.008.014.012l0,0,.014.012,0,0s.009.008.014.012l0,0,.014.012,0,0,.013.011,0,0c0,.005.01.008.014.013l0,0a.153.153,0,0,0,.014.012l0,0a.129.129,0,0,1,.014.012l0,0s.009.008.014.012l0,0s.01.007.013.011l0,0,.013.011,0,0s.009.007.013.012l0,0,.014.012,0,0,.014.012,0,0,.013.012,0,0c0,.005.01.008.013.013l0,0,.014.012,0,0a.151.151,0,0,1,.013.012l0,0,.014.012,0,0s.01.008.013.012l0,0s.01.007.013.012l0,0,.014.012,0,0s.01.007.014.011l0,0,.013.011,0,0a.094.094,0,0,0,.013.012l0,0,.013.012,0,0a.126.126,0,0,1,.014.012l0,0,.014.011,0,0c0,.005.009.008.014.013l0,0s.009.008.013.012l0,0,.013.012,0,0s.01.008.014.012l0,0s.009.008.014.012l0,0a.158.158,0,0,1,.014.012l0,0,.014.012,0,0s.01.007.013.012l0,0a.126.126,0,0,1,.013.011l0,0a.16.16,0,0,1,.014.012l0,0,.014.012,0,0s.009.008.014.012l0,0,.013.012,0,0c0,.005.01.008.013.013a.006.006,0,0,1,0,0s.009.007.013.012l0,0,.014.012,0,0s.01.008.014.012l0,0s.01.008.013.012l0,0s.01.007.013.011l0,0,.014.012,0,0,.014.012,0,0s.009.007.013.012l0,0s.009.008.013.012l0,0s.009.008.013.012l0,0a.172.172,0,0,1,.014.012l0,0,.014.012,0,0c0,.005.01.008.014.013l0,0s.009.007.013.011l0,0s.01.008.013.012l0,0,.014.012,0,0,.014.012,0,0,.014.011,0,0a.085.085,0,0,0,.014.012l0,0a.145.145,0,0,0,.013.012l0,0s.009.008.013.012l0,0s.01.008.014.012l0,0s.01.008.014.012l0,0s.01.008.014.012l0,0,.013.012,0,0a.137.137,0,0,1,.014.013l0,0s.009.007.013.011l0,0s.009.008.014.012l0,0,.014.012,0,0s.009.007.013.012l0,0,.014.011,0,0s.009.008.013.011l0,0s.01.007.014.012l0,0,.014.012,0,0s.009.008.013.012l0,0,.013.012,0,0s.01.008.014.012l0,0,.014.012,0,0,.013.012,0,0,.013.012,0,0,.013.011,0,0,.014.012,0,0s.009.007.013.012l0,0,.014.012,0,0a.11.11,0,0,0,.013.011l0,0s.009.007.013.011l0,0,.013.012,0,0s.01.008.014.012l0,0,.014.012,0,0s.01.008.013.012l0,0a.15.15,0,0,0,.013.012l0,0,.013.012,0,0,.014.012,0,0,.013.011,0,0,.013.012,0,0a.154.154,0,0,0,.013.012l0,0,.014.012,0,0s.009.007.013.011l0,0,.014.012,0,0,.013.012,0,0,.013.012,0,0c0,.005.009.008.014.013l0,0s.01.008.014.012l0,0,.014.012,0,0a.1.1,0,0,0,.013.012l0,0a.169.169,0,0,1,.013.012l0,0,.013.011,0,0,.014.012,0,0s.009.007.013.012l0,0,.014.012,0,0a.163.163,0,0,1,.013.012l0,0,.013.012,0,0a18.384,18.384,0,0,0,3.576,2.884,25.258,25.258,0,0,0,9.089,3.489l7.58,1.467a10.72,10.72,0,0,1,1.988.562,4.684,4.684,0,0,0-1.057-1.806",
    transform: "translate(-588.624 -68.825)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.008,55.432l-4.591.847a.122.122,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.019l.012,0c0,.006,0,.012,0,.018l.012,0a.152.152,0,0,0,0,.019l.012,0a.158.158,0,0,0,0,.018l.012,0a.122.122,0,0,1,0,.018l.012,0c0,.006,0,.013,0,.018l.013,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.019l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0a.114.114,0,0,0,0,.018l.012,0a.08.08,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0a.085.085,0,0,1,0,.019l.012,0a.137.137,0,0,1,0,.018l.013,0c0,.006,0,.013,0,.019l.012,0a.172.172,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0a.174.174,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.019l.012,0a.161.161,0,0,0,0,.018l.012,0a.12.12,0,0,1,0,.018l.012,0a.112.112,0,0,1,0,.018l.013,0a.171.171,0,0,0,0,.018l.012,0a.184.184,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.011,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0a.094.094,0,0,1,0,.018l.012,0c0,.007,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.019l.013,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.018l.012,0c0,.006,0,.012,0,.018l.013,0c0,.006,0,.012,0,.018l.012,0a.131.131,0,0,0,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.019l.012,0c0,.006,0,.012,0,.018l.012,0a.157.157,0,0,0,0,.019l.012,0a.092.092,0,0,1,0,.018l.012,0a.178.178,0,0,1,0,.018l.013,0a.122.122,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.018l.012,0,0,.018.012,0c0,.005,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0,0,.019.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.019l.013,0c0,.006,0,.012,0,.018l.012,0a.157.157,0,0,0,0,.018l.012,0a.132.132,0,0,1,0,.018l.012,0a.16.16,0,0,1,0,.018l.013,0c0,.006,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0a.145.145,0,0,0,0,.018l.012,0a.154.154,0,0,0,0,.019l.011,0a.123.123,0,0,1,0,.018l.012,0a.157.157,0,0,1,0,.018l.013,0c0,.007,0,.012,0,.018l.012,0a.158.158,0,0,0,0,.018l.012,0a.083.083,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.019l.012,0c0,.006,0,.012,0,.018l.012,0c0,.007,0,.013,0,.018l.013,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.011,0a.144.144,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.011,0,.018l.012,0a.158.158,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0a.119.119,0,0,0,0,.018l.012,0a.178.178,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.013,0a.171.171,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.005,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.019l.012,0a.13.13,0,0,0,0,.018l.011,0a.113.113,0,0,1,0,.018l.012,0c0,.007,0,.013,0,.018l.013,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0a.117.117,0,0,1,0,.019l.012,0,0,.018.012,0c0,.007,0,.013,0,.019l.012,0c0,.006,0,.012,0,.018l.013,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.018l.011,0a.156.156,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.013,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.019l.012,0,0,.018.012,0c0,.007,0,.013,0,.019l.012,0a.123.123,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.018l.013,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.011,0a.116.116,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0a.155.155,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.019l.012,0,0,.018.012,0a.16.16,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.013,0c0,.006,0,.012,0,.018l.012,0a.172.172,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.013,0a.171.171,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0a.164.164,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.019l.012,0,0,.018.012,0a.183.183,0,0,0,0,.019l.012,0a.113.113,0,0,0,0,.018l14.365-2.651-3.2-3.2Z",
    transform: "translate(-646.076 -36.639)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.953,30.784a21.133,21.133,0,0,0-1.578-4.585,18,18,0,0,0-4.178-5.47l0,0-.014-.013h0l-.016-.016,0,0a.137.137,0,0,0-.014-.014h0l-.015-.015,0,0-.014-.014h0l-.015-.014,0,0-.014-.014h0l-.016-.016,0,0-.014-.014h0l-.014-.015,0,0-.014-.014,0,0L975,20.538h0l-.016-.015,0,0-.013-.014h0l-.015-.015,0,0c-.005,0-.009-.01-.014-.014h0l-.015-.015,0,0-.014-.014h0l-.015-.014,0,0-.014-.013h0l-.015-.016,0,0-.014-.014,0,0c-.005,0-.009-.009-.014-.014h0l-.016-.015,0,0-.013-.014h0c-.005,0-.009-.01-.014-.015h0l-.015-.014h0l-.015-.015,0,0a.178.178,0,0,0-.014-.013h0l-.015-.015,0,0-.014-.014h0l-.015-.014,0,0-.014-.013h0l-.015-.015h0l-.015-.014,0,0-.013-.014h0l-.014-.015s0,0,0,0l-.014-.013h0l-.016-.015h0l-.015-.014h0l-.015-.015,0,0-.014-.013h0l-.015-.015,0,0-.014-.014,0,0-.013-.014h0L974.442,20l0,0-.014-.014h0l-.014-.014,0,0c-.005,0-.009-.009-.014-.014h0l-.015-.015,0,0-.013-.013h0l-.014-.015h0l-.015-.014h0l-.015-.015,0,0a.178.178,0,0,0-.014-.013l0,0-.013-.013h0l-.015-.015,0,0-.014-.014h0l-.016-.016,0,0-.014-.014h0l-.015-.014,0,0-.014-.014h0l-.014-.015,0,0-.014-.013h0l-.016-.015,0,0-.014-.014,0,0-.014-.014h0l-.015-.014,0,0-.014-.013h0l-.015-.015,0,0-.013-.014h0l-.016-.016,0,0L974,19.572h0l-.014-.014,0,0-.014-.014h0l-.015-.015,0,0-.013-.014h0l-.014-.014h0l-.015-.015,0,0-.014-.014h0l-.015-.014,0,0-.013-.014h0l-.015-.015h0l-.015-.014h0c-.005-.005-.009-.01-.014-.015l0,0-.014-.014h0l-.015-.014,0,0-.014-.013,0,0-.014-.014h0l-.015-.015h0l-.015-.014,0,0-.015-.015,0,0-.014-.014h0l-.015-.014,0,0-.014-.014h0l-.015-.015v0l-.015-.014h0l-.016-.015,0,0-.014-.014,0,0-.014-.014h0l-.015-.015,0,0-.014-.014h0l-.016-.016,0,0-.014-.014h0l-.015-.015s0,0,0,0l-.014-.014h0l-.015-.014,0,0-.013-.014,0,0L973.41,19h0l-.015-.015,0,0-.014-.014h0l-.015-.015,0,0-.014-.014h0l-.015-.015,0,0-.014-.013h0l-.015-.016,0,0-.013-.014h0l-.015-.015,0,0-.014-.014,0,0-.014-.014h0l-.015-.015h0a.2.2,0,0,1-.014-.015h0l-.015-.014,0,0a.19.19,0,0,1-.014-.013h0l-.015-.015,0,0-.014-.014h0l-.015-.015,0,0L973.1,18.7h0l-.015-.016,0,0a.186.186,0,0,0-.014-.014l0,0-.014-.014h0l-.015-.015,0,0-.014-.013h0L973,18.607h0l-.015-.015h0l-.015-.014,0,0-.014-.013h0l-.014-.015,0,0-.014-.014h0l-.015-.015h0l-.014-.014,0,0-.014-.014h0l-.015-.014,0,0-.014-.014h0l-.015-.015,0,0-.014-.013h0a.145.145,0,0,0-.015-.015h0c-.005,0-.009-.01-.014-.015h0l-.015-.014,0,0a.177.177,0,0,1-.014-.013v0l-.015-.015,0,0-.014-.014,0,0c-.005,0-.009-.01-.014-.014h0a.2.2,0,0,1-.015-.015l0,0-.014-.014h0l-.015-.014,0,0-.014-.014h0l-.015-.015,0,0-.014-.013h0l-.016-.015,0,0-.014-.014h0l-.015-.014,0,0-.013-.014,0,0-.014-.013h0l-.016-.015,0,0a.149.149,0,0,0-.014-.014h0c-.006,0-.01-.01-.016-.015l0,0-.014-.014h0l-.015-.014,0,0-.014-.014h0l-.015-.015,0,0-.014-.014h0l-.016-.015,0,0-.013-.014,0,0-.014-.014h0l-.016-.015,0,0-.014-.013,0,0c-.005,0-.009-.01-.014-.015h0l-.015-.014h0l-.015-.015,0,0-.014-.014h0l-.015-.014,0,0-.014-.013h0l-.015-.015,0,0-.014-.014h0l-.015-.015h0l-.016-.015,0,0-.014-.014h0c-.005,0-.009-.01-.014-.015l0,0-.014-.014h0l-.016-.015h0l-.015-.014h0l-.015-.015,0,0-.014-.014h0L972,17.641l0,0-.014-.013,0,0-.014-.014h0l-.016-.016,0,0-.014-.014h0l-.014-.015s0,0,0,0l-.014-.013a17.991,17.991,0,0,1,4.179,5.47,20.5,20.5,0,0,1,1.9,5.946l-.018,0,3.2,3.2.109-.02c-.066-.45-.216-.908-.318-1.361",
    transform: "translate(-664.177 -11.991)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.2,200.424h0Z",
    transform: "translate(-687.613 -136.965)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.3,200.526h0Z",
    transform: "translate(-687.684 -137.034)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.613,200.825h0Z",
    transform: "translate(-687.896 -137.239)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.148,200.376h0Z",
    transform: "translate(-687.578 -136.932)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.1,200.326",
    transform: "translate(-687.544 -136.898)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.56,200.776h0Z",
    transform: "translate(-687.86 -137.205)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.509,200.725h0Z",
    transform: "translate(-687.826 -137.171)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.044,200.275",
    transform: "translate(-687.508 -136.863)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.406,200.626h0Z",
    transform: "translate(-687.755 -137.102)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.355,200.576h0Z",
    transform: "translate(-687.72 -137.069)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.458,200.676h0Z",
    transform: "translate(-687.791 -137.137)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.251,200.475h0Z",
    transform: "translate(-687.649 -137)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.579,199.825h0Z",
    transform: "translate(-687.19 -136.555)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.63,199.876h0Z",
    transform: "translate(-687.224 -136.59)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.422,199.675h0Z",
    transform: "translate(-687.082 -136.453)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.475,199.726h0Z",
    transform: "translate(-687.119 -136.487)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.682,199.926",
    transform: "translate(-687.26 -136.625)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.94,200.175h0Z",
    transform: "translate(-687.437 -136.794)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.89,200.126h0Z",
    transform: "translate(-687.402 -136.761)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.733,199.975h0Z",
    transform: "translate(-687.295 -136.658)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.991,200.225h0Z",
    transform: "translate(-687.471 -136.829)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.837,200.075h0Z",
    transform: "translate(-687.366 -136.726)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.786,200.026h0Z",
    transform: "translate(-687.331 -136.693)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.9,202.076h0Z",
    transform: "translate(-688.779 -138.094)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.543,201.725h0Z",
    transform: "translate(-688.532 -137.854)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.6,201.776h0Z",
    transform: "translate(-688.568 -137.888)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.336,201.526h0Z",
    transform: "translate(-688.391 -137.718)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.389,201.576",
    transform: "translate(-688.427 -137.752)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.442,201.626",
    transform: "translate(-688.463 -137.787)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.492,201.676h0Z",
    transform: "translate(-688.497 -137.82)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.854,202.025h0Z",
    transform: "translate(-688.744 -138.059)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.372,199.625h0Z",
    transform: "translate(-687.048 -136.419)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.7,201.876h0Z",
    transform: "translate(-688.639 -137.957)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.647,201.826h0Z",
    transform: "translate(-688.603 -137.923)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.75,201.926h0Z",
    transform: "translate(-688.674 -137.991)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.234,201.426h0Z",
    transform: "translate(-688.321 -137.65)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.285,201.475h0Z",
    transform: "translate(-688.356 -137.683)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.924,201.125h0Z",
    transform: "translate(-688.109 -137.444)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.767,200.975h0Z",
    transform: "translate(-688.002 -137.341)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.486,172.213l3.292,3.182,3.7-11.543-3.292-3.182Z",
    transform: "translate(-720.612 -109.798)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.974,201.176h0Z",
    transform: "translate(-688.143 -137.479)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.82,201.026h0Z",
    transform: "translate(-688.038 -137.376)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.666,200.877",
    transform: "translate(-687.933 -137.275)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.181,201.375h0Z",
    transform: "translate(-688.285 -137.615)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.078,201.276h0Z",
    transform: "translate(-688.214 -137.547)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.131,201.327h0Z",
    transform: "translate(-688.25 -137.582)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.027,201.226",
    transform: "translate(-688.179 -137.513)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.284,198.576h0Z",
    transform: "translate(-686.305 -135.702)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.612,197.926h0Z",
    transform: "translate(-685.846 -135.257)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.561,197.875h0Z",
    transform: "translate(-685.811 -135.223)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.665,197.976h0Z",
    transform: "translate(-685.882 -135.292)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.508,197.824h0Z",
    transform: "translate(-685.775 -135.188)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.716,198.025h0Z",
    transform: "translate(-685.916 -135.325)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.458,197.775h0Z",
    transform: "translate(-685.74 -135.155)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.923,198.226h0Z",
    transform: "translate(-686.058 -135.463)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.769,198.076h0Z",
    transform: "translate(-685.953 -135.36)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.976,198.276",
    transform: "translate(-686.094 -135.497)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.407,197.726",
    transform: "translate(-685.705 -135.121)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.872,198.175h0Z",
    transform: "translate(-686.023 -135.428)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.819,198.125h0Z",
    transform: "translate(-685.987 -135.393)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.043,197.375h0Z",
    transform: "translate(-685.457 -134.881)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.94,197.275h0Z",
    transform: "translate(-685.386 -134.813)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.027,198.326h0Z",
    transform: "translate(-686.129 -135.531)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.992,197.325",
    transform: "translate(-685.422 -134.847)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.843,197.126l-.005.016,16.353-.016Z",
    transform: "translate(-685.317 -134.712)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.889,197.225h0Z",
    transform: "translate(-685.351 -134.778)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.2,197.525h0Z",
    transform: "translate(-685.564 -134.984)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.1,197.426h0Z",
    transform: "translate(-685.493 -134.916)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.321,199.577",
    transform: "translate(-687.013 -136.386)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.25,197.576h0Z",
    transform: "translate(-685.598 -135.018)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.354,197.676h0Z",
    transform: "translate(-685.669 -135.087)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.147,197.475h0Z",
    transform: "translate(-685.528 -134.949)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.3,197.625h0Z",
    transform: "translate(-685.633 -135.052)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.01,199.276h0Z",
    transform: "translate(-686.801 -136.181)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.906,199.175h0Z",
    transform: "translate(-686.73 -136.111)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.957,199.226h0Z",
    transform: "translate(-686.765 -136.146)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.8,199.075h0Z",
    transform: "translate(-686.659 -136.043)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.853,199.124h0Z",
    transform: "translate(-686.694 -136.077)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.164,199.425h0Z",
    transform: "translate(-686.906 -136.282)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.061,199.325h0Z",
    transform: "translate(-686.836 -136.214)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.268,199.526h0Z",
    transform: "translate(-686.977 -136.351)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.217,199.476h0Z",
    transform: "translate(-686.942 -136.317)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.113,199.376h0Z",
    transform: "translate(-686.872 -136.249)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.752,199.026",
    transform: "translate(-686.625 -136.01)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.958,202.125h0Z",
    transform: "translate(-688.815 -138.127)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.388,198.675h0Z",
    transform: "translate(-686.376 -135.77)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.077,198.375h0Z",
    transform: "translate(-686.164 -135.564)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.337,198.626",
    transform: "translate(-686.341 -135.736)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.234,198.525h0Z",
    transform: "translate(-686.27 -135.667)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.13,198.425h0Z",
    transform: "translate(-686.2 -135.599)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.441,198.726h0Z",
    transform: "translate(-686.412 -135.804)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.7,198.976h0Z",
    transform: "translate(-686.588 -135.975)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.6,198.876h0Z",
    transform: "translate(-686.518 -135.907)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.646,198.925h0Z",
    transform: "translate(-686.552 -135.94)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.545,198.826h0Z",
    transform: "translate(-686.483 -135.872)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.492,198.775h0Z",
    transform: "translate(-686.447 -135.838)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.716,200.926",
    transform: "translate(-687.967 -137.308)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.889,205.926h0Z",
    transform: "translate(-691.502 -140.725)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.424,205.476",
    transform: "translate(-691.184 -140.418)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.216,205.276h0Z",
    transform: "translate(-691.042 -140.281)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.32,205.376h0Z",
    transform: "translate(-691.113 -140.349)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.578,205.627h0Z",
    transform: "translate(-691.289 -140.521)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.371,205.426h0Z",
    transform: "translate(-691.148 -140.383)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.527,205.577h0Z",
    transform: "translate(-691.255 -140.486)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.838,205.877",
    transform: "translate(-691.467 -140.692)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.785,205.827h0Z",
    transform: "translate(-691.431 -140.657)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.682,205.727h0Z",
    transform: "translate(-691.36 -140.589)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.631,205.676h0Z",
    transform: "translate(-691.325 -140.554)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.735,205.777",
    transform: "translate(-691.397 -140.623)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.474,205.526h0Z",
    transform: "translate(-691.219 -140.451)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.751,204.826",
    transform: "translate(-690.724 -139.973)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.164,205.225h0Z",
    transform: "translate(-691.006 -140.246)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.855,204.927h0Z",
    transform: "translate(-690.795 -140.042)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.648,204.725Z",
    transform: "translate(-690.653 -139.904)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.7,204.778",
    transform: "translate(-690.689 -139.941)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.8,204.876h0Z",
    transform: "translate(-690.759 -140.007)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.113,205.176h0Z",
    transform: "translate(-690.971 -140.212)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.062,205.127",
    transform: "translate(-690.937 -140.179)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.906,204.977h0Z",
    transform: "translate(-690.83 -140.077)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.009,205.077h0Z",
    transform: "translate(-690.901 -140.144)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.958,205.026h0Z",
    transform: "translate(-690.866 -140.11)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.509,206.525h0Z",
    transform: "translate(-691.925 -141.134)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.769,206.777",
    transform: "translate(-692.103 -141.307)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.561,206.576h0Z",
    transform: "translate(-691.961 -141.169)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.872,206.877h0Z",
    transform: "translate(-692.174 -141.375)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.716,206.727h0Z",
    transform: "translate(-692.067 -141.272)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.665,206.676h0Z",
    transform: "translate(-692.032 -141.237)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.82,206.826h0Z",
    transform: "translate(-692.138 -141.34)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.13,207.127h0Z",
    transform: "translate(-692.35 -141.545)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.08,207.077",
    transform: "translate(-692.316 -141.512)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.923,206.927h0Z",
    transform: "translate(-692.208 -141.409)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.976,206.977h0Z",
    transform: "translate(-692.245 -141.443)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.027,207.027h0Z",
    transform: "translate(-692.279 -141.477)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.045,206.078",
    transform: "translate(-691.608 -140.829)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.2,206.227h0Z",
    transform: "translate(-691.714 -140.93)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.595,204.676h0Z",
    transform: "translate(-690.618 -139.871)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.147,206.176h0Z",
    transform: "translate(-691.678 -140.896)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.94,205.976h0Z",
    transform: "translate(-691.537 -140.759)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.993,206.026Z",
    transform: "translate(-691.573 -140.793)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.1,206.127",
    transform: "translate(-691.643 -140.862)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.458,206.477h0Z",
    transform: "translate(-691.891 -141.101)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.407,206.427",
    transform: "translate(-691.856 -141.067)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.251,206.277h0Z",
    transform: "translate(-691.749 -140.965)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.3,206.326h0Z",
    transform: "translate(-691.785 -140.998)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.354,206.377h0Z",
    transform: "translate(-691.82 -141.033)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.25,203.376h0Z",
    transform: "translate(-689.698 -138.982)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.838,202.976h0Z",
    transform: "translate(-689.417 -138.709)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.941,203.076h0Z",
    transform: "translate(-689.487 -138.777)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.787,202.927",
    transform: "translate(-689.382 -138.676)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.888,203.026h0Z",
    transform: "translate(-689.451 -138.743)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.734,202.876",
    transform: "translate(-689.346 -138.641)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.681,202.826h0Z",
    transform: "translate(-689.31 -138.606)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.63,202.775h0Z",
    transform: "translate(-689.275 -138.571)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.148,203.277h0Z",
    transform: "translate(-689.629 -138.914)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.2,203.326h0Z",
    transform: "translate(-689.664 -138.948)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.992,203.127h0Z",
    transform: "translate(-689.522 -138.812)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.045,203.177h0Z",
    transform: "translate(-689.558 -138.847)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.1,203.226h0Z",
    transform: "translate(-689.593 -138.88)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.165,202.326h0Z",
    transform: "translate(-688.957 -138.265)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.216,202.375h0Z",
    transform: "translate(-688.992 -138.298)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.011,202.177",
    transform: "translate(-688.852 -138.163)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.579,202.726h0Z",
    transform: "translate(-689.24 -138.538)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.112,202.275h0Z",
    transform: "translate(-688.921 -138.23)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.269,202.426h0Z",
    transform: "translate(-689.028 -138.333)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.061,202.226",
    transform: "translate(-688.886 -138.197)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.476,202.627h0Z",
    transform: "translate(-689.169 -138.47)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.527,202.676h0Z",
    transform: "translate(-689.204 -138.503)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.423,202.576h0Z",
    transform: "translate(-689.133 -138.435)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.319,202.476h0Z",
    transform: "translate(-689.063 -138.367)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.372,202.526",
    transform: "translate(-689.098 -138.402)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.44,204.526h0Z",
    transform: "translate(-690.512 -139.768)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.132,204.227",
    transform: "translate(-690.301 -139.564)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.233,204.327h0Z",
    transform: "translate(-690.37 -139.632)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.182,204.276h0Z",
    transform: "translate(-690.336 -139.597)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.975,204.075h0Z",
    transform: "translate(-690.194 -139.46)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.026,204.126h0Z",
    transform: "translate(-690.229 -139.495)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.079,204.176",
    transform: "translate(-690.265 -139.529)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.493,204.576",
    transform: "translate(-690.548 -139.803)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.544,204.626h0Z",
    transform: "translate(-690.583 -139.836)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.337,204.427h0Z",
    transform: "translate(-690.441 -139.7)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.39,204.477h0Z",
    transform: "translate(-690.477 -139.735)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.286,204.376h0Z",
    transform: "translate(-690.406 -139.665)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.717,203.827",
    transform: "translate(-690.018 -139.291)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.51,203.626h0Z",
    transform: "translate(-689.876 -139.153)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.561,203.676h0Z",
    transform: "translate(-689.911 -139.188)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.457,203.576h0Z",
    transform: "translate(-689.84 -139.118)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.406,203.526",
    transform: "translate(-689.805 -139.085)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.356,203.477",
    transform: "translate(-689.771 -139.052)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.664,203.777h0Z",
    transform: "translate(-689.981 -139.256)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.821,203.926",
    transform: "translate(-690.089 -139.358)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.768,203.876h0Z",
    transform: "translate(-690.052 -139.324)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.614,203.726h0Z",
    transform: "translate(-689.947 -139.221)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.3,203.425h0Z",
    transform: "translate(-689.734 -139.016)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.872,203.976h0Z",
    transform: "translate(-690.123 -139.392)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.8,201.977h0Z",
    transform: "translate(-688.71 -138.026)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.023,63.754l4.07,12.888L1085.89,57l-6.373,19.643h4.324Z",
    transform: "translate(-737.717 -38.953)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.928,203.816h0l-.006-.005Z",
    transform: "translate(-786.517 -139.28)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.876,203.764h0l-.006-.006Z",
    transform: "translate(-786.481 -139.244)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.825,203.715h0l-.006-.006Z",
    transform: "translate(-786.446 -139.21)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.979,203.865h0l-.006-.006Z",
    transform: "translate(-786.552 -139.313)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.032,203.915h0l-.005-.005Z",
    transform: "translate(-786.588 -139.348)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.083,203.965h0l-.006-.006Z",
    transform: "translate(-786.622 -139.381)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.618,203.514h0l-.006-.006Z",
    transform: "translate(-786.305 -139.073)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.567,203.464h0l-.006-.006Z",
    transform: "translate(-786.27 -139.038)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.22,202.161h.006l-.008-.008Z",
    transform: "translate(-785.349 -138.147)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.137,204.016h0l0,0Z",
    transform: "translate(-786.66 -139.417)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.669,203.565h0l-.006-.006Z",
    transform: "translate(-786.339 -139.107)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.721,203.614h0l-.006-.006Z",
    transform: "translate(-786.375 -139.141)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.757,204.618h0l0,0Z",
    transform: "translate(-787.083 -139.828)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.5,204.368h0l-.005,0Z",
    transform: "translate(-786.907 -139.657)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.808,204.666h0l0,0Z",
    transform: "translate(-787.118 -139.861)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.653,204.517h0l-.005-.005Z",
    transform: "translate(-787.012 -139.759)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.187,204.066h0l-.006-.005Z",
    transform: "translate(-786.693 -139.45)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.514,203.413h0l-.006-.006Z",
    transform: "translate(-786.234 -139.003)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.706,204.568h0l0,0Z",
    transform: "translate(-787.049 -139.795)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.6,204.467h0l0,0Z",
    transform: "translate(-786.978 -139.725)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.239,204.115h0l-.005-.006Z",
    transform: "translate(-786.729 -139.484)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.291,204.165h0l0-.005Z",
    transform: "translate(-786.765 -139.518)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.344,204.217h0l0,0Z",
    transform: "translate(-786.802 -139.554)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.444,204.316h0l-.006-.005Z",
    transform: "translate(-786.87 -139.621)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.394,204.267h0l-.006-.005Z",
    transform: "translate(-786.835 -139.588)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.549,204.417h0l-.005-.005Z",
    transform: "translate(-786.942 -139.691)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.634,202.561h.006l-.008-.008Z",
    transform: "translate(-785.633 -138.42)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.582,202.51h0l-.008-.008Z",
    transform: "translate(-785.596 -138.386)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.686,202.612h.006l-.008-.008Z",
    transform: "translate(-785.667 -138.455)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.529,202.46h.006l-.009-.008Z",
    transform: "translate(-785.56 -138.351)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.789,202.711h.005l-.008-.008Z",
    transform: "translate(-785.738 -138.523)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.737,202.66h.005l-.008-.008Z",
    transform: "translate(-785.702 -138.488)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.479,202.411h.005l-.008-.008Z",
    transform: "translate(-785.526 -138.318)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.322,202.259h.006l-.009-.008Z",
    transform: "translate(-785.419 -138.213)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.84,202.761h0l-.008-.007Z",
    transform: "translate(-785.773 -138.558)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.271,202.209h.006l-.008-.008Z",
    transform: "translate(-785.384 -138.18)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.375,202.31h.006l-.008-.008Z",
    transform: "translate(-785.455 -138.248)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.427,202.36h.006l-.008-.008Z",
    transform: "translate(-785.491 -138.283)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.256,203.163h0l-.006-.006Z",
    transform: "translate(-786.057 -138.833)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.461,203.362h0l-.006-.006Z",
    transform: "translate(-786.198 -138.969)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.305,203.212h.005l-.008-.007Z",
    transform: "translate(-786.091 -138.866)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.411,203.313h0l-.006-.006Z",
    transform: "translate(-786.163 -138.935)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.2,203.113h.005l-.007-.007Z",
    transform: "translate(-786.021 -138.798)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.358,203.263h.005l-.008-.007Z",
    transform: "translate(-786.127 -138.901)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.047,202.963h.005l-.008-.007Z",
    transform: "translate(-785.914 -138.695)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.151,203.062h.005l-.008-.007Z",
    transform: "translate(-785.985 -138.763)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.944,202.861h.005l-.008-.007Z",
    transform: "translate(-785.844 -138.626)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150,202.913h0l-.006-.006Z",
    transform: "translate(-785.881 -138.662)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.892,202.811h.005l-.007-.008Z",
    transform: "translate(-785.809 -138.591)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.1,203.011h.005L1150.1,203Z",
    transform: "translate(-785.949 -138.728)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.772,203.664h0l-.006-.006Z",
    transform: "translate(-786.41 -139.175)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.154,205.971h0l0,0Z",
    transform: "translate(-788.039 -140.754)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.568,206.373h0l0,0Z",
    transform: "translate(-788.322 -141.029)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.518,206.324h0l0,0Z",
    transform: "translate(-788.287 -140.996)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.723,206.523h0l0,0Z",
    transform: "translate(-788.427 -141.132)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.465,206.273h0l0,0Z",
    transform: "translate(-788.251 -140.961)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.672,206.474h0l0,0Z",
    transform: "translate(-788.393 -141.098)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.621,206.425h0Z",
    transform: "translate(-788.358 -141.065)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.414,206.223h0l0,0Z",
    transform: "translate(-788.216 -140.926)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.207,206.023h0l0,0Z",
    transform: "translate(-788.075 -140.79)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.26,206.074h0l0,0Z",
    transform: "translate(-788.111 -140.825)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.361,206.172h0l0,0Z",
    transform: "translate(-788.18 -140.891)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.31,206.122h0l0,0Z",
    transform: "translate(-788.146 -140.858)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.776,206.574h0l0,0Z",
    transform: "translate(-788.463 -141.166)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.139,206.924h0Z",
    transform: "translate(-788.712 -141.407)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.241,207.026h0Z",
    transform: "translate(-788.781 -141.476)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.191,206.977h0Z",
    transform: "translate(-788.748 -141.443)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.346,207.125h0Z",
    transform: "translate(-788.853 -141.544)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.3,207.076h0Z",
    transform: "translate(-788.819 -141.511)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.83,206.625Z",
    transform: "translate(-788.501 -141.202)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.879,206.674h0Z",
    transform: "translate(-788.534 -141.236)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.086,206.876h0Z",
    transform: "translate(-788.676 -141.373)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.93,206.724h0l0,0Z",
    transform: "translate(-788.569 -141.269)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.984,206.775h0Z",
    transform: "translate(-788.606 -141.305)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.033,206.825h0Z",
    transform: "translate(-788.64 -141.338)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.222,205.069h0l0,0Z",
    transform: "translate(-787.401 -140.136)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.275,205.119h0l0,0Z",
    transform: "translate(-787.437 -140.171)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.86,204.717h0l0,0Z",
    transform: "translate(-787.154 -139.896)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.326,205.168h0l0,0Z",
    transform: "translate(-787.472 -140.204)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.171,205.019h0l0,0Z",
    transform: "translate(-787.367 -140.103)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.429,205.269h0l0,0Z",
    transform: "translate(-787.543 -140.274)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.376,205.218h0l0,0Z",
    transform: "translate(-787.507 -140.239)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.118,204.969h0l0,0Z",
    transform: "translate(-787.331 -140.068)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.1,205.922h0l0,0Z",
    transform: "translate(-788.004 -140.721)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.484,205.321h0l0,0Z",
    transform: "translate(-787.581 -140.31)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.913,204.769h0l0,0Z",
    transform: "translate(-787.19 -139.932)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.015,204.868h0l0,0Z",
    transform: "translate(-787.26 -139.999)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.068,204.918h0l0,0Z",
    transform: "translate(-787.296 -140.033)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.964,204.818h0l0,0Z",
    transform: "translate(-787.225 -139.965)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.895,205.72h0l0,0Z",
    transform: "translate(-787.861 -140.582)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.949,205.772h0l0,0Z",
    transform: "translate(-787.898 -140.618)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.844,205.671h0l0,0Z",
    transform: "translate(-787.826 -140.549)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.052,205.873h0l0,0Z",
    transform: "translate(-787.969 -140.687)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153,205.821h0l0,0Z",
    transform: "translate(-787.932 -140.651)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.584,205.419h0l0,0Z",
    transform: "translate(-787.648 -140.376)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.636,205.471h0l0,0Z",
    transform: "translate(-787.684 -140.412)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.534,205.37h0l0,0Z",
    transform: "translate(-787.615 -140.343)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.791,205.62h0l0,0Z",
    transform: "translate(-787.79 -140.514)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.74,205.571h0l0,0Z",
    transform: "translate(-787.755 -140.481)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.689,205.52h0l0,0Z",
    transform: "translate(-787.721 -140.446)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.268,199.3h.009l-.013-.014Z",
    transform: "translate(-783.331 -136.186)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.958,199h.009l-.013-.013Z",
    transform: "translate(-783.118 -135.982)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.7,198.745h.01l-.014-.014Z",
    transform: "translate(-782.94 -135.808)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.647,198.7h.01l-.014-.014Z",
    transform: "translate(-782.906 -135.775)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.8,198.847h.01l-.015-.014Z",
    transform: "translate(-783.011 -135.878)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.336,198.4h.01l-.015-.014Z",
    transform: "translate(-782.693 -135.57)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.9,198.948h.01l-.014-.014Z",
    transform: "translate(-783.082 -135.947)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.75,198.8h.01l-.014-.014Z",
    transform: "translate(-782.977 -135.844)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.44,198.5h.01l-.014-.014Z",
    transform: "translate(-782.764 -135.639)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.389,198.446h.009l-.013-.014Z",
    transform: "translate(-782.73 -135.604)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.49,198.546h.01l-.015-.014Z",
    transform: "translate(-782.799 -135.672)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.594,198.646h.01l-.014-.014Z",
    transform: "translate(-782.87 -135.74)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.543,198.6h.009l-.014-.014Z",
    transform: "translate(-782.835 -135.707)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.854,198.9h.01l-.014-.014Z",
    transform: "translate(-783.047 -135.912)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.475,199.5h.009l-.013-.013Z",
    transform: "translate(-783.472 -136.325)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.37,199.4h.009l-.013-.013Z",
    transform: "translate(-783.4 -136.255)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.424,199.45h.009l-.013-.012Z",
    transform: "translate(-783.437 -136.291)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.528,199.55h.008l-.012-.012Z",
    transform: "translate(-783.508 -136.359)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.579,199.6h.008l-.012-.012Z",
    transform: "translate(-783.543 -136.393)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.113,199.148h.009l-.013-.013Z",
    transform: "translate(-783.225 -136.085)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.321,199.349h.009l-.013-.013Z",
    transform: "translate(-783.367 -136.222)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.008,199.047h.01l-.014-.014Z",
    transform: "translate(-783.153 -136.015)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.059,199.1h.009l-.013-.014Z",
    transform: "translate(-783.188 -136.049)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.163,199.2h.01l-.014-.014Z",
    transform: "translate(-783.258 -136.118)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.168,202.109h.006l-.008-.008Z",
    transform: "translate(-785.313 -138.111)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.145,197.243h.012l0,.015h.011l-.032-.031Z",
    transform: "translate(-781.88 -134.781)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.4,197.493h.011l.005.016h.011l-.033-.032Z",
    transform: "translate(-782.056 -134.952)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.507,197.593h.011l-.016-.016Z",
    transform: "translate(-782.127 -135.02)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.611,197.694h.01l-.016-.015Z",
    transform: "translate(-782.198 -135.089)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.3,197.392h.011l.005.016h.011l-.032-.032Z",
    transform: "translate(-781.985 -134.882)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.559,197.642h.011l-.016-.016Z",
    transform: "translate(-782.162 -135.053)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.663,197.743h.011l-.016-.016Z",
    transform: "translate(-782.234 -135.123)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.244,7.433h-.012l-.005-.016h-.01l-.006-.016h-.011l-.006-.015h-.011l-.005-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.005-.016h-.011l-.005-.015h-.011l-.006-.016h-.01l-.006-.016H1134L1134,7.2h-.011l-.006-.015h-.01l-.006-.016h-.011l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.01L1133.9,7.1h-.011l-.005-.016h-.011l-.005-.016h-.011l-.006-.016h-.01l-.006-.015h-.011l-.005-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.005-.016h-.011l-.005-.016h-.011l-.006-.016h-.01l-.005-.016h-.011l-.005-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.006-.016h-.011l-.005-.016h-.011l-.005-.016h-.01l-.006-.016h-.011l-.005-.015h-.011l-.005-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.005-.016h-.011l-.005-.016h-.011l-.006-.016h-.011l-.005-.016h-.011l-.005-.016h-.011l-.005-.016h-.011l-.006-.015h-.01l-.006-.016h-.011l-.005-.016h-.011l-.005-.016h-.01l-.006-.016h-.011l-.006-.015h-.011l0-.016h-.011l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.011l-.005-.015h-.011l-.005-.016h-.011l-.006-.016h-.011l-.005-.016h-.011l-.005-.016H1133L1133,6.23h-.01l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.01l-.006-.015h-.011l-.005-.016h-.012l-.005-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l0-.015h-.011l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.011l-.006-.015h-.01l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.011l-.005-.016h-.011l-.006-.015h-.011l-.005-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l0-.016h-.011l-.006-.016h-.011l-.006-.016h-.011l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.011l-.005-.016h-.011l-.006-.015h-.01l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.005-.016h-.011l-.005-.016h-.011l-.006-.016h-.01l-.006-.016h-.011L1132,5.264h-.011l-.006-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.01l-.006-.015h-.011l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.005-.015h-.012l-.005-.016h-.01L1131.722,5h-.011l-.006-.016h-.011l-.005-.015h-.011l-.006-.016h-.01l-.005-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.005-.016h-.012l-.005-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.01l-.005-.016h-.011l-.005-.016h-.012l-.005-.015h-.011l-.006-.016h-.01l-.006-.016h-.011l-.005-.016h-.011l-.006-.015h-.011l-.006-.016h-.011l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.01l-.006-.015h-.011l-.005-.016h-.012l-.005-.016h-.011l-.006-.016h-.01l-.006-.016h-.011l-.005-.016h-.011l-.006-.016h-.011l-.006-.016h-.011l-.006-.016h-.011l-.005-.016h-.011L1131,4.3h-.01l-.005-.016h-.011l-.005-.016h-.012l21.359,61.064,3.292,3.182Z",
    transform: "translate(-772.87 -2.915)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.042,197.142h.011l-.016-.016Z",
    transform: "translate(-781.809 -134.712)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.093,197.191h.011l-.016-.016Z",
    transform: "translate(-781.844 -134.745)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.249,197.343h.012l-.016-.016Z",
    transform: "translate(-781.951 -134.849)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.629,199.649h.009l-.013-.012Z",
    transform: "translate(-783.578 -136.427)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.232,198.295h.01l-.015-.015Z",
    transform: "translate(-782.623 -135.5)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.128,198.194h.011l-.016-.016Z",
    transform: "translate(-782.551 -135.431)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.078,198.145h.01l-.015-.015Z",
    transform: "translate(-782.517 -135.397)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.024,198.094h.01l-.015-.015Z",
    transform: "translate(-782.48 -135.363)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.285,198.345h.01l-.014-.014Z",
    transform: "translate(-782.659 -135.535)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.716,197.795h.011l-.015-.014Z",
    transform: "translate(-782.27 -135.159)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.18,198.246h.01l-.016-.014Z",
    transform: "translate(-782.587 -135.467)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.973,198.045h.01l-.015-.015Z",
    transform: "translate(-782.445 -135.329)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.818,197.895h.011l-.016-.015Z",
    transform: "translate(-782.339 -135.227)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.766,197.844h.01l-.015-.015Z",
    transform: "translate(-782.303 -135.192)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.871,197.944h.01l-.015-.015Z",
    transform: "translate(-782.375 -135.26)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.92,197.994h.011l-.016-.015Z",
    transform: "translate(-782.409 -135.295)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.216,199.248h.009l-.013-.013Z",
    transform: "translate(-783.295 -136.153)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.39,201.356h.007l-.01-.009Z",
    transform: "translate(-784.781 -137.596)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.339,201.305h.007l-.01-.01Z",
    transform: "translate(-784.747 -137.56)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.925,200.9h.007l-.01-.01Z",
    transform: "translate(-784.464 -137.285)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.288,201.257h.007l-.01-.009Z",
    transform: "translate(-784.712 -137.528)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.545,201.5h.007l-.01-.01Z",
    transform: "translate(-784.887 -137.696)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.494,201.456h.006l-.01-.01Z",
    transform: "translate(-784.852 -137.664)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.6,201.557h.006l-.01-.009Z",
    transform: "translate(-784.923 -137.733)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.976,200.954h.008l-.011-.01Z",
    transform: "translate(-784.498 -137.32)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.029,201h.008l-.011-.01Z",
    transform: "translate(-784.534 -137.355)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.183,201.155h.008l-.011-.01Z",
    transform: "translate(-784.64 -137.458)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.082,201.057h.006l-.01-.009Z",
    transform: "translate(-784.57 -137.392)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.132,201.106h.007l-.01-.009Z",
    transform: "translate(-784.605 -137.425)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.443,201.407h.006l-.01-.01Z",
    transform: "translate(-784.818 -137.63)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.064,202.009h.006l-.008-.008Z",
    transform: "translate(-785.242 -138.043)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.96,201.908h.006l-.009-.009Z",
    transform: "translate(-785.171 -137.973)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.013,201.959h.006l-.009-.009Z",
    transform: "translate(-785.208 -138.008)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.682,199.7h.009l-.013-.012Z",
    transform: "translate(-783.614 -136.462)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.114,202.057h.006l-.009-.01Z",
    transform: "translate(-785.276 -138.075)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.652,201.609h.006l-.009-.008Z",
    transform: "translate(-784.961 -137.769)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.752,201.707h.006l-.009-.009Z",
    transform: "translate(-785.029 -137.836)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.7,201.658h.006l-.01-.009Z",
    transform: "translate(-784.994 -137.803)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.857,201.808h.007l-.01-.009Z",
    transform: "translate(-785.101 -137.905)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.908,201.859h.006l-.009-.008Z",
    transform: "translate(-785.136 -137.94)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.806,201.758h.006l-.009-.009Z",
    transform: "translate(-785.066 -137.871)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.236,201.206h.006l-.01-.01Z",
    transform: "translate(-784.676 -137.493)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.993,200H1147l-.012-.012Z",
    transform: "translate(-783.826 -136.669)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.1,200.1h.008l-.012-.012Z",
    transform: "translate(-783.897 -136.737)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.305,200.3h.007l-.011-.011Z",
    transform: "translate(-784.04 -136.874)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.148,200.151h.008l-.012-.012Z",
    transform: "translate(-783.932 -136.77)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.2,200.2h.008l-.012-.012Z",
    transform: "translate(-783.967 -136.805)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.251,200.252h.008l-.011-.011Z",
    transform: "translate(-784.003 -136.84)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.044,200.051h.008l-.012-.012Z",
    transform: "translate(-783.861 -136.702)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.94,199.95h.008l-.012-.012Z",
    transform: "translate(-783.79 -136.633)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.786,199.8h.008l-.012-.012Z",
    transform: "translate(-783.685 -136.53)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.735,199.75h.008l-.011-.012Z",
    transform: "translate(-783.65 -136.497)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.837,199.849h.009l-.013-.013Z",
    transform: "translate(-783.72 -136.564)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.889,199.9h.008l-.011-.012Z",
    transform: "translate(-783.756 -136.6)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.666,200.654h.007l-.011-.011Z",
    transform: "translate(-784.286 -137.115)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.613,200.6h.007l-.011-.011Z",
    transform: "translate(-784.25 -137.08)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.718,200.7h.008l-.011-.01Z",
    transform: "translate(-784.322 -137.149)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.874,200.854h.007l-.01-.01Z",
    transform: "translate(-784.429 -137.252)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.767,200.752h.008l-.012-.012Z",
    transform: "translate(-784.355 -137.181)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.356,200.352h.008l-.011-.012Z",
    transform: "translate(-784.075 -136.908)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.82,200.8h.007l-.011-.01Z",
    transform: "translate(-784.391 -137.217)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.509,200.5h.008l-.012-.012Z",
    transform: "translate(-784.179 -137.011)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.563,200.554h.007l-.01-.01Z",
    transform: "translate(-784.216 -137.047)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.458,200.453h.008l-.011-.011Z",
    transform: "translate(-784.144 -136.977)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.406,200.4h.008l-.011-.012Z",
    transform: "translate(-784.108 -136.941)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.18,160.671l3.292,3.182h18.664l-1.022-3.182Z",
    transform: "translate(-728.603 -109.799)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.306,200.527l.016.016.005-.016Z",
    transform: "translate(-687.687 -137.036)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.2,200.426l.016.015.005-.015Z",
    transform: "translate(-687.614 -136.966)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.253,200.477l.016.016.005-.016Z",
    transform: "translate(-687.65 -137.001)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.15,200.377l.016.015.006-.015Z",
    transform: "translate(-687.58 -136.933)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.357,200.576l.016.015.006-.015Z",
    transform: "translate(-687.721 -137.069)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.408,200.627l.016.016.005-.016Z",
    transform: "translate(-687.756 -137.104)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.564,200.777l.016.015.005-.015Z",
    transform: "translate(-687.863 -137.207)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.1,200.326l.016.016.006-.016Z",
    transform: "translate(-687.544 -136.898)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.666,200.877l.016.016.006-.016Z",
    transform: "translate(-687.932 -137.275)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.511,200.726l.016.016.006-.016Z",
    transform: "translate(-687.827 -137.172)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.46,200.678l.015.015.006-.015Z",
    transform: "translate(-687.792 -137.139)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.615,200.826l.016.016.005-.016Z",
    transform: "translate(-687.897 -137.24)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.891,200.127l.016.015.006-.015Z",
    transform: "translate(-687.403 -136.762)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.581,199.826l.016.016.006-.016Z",
    transform: "translate(-687.191 -136.557)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.682,199.926l.016.016.006-.016Z",
    transform: "translate(-687.26 -136.625)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.634,199.877l.015.016.005-.016Z",
    transform: "translate(-687.227 -136.592)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.716,200.926l.016.016.006-.016Z",
    transform: "translate(-687.967 -137.308)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.493,199.742l.005-.015h-.021l.032.031.005-.016Z",
    transform: "translate(-687.12 -136.489)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.942,200.176l.016.016.006-.016Z",
    transform: "translate(-687.438 -136.796)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.044,200.275l.017.016.005-.016Z",
    transform: "translate(-687.507 -136.864)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006,200.227l.015.016.005-.016Z",
    transform: "translate(-687.474 -136.83)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.735,199.977l.016.016.005-.016Z",
    transform: "translate(-687.296 -136.66)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.839,200.076l.016.016.005-.016Z",
    transform: "translate(-687.367 -136.728)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.788,200.028l.015.015.006-.015Z",
    transform: "translate(-687.333 -136.694)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.7,201.876l.016.016.006-.016Z",
    transform: "translate(-688.64 -137.958)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.805,201.978l.016.015.006-.015Z",
    transform: "translate(-688.711 -138.027)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.753,201.927l.016.016,0-.016Z",
    transform: "translate(-688.675 -137.992)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.6,201.777l.016.016.005-.016Z",
    transform: "translate(-688.57 -137.89)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.649,201.828l.016.016.006-.016Z",
    transform: "translate(-688.604 -137.924)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.494,201.677l.016.015.006-.015Z",
    transform: "translate(-688.499 -137.822)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.442,201.626l.016.016.006-.016Z",
    transform: "translate(-688.463 -137.787)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.545,201.726l.016.016.005-.016Z",
    transform: "translate(-688.533 -137.855)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.769,200.976l.016.016.005-.016Z",
    transform: "translate(-688.003 -137.343)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.424,199.676l.016.016.005-.016Z",
    transform: "translate(-687.084 -136.454)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.856,202.027l.016.016.006-.016Z",
    transform: "translate(-688.746 -138.061)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.96,202.126l.016.016,0-.016Z",
    transform: "translate(-688.817 -138.129)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.909,202.077l.015.015.005-.015Z",
    transform: "translate(-688.782 -138.095)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.011,202.177l.016.015.006-.015Z",
    transform: "translate(-688.851 -138.163)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.389,201.576l.017.016.005-.016Z",
    transform: "translate(-688.427 -137.752)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.979,201.177l.016.015.005-.015Z",
    transform: "translate(-688.146 -137.48)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.08,201.277l.016.016.006-.016Z",
    transform: "translate(-688.216 -137.548)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.926,201.127l.016.016.006-.016Z",
    transform: "translate(-688.11 -137.445)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.838,201.042l.005-.016h-.021l.032.031.005-.016Z",
    transform: "translate(-688.039 -137.377)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.061,202.226l.016.016.006-.016Z",
    transform: "translate(-688.886 -138.197)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.34,201.527l.016.016.005-.016Z",
    transform: "translate(-688.393 -137.719)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.287,201.476l.015.016.006-.016Z",
    transform: "translate(-688.357 -137.684)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.237,201.427l.016.015.006-.015Z",
    transform: "translate(-688.322 -137.651)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.184,201.377l.016.016.005-.016Z",
    transform: "translate(-688.286 -137.616)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.133,201.328l.016.015.006-.015Z",
    transform: "translate(-688.252 -137.583)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.027,201.226l.016.016.006-.016Z",
    transform: "translate(-688.179 -137.513)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.72,198.026l.016.016.005-.016Z",
    transform: "translate(-685.919 -135.327)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.029,198.327l.015.015.006-.015Z",
    transform: "translate(-686.13 -135.532)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.667,197.976l.016.016.006-.016Z",
    transform: "translate(-685.883 -135.292)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.563,197.876l.016.016.005-.016Z",
    transform: "translate(-685.812 -135.224)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.51,197.825l.016.016.006-.016Z",
    transform: "translate(-685.776 -135.189)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.46,197.777l.016.015.006-.015Z",
    transform: "translate(-685.741 -135.156)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.771,198.077l.016.015.006-.015Z",
    transform: "translate(-685.954 -135.361)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.927,198.228l.016.016.005-.016Z",
    transform: "translate(-686.061 -135.464)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.976,198.276l.017.016.005-.016Z",
    transform: "translate(-686.094 -135.497)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.874,198.177l.015.016.006-.016Z",
    transform: "translate(-686.025 -135.429)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.821,198.126l.016.016.005-.016Z",
    transform: "translate(-685.989 -135.395)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.407,197.726l.016.016.006-.016Z",
    transform: "translate(-685.705 -135.121)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.616,197.927l.016.016.005-.016Z",
    transform: "translate(-685.848 -135.259)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.992,197.326l.016.016.006-.016Z",
    transform: "translate(-685.422 -134.848)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.944,197.277l.016.016.005-.016Z",
    transform: "translate(-685.389 -134.814)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.838,197.175l.016.016.006-.016Z",
    transform: "translate(-685.317 -134.745)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.891,197.226l.016.016.006-.016Z",
    transform: "translate(-685.353 -134.78)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.045,197.376l.016.016.005-.016Z",
    transform: "translate(-685.458 -134.882)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.149,197.476l.016.016.005-.016Z",
    transform: "translate(-685.529 -134.951)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.305,197.626l.016.016.006-.016Z",
    transform: "translate(-685.636 -135.053)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.255,197.577l.015.015.006-.015Z",
    transform: "translate(-685.601 -135.02)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.358,197.677l.016.016.005-.016Z",
    transform: "translate(-685.672 -135.088)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.1,197.427l.016.015.006-.015Z",
    transform: "translate(-685.494 -134.917)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.2,197.527l.016.016.005-.016Z",
    transform: "translate(-685.565 -134.985)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.443,198.727l.016.015.006-.015Z",
    transform: "translate(-686.413 -135.806)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.908,199.176l.016.016.005-.016Z",
    transform: "translate(-686.731 -136.113)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.961,199.227l.015.016.005-.016Z",
    transform: "translate(-686.768 -136.147)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.063,199.327l.016.016.005-.016Z",
    transform: "translate(-686.837 -136.215)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.012,199.276l.015.016.006-.016Z",
    transform: "translate(-686.802 -136.181)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.855,199.126l.016.016.005-.016Z",
    transform: "translate(-686.695 -136.078)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.8,199.077l.016.015.006-.015Z",
    transform: "translate(-686.66 -136.045)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.079,198.376l.016.016.006-.016Z",
    transform: "translate(-686.165 -135.566)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.272,199.528l.016.016.005-.016Z",
    transform: "translate(-686.98 -136.353)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.752,199.026l.016.016.006-.016Z",
    transform: "translate(-686.624 -136.01)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.219,199.477l.016.016.006-.016Z",
    transform: "translate(-686.944 -136.318)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.166,199.426l.016.016.005-.016Z",
    transform: "translate(-686.908 -136.283)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.115,199.377l.016.015.006-.015Z",
    transform: "translate(-686.873 -136.25)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.321,199.577l.016.015.006-.015Z",
    transform: "translate(-687.013 -136.386)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.289,198.577l.016.016.005-.016Z",
    transform: "translate(-686.308 -135.703)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.7,198.977l.016.016.005-.016Z",
    transform: "translate(-686.591 -135.977)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.337,198.626l.016.016.006-.016Z",
    transform: "translate(-686.341 -135.736)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.236,198.526l.016.016.006-.016Z",
    transform: "translate(-686.272 -135.668)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.148,198.442l.005-.016h-.021l.032.031.006-.016Z",
    transform: "translate(-686.201 -135.6)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.39,198.677l.016.016.005-.016Z",
    transform: "translate(-686.377 -135.771)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.373,199.625l.015.016.006-.016Z",
    transform: "translate(-687.049 -136.419)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.6,198.878l.015.015.006-.015Z",
    transform: "translate(-686.52 -135.908)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.65,198.926l.015.016.006-.016Z",
    transform: "translate(-686.555 -135.942)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.494,198.776l.016.016.005-.016Z",
    transform: "translate(-686.448 -135.839)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.547,198.827l.016.016.005-.016Z",
    transform: "translate(-686.484 -135.874)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.857,204.928l.016.016.006-.016Z",
    transform: "translate(-690.796 -140.043)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.529,205.578l.015.016.006-.016Z",
    transform: "translate(-691.256 -140.487)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.477,205.527l.016.016.005-.016Z",
    transform: "translate(-691.22 -140.453)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.375,205.428l.016.016.006-.016Z",
    transform: "translate(-691.151 -140.385)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.58,205.627l.016.016.005-.016Z",
    transform: "translate(-691.291 -140.521)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.424,205.477l.016.016.006-.016Z",
    transform: "translate(-691.184 -140.418)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.891,205.927l.016.016.006-.016Z",
    transform: "translate(-691.503 -140.726)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.6,204.676l.016.016.006-.016Z",
    transform: "translate(-690.619 -139.871)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.838,205.877l.016.015.006-.015Z",
    transform: "translate(-691.467 -140.691)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.633,205.678l.016.016.005-.016Z",
    transform: "translate(-691.327 -140.555)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.735,205.777l.016.016.006-.016Z",
    transform: "translate(-691.396 -140.623)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.322,205.377l.016.016.006-.016Z",
    transform: "translate(-691.114 -140.35)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.684,205.728l.016.016.005-.016Z",
    transform: "translate(-691.362 -140.59)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.8,204.877l.016.016.005-.016Z",
    transform: "translate(-690.76 -140.008)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.751,204.826l.016.016.006-.016Z",
    transform: "translate(-690.724 -139.974)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.908,204.977l.016.016.005-.016Z",
    transform: "translate(-690.831 -140.076)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.648,204.727l.017.016.005-.016Z",
    transform: "translate(-690.653 -139.906)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.7,204.778l.016.016.006-.016Z",
    transform: "translate(-690.689 -139.94)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.013,205.078l.016.016.005-.016Z",
    transform: "translate(-690.903 -140.146)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.96,205.027l.016.016.006-.016Z",
    transform: "translate(-690.867 -140.111)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.166,205.227l.016.016.006-.016Z",
    transform: "translate(-691.008 -140.247)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.115,205.178l.016.015.006-.015Z",
    transform: "translate(-690.973 -140.214)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.234,205.293l.005-.016h-.021l.032.031.006-.016Z",
    transform: "translate(-691.043 -140.282)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.062,205.127l.016.016.006-.016Z",
    transform: "translate(-690.937 -140.179)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.787,205.828l.016.016.005-.016Z",
    transform: "translate(-691.432 -140.658)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.821,206.827l.016.016,0-.016Z",
    transform: "translate(-692.139 -141.341)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.874,206.878l.016.016.006-.016Z",
    transform: "translate(-692.175 -141.376)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.769,206.777l.016.016.006-.016Z",
    transform: "translate(-692.103 -141.306)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.72,206.728l.016.016.005-.016Z",
    transform: "translate(-692.07 -141.273)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.667,206.677l.016.016.006-.016Z",
    transform: "translate(-692.034 -141.238)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.942,205.976l.016.016.006-.016Z",
    transform: "translate(-691.538 -140.759)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.079,207.077l.016.016.006-.016Z",
    transform: "translate(-692.315 -141.512)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.132,207.128l.016.016.005-.016Z",
    transform: "translate(-692.351 -141.547)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.925,206.927l.016.016.005-.016Z",
    transform: "translate(-692.21 -141.409)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.579,206.593l.005-.016h-.021l.032.031.006-.016Z",
    transform: "translate(-691.963 -141.17)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.978,206.978l.016.015.005-.015Z",
    transform: "translate(-692.246 -141.444)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.029,207.029l.016.016.005-.016Z",
    transform: "translate(-692.281 -141.479)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.149,206.177l.016.016.005-.016Z",
    transform: "translate(-691.68 -140.897)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.2,206.228l.016.016.006-.016Z",
    transform: "translate(-691.716 -140.932)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.511,206.527l.016.016.006-.016Z",
    transform: "translate(-691.927 -141.136)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.045,206.078l.016.016.006-.016Z",
    transform: "translate(-691.609 -140.829)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.993,206.027l.017.016.005-.016Z",
    transform: "translate(-691.573 -140.794)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.1,206.127l.016.016.006-.016Z",
    transform: "translate(-691.643 -140.862)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.407,206.427l.016.016.006-.016Z",
    transform: "translate(-691.856 -141.068)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.46,206.478l.015.015.006-.015Z",
    transform: "translate(-691.892 -141.102)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.358,206.378l.016.015.005-.015Z",
    transform: "translate(-691.823 -141.034)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.253,206.277l.016.016.005-.016Z",
    transform: "translate(-691.75 -140.965)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.305,206.328l.016.016.006-.016Z",
    transform: "translate(-691.786 -141)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.563,203.676l.016.016.006-.016Z",
    transform: "translate(-689.912 -139.188)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.89,203.026l.016.015.005-.015Z",
    transform: "translate(-689.453 -138.744)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.943,203.077l.016.016.005-.016Z",
    transform: "translate(-689.489 -138.778)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.787,202.927l.016.016.006-.016Z",
    transform: "translate(-689.382 -138.676)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.734,202.876l.017.016.005-.016Z",
    transform: "translate(-689.346 -138.641)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.994,203.128l.016.016.006-.016Z",
    transform: "translate(-689.523 -138.813)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.839,202.978l.016.016.006-.016Z",
    transform: "translate(-689.418 -138.71)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.252,203.376l.016.016.006-.016Z",
    transform: "translate(-689.7 -138.982)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.2,203.327l.016.016.006-.016Z",
    transform: "translate(-689.665 -138.949)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.047,203.177l.015.016.006-.016Z",
    transform: "translate(-689.56 -138.846)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.15,203.278l.016.015.006-.015Z",
    transform: "translate(-689.63 -138.916)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.1,203.228l.016.016.005-.016Z",
    transform: "translate(-689.594 -138.881)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.372,202.526l.016.016.006-.016Z",
    transform: "translate(-689.098 -138.402)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.323,202.478l.016.016.005-.016Z",
    transform: "translate(-689.065 -138.369)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.685,202.827l.016.016.006-.016Z",
    transform: "translate(-689.312 -138.607)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.167,202.327l.016.015.006-.015Z",
    transform: "translate(-688.958 -138.266)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.3,203.427l.016.016.005-.016Z",
    transform: "translate(-689.736 -139.017)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.218,202.376l.016.016.006-.016Z",
    transform: "translate(-688.993 -138.299)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.271,202.427l.016.016.006-.016Z",
    transform: "translate(-689.029 -138.334)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.582,202.728l.016.015.006-.015Z",
    transform: "translate(-689.242 -138.539)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.632,202.776l.016.016.006-.016Z",
    transform: "translate(-689.276 -138.573)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.529,202.677l.016.016.005-.016Z",
    transform: "translate(-689.205 -138.505)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.478,202.628l.016.015.005-.015Z",
    transform: "translate(-689.171 -138.471)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.425,202.577l.016.016.006-.016Z",
    transform: "translate(-689.135 -138.437)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.288,204.377l.016.016.005-.016Z",
    transform: "translate(-690.408 -139.667)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.132,204.227l.016.016.006-.016Z",
    transform: "translate(-690.301 -139.564)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.184,204.278l.016.016.006-.016Z",
    transform: "translate(-690.337 -139.599)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.03,204.128l.016.016.006-.016Z",
    transform: "translate(-690.232 -139.496)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.339,204.428l.016.016.005-.016Z",
    transform: "translate(-690.443 -139.702)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.079,204.176l.017.016.005-.016Z",
    transform: "translate(-690.265 -139.529)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.977,204.077l.016.016.006-.016Z",
    transform: "translate(-690.195 -139.461)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.493,204.576l.016.016.006-.016Z",
    transform: "translate(-690.548 -139.803)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.356,203.477l.016.016.006-.016Z",
    transform: "translate(-689.771 -139.052)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.442,204.528l.016.016.005-.016Z",
    transform: "translate(-690.513 -139.77)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.546,204.627l.016.015.006-.015Z",
    transform: "translate(-690.584 -139.838)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.392,204.477l.016.016.006-.016Z",
    transform: "translate(-690.479 -139.735)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.235,204.327l.016.016.005-.016Z",
    transform: "translate(-690.372 -139.632)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.512,203.628l.016.016.006-.016Z",
    transform: "translate(-689.877 -139.155)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.114,202.277l.016.016.006-.016Z",
    transform: "translate(-688.922 -138.231)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.889,203.992l.005-.016h-.021l.032.031.006-.016Z",
    transform: "translate(-690.124 -139.393)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.668,203.778l.016.015.005-.015Z",
    transform: "translate(-689.984 -139.257)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.459,203.577l.016.016.005-.016Z",
    transform: "translate(-689.841 -139.12)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.406,203.526l.016.016.006-.016Z",
    transform: "translate(-689.805 -139.085)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.616,203.727l.016.016.006-.016Z",
    transform: "translate(-689.948 -139.223)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.717,203.827l.016.016.006-.016Z",
    transform: "translate(-690.018 -139.291)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.77,203.878l.016.016.005-.016Z",
    transform: "translate(-690.054 -139.325)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.821,203.926l.016.016.006-.016Z",
    transform: "translate(-690.088 -139.359)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.838,197.142h.022l-.006.016h.022l-.006.016h.022l-.005.015h.022l-.006.016h.022l-.005.015h.022l-.006.015h.022l-.005.015h.022l-.005.015h.022l-.006.015h.022l-.006.016h.022l-.005.016h.022l-.006.015h.022l-.006.015h.023l-.006.015h.022l-.005.016h.021l-.005.015h.022l-.006.016h.022l-.005.016h.022l-.006.015h.022l-.005.016h.022l-.006.015h.022l-.005.016h.022l-.005.016h.021l-.006.015h.022l-.006.015h.022l-.005.016h.022l-.006.016h.022l-.006.016h.022l-.005.016h.022l-.006.015h.022l-.005.016h.022l-.006.015h.022l-.005.016h.022l-.005.015h.021l-.006.015h.023l-.006.016h.022l-.005.016h.022l-.006.016h.022l-.006.015h.022l-.005.016h.022l-.005.016h.021l-.005.016h.022l-.006.015h.022l-.005.015h.022l-.006.015h.022l-.005.016h.022l-.006.016h.022l-.005.015h.022l-.006.016h.022l-.006.016h.022l-.005.016h.022l-.005.016h.021l-.005.015h.022l-.006.016h.022l-.005.016h.022l-.006.016h.022l-.005.015h.022l-.006.015h.022l-.005.016h.022l-.006.015h.022l-.006.015h.022l-.005.015h.022l-.005.016h.022l-.006.016h.022l-.006.015h.022l-.005.015h.022l-.005.016h.021l-.005.016h.022l-.006.016h.022l-.005.016h.022l-.006.015h.022l-.006.016h.022l-.005.015h.022l-.005.016h.022l-.006.015h.022l-.006.016h.022l-.005.016h.022l-.005.016h.021l-.005.016h.022l-.006.015h.022l-.005.016h.022l-.006.016h.022l-.006.016h.022l-.006.015h.022l-.005.016h.022l-.006.015h.022l-.006.016h.022l-.005.016h.022l-.005.016h.022l-.006.016h.022l-.006.015h.022l-.005.016h.022l-.005.015h.022l-.006.016h.022l-.006.016h.022l-.005.016h.022l-.006.015h.022l-.006.015h.022l-.005.015h.022l-.005.016h.022l-.006.016h.022l-.006.015h.022l-.006.016h.022l-.006.015h.022l-.006.016h.022l-.006.016h.022l-.005.015h.022l-.006.016h.023l-.006.016h.021l-.005.015h.022l-.005.015h.022l-.006.015h.022l-.006.016h.022l-.006.016h.022l-.005.016h.022l-.006.015h.022l-.006.016h.022l-.005.016h.022l-.005.016h.022l-.006.015h.022l-.006.015h.022l-.005.016h.022l-.006.015h.022l-.006.016h.023l-.006.015h.022l-.005.016h.022l-.006.016h.022l-.006.016h.022l-.005.015h.022l-.006.016h.022l-.006.016h.022l-.006.016h.022l-.005.016h.022l-.006.015h.022l-.005.016h.022l-.006.016h.022l-.005.015h.022l-.006.015h.022l-.006.015h.023l-.006.016h.022l-.005.016h.022l-.006.016h.022l-.006.015h.022l-.005.016h.022l-.005.016h.021l-.005.016h.022l-.006.015h.022l-.005.015h.022l-.006.016h.022l-.006.016h.023l-.006.016h.022l-.005.016h.022l-.006.016h.022l-.006.016h.022l-.005.016h.022l-.006.016h.022l-.005.015h.022l-.006.016h.022l-.005.016h.022l-.006.016h.022l-.006.015h.023l-.006.016h.022l-.005.016h.022l-.006.016h.022l-.006.016h.022l-.006.015h.022l-.006.016h.022l-.005.016h.022l-.006.016h.022l-.005.015h.022l-.005.016h.021l-.005.016h.022l-.006.016h.022l-.005.015h.022l-.006.015h.022l-.006.016h.022l-.006.016h.022l-.005.016h.022l-.006.015h.022l-.006.016h.022l-.005.016h.022l-.006.016h.022l-.005.016h.022l-.006.015h.022l-.005.016h.022l-.006.016h.022l-.006.015h.022l-.006.015h.022l-.005.016h.022l-.006.016h.022l-.006.016h.022l-.005.016H1006l-.006.015h.022l-.005.016h.022l-.006.016h.022l-.005.016h.022l-.005.015h.021l-.005.016h.022l-.006.016h.022l-.005.016h16.37l-3.292-3.182Z",
    transform: "translate(-685.317 -134.712)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.2,204.077l.011.01,0-.01Z",
    transform: "translate(-786.706 -139.461)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151,203.878l.01.01,0-.01Z",
    transform: "translate(-786.566 -139.325)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.046,203.926l.011.01,0-.01Z",
    transform: "translate(-786.599 -139.359)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.15,204.026l.011.011,0-.011Z",
    transform: "translate(-786.67 -139.427)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.1,203.977l.012.011,0-.011Z",
    transform: "translate(-786.635 -139.393)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.254,204.128l.011.01,0-.01Z",
    transform: "translate(-786.74 -139.496)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.348,202.277l.008.008,0-.008Z",
    transform: "translate(-785.438 -138.231)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.79,203.676l.01.01,0-.01Z",
    transform: "translate(-786.424 -139.188)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.687,203.577l.01.009,0-.009Z",
    transform: "translate(-786.353 -139.12)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.843,203.727l.009.01,0-.01Z",
    transform: "translate(-786.46 -139.223)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.82,204.676l.012.012,0-.012Z",
    transform: "translate(-787.128 -139.871)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.945,203.827l.01.01,0-.01Z",
    transform: "translate(-786.529 -139.291)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.894,203.778l.01.01,0-.01Z",
    transform: "translate(-786.495 -139.257)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.668,204.528l.012.012,0-.012Z",
    transform: "translate(-787.024 -139.77)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.717,204.576l.012.012,0-.012Z",
    transform: "translate(-787.057 -139.803)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.77,204.627l.012.011,0-.011Z",
    transform: "translate(-787.093 -139.838)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.636,203.526l.01.01,0-.01Z",
    transform: "translate(-786.318 -139.085)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.3,204.176l.012.012,0-.012Z",
    transform: "translate(-786.775 -139.529)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.615,204.477l.012.011,0-.011Z",
    transform: "translate(-786.988 -139.735)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.564,204.428l.012.011,0-.011Z",
    transform: "translate(-786.953 -139.702)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.357,204.227l.011.011,0-.011Z",
    transform: "translate(-786.811 -139.564)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.41,204.278l.011.01,0-.01Z",
    transform: "translate(-786.847 -139.599)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.514,204.377l.011.011,0-.011Z",
    transform: "translate(-786.918 -139.667)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.461,204.327l.012.012,0-.012Z",
    transform: "translate(-786.882 -139.632)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.811,202.728l.008.008,0-.008Z",
    transform: "translate(-785.755 -138.539)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.758,202.677l.009.008,0-.008Z",
    transform: "translate(-785.718 -138.505)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.71,202.628l.008.008,0-.008Z",
    transform: "translate(-785.685 -138.471)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.915,202.827l.008.008,0-.008Z",
    transform: "translate(-785.826 -138.607)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.657,202.577l.008.008,0-.008Z",
    transform: "translate(-785.649 -138.437)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.862,202.776l.009.008,0-.008Z",
    transform: "translate(-785.789 -138.573)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.6,202.526l.009.008,0-.008Z",
    transform: "translate(-785.613 -138.402)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.45,202.376l.008.008,0-.008Z",
    transform: "translate(-785.508 -138.299)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.873,204.727l.012.012,0-.012Z",
    transform: "translate(-787.164 -139.906)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.555,202.478l.008.008,0-.008Z",
    transform: "translate(-785.58 -138.369)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.5,202.427l.008.008,0-.008Z",
    transform: "translate(-785.544 -138.334)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.965,202.876l.01.009,0-.009Z",
    transform: "translate(-785.86 -138.641)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.585,203.477l.01.01,0-.01Z",
    transform: "translate(-786.284 -139.052)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.38,203.278l.009.009,0-.009Z",
    transform: "translate(-786.143 -138.916)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.327,203.228l.009.009,0-.009Z",
    transform: "translate(-786.107 -138.881)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.429,203.327l.01.009,0-.009Z",
    transform: "translate(-786.177 -138.949)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.532,203.427l.01.009,0-.009Z",
    transform: "translate(-786.247 -139.017)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.48,203.376l.01.01,0-.01Z",
    transform: "translate(-786.211 -138.982)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.069,202.978l.008.008,0-.008Z",
    transform: "translate(-785.931 -138.71)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.12,203.026l.009.009,0-.009Z",
    transform: "translate(-785.966 -138.744)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.016,202.927l.009.009,0-.009Z",
    transform: "translate(-785.895 -138.676)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.224,203.128l.009.009,0-.009Z",
    transform: "translate(-786.037 -138.813)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.173,203.077l.009.009,0-.009Z",
    transform: "translate(-786.002 -138.778)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.274,203.177l.009.009,0-.009Z",
    transform: "translate(-786.071 -138.846)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.74,203.628l.01.009,0-.009Z",
    transform: "translate(-786.389 -139.155)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.627,206.427l.014.014,0-.014Z",
    transform: "translate(-788.362 -141.068)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.576,206.378l.014.014,0-.014Z",
    transform: "translate(-788.327 -141.034)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.677,206.478l.014.014,0-.014Z",
    transform: "translate(-788.397 -141.102)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.728,206.527l.015.014,0-.014Z",
    transform: "translate(-788.431 -141.136)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.523,206.328l.014.014,0-.014Z",
    transform: "translate(-788.291 -141)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.781,206.578l.015.015-.005-.015Z",
    transform: "translate(-788.468 -141.17)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.47,206.277l.015.014,0-.014Z",
    transform: "translate(-788.255 -140.965)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.83,206.626l.016.015,0-.015Z",
    transform: "translate(-788.501 -141.204)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.316,206.127l.014.014,0-.014Z",
    transform: "translate(-788.15 -140.862)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.265,206.078l.014.014,0-.014Z",
    transform: "translate(-788.115 -140.829)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.419,206.228l.014.014,0-.014Z",
    transform: "translate(-788.22 -140.932)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.369,206.177l.014.014,0-.014Z",
    transform: "translate(-788.186 -140.897)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.3,207.077l.016.015-.005-.015Z",
    transform: "translate(-788.82 -141.512)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.246,207.029l.016.015-.005-.015Z",
    transform: "translate(-788.786 -141.479)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.883,206.677l.015.014,0-.014Z",
    transform: "translate(-788.537 -141.238)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.193,206.978l.015.015,0-.015Z",
    transform: "translate(-788.749 -141.444)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.139,197.226h0Z",
    transform: "translate(-781.878 -134.78)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.358,207.128h-.011l.016.016Z",
    transform: "translate(-788.855 -141.547)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.212,206.027l.015.014,0-.014Z",
    transform: "translate(-788.079 -140.794)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.986,206.777l.015.015,0-.015Z",
    transform: "translate(-788.608 -141.306)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.935,206.728l.016.015-.005-.015Z",
    transform: "translate(-788.573 -141.273)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.039,206.827l.015.015,0-.015Z",
    transform: "translate(-788.644 -141.341)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.141,206.927l.016.016-.005-.016Z",
    transform: "translate(-788.713 -141.409)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.09,206.878l.015.014-.005-.014Z",
    transform: "translate(-788.679 -141.376)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.975,204.826l.012.012,0-.012Z",
    transform: "translate(-787.233 -139.974)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.542,205.377l.013.012,0-.012Z",
    transform: "translate(-787.621 -140.35)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.339,205.178l.012.012,0-.012Z",
    transform: "translate(-787.482 -140.214)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.161,205.976l.014.014,0-.014Z",
    transform: "translate(-788.044 -140.759)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.286,205.127l.012.012,0-.012Z",
    transform: "translate(-787.446 -140.179)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.491,205.326l.014.013,0-.013Z",
    transform: "translate(-787.586 -140.315)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.44,205.277l.014.013,0-.013Z",
    transform: "translate(-787.551 -140.282)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.387,205.227l.013.012,0-.012Z",
    transform: "translate(-787.515 -140.247)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.924,204.778l.012.012,0-.012Z",
    transform: "translate(-787.199 -139.94)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.182,205.027l.012.012,0-.012Z",
    transform: "translate(-787.375 -140.111)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.028,204.877l.012.012,0-.012Z",
    transform: "translate(-787.269 -140.008)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.131,204.977l.012.012,0-.012Z",
    transform: "translate(-787.34 -140.076)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.081,204.928l.011.012,0-.012Z",
    transform: "translate(-787.306 -140.043)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.235,205.078l.012.012,0-.012Z",
    transform: "translate(-787.411 -140.146)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.009,205.828l.014.014,0-.014Z",
    transform: "translate(-787.94 -140.658)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.956,205.777l.013.013,0-.013Z",
    transform: "translate(-787.904 -140.623)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.058,205.877l.014.014,0-.014Z",
    transform: "translate(-787.973 -140.691)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.594,205.428l.013.013,0-.013Z",
    transform: "translate(-787.657 -140.385)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.905,205.728l.014.013,0-.013Z",
    transform: "translate(-787.869 -140.59)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.111,205.927l.014.013,0-.013Z",
    transform: "translate(-788.009 -140.726)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.853,205.678l.013.012,0-.012Z",
    transform: "translate(-787.833 -140.555)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.645,205.477l.014.013,0-.013Z",
    transform: "translate(-787.691 -140.418)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.7,205.527l.013.013,0-.013Z",
    transform: "translate(-787.728 -140.453)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.8,205.627l.013.013,0-.013Z",
    transform: "translate(-787.798 -140.521)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.751,205.578l.012.012,0-.012Z",
    transform: "translate(-787.764 -140.487)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.4,202.327l.008.008,0-.008Z",
    transform: "translate(-785.473 -138.266)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.945,198.977l0,0v0Z",
    transform: "translate(-783.113 -135.977)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.843,198.878l0,0v0Z",
    transform: "translate(-783.043 -135.908)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.532,198.577l0,0v0Z",
    transform: "translate(-782.831 -135.703)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.894,198.926l0,0v0Z",
    transform: "translate(-783.078 -135.942)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.1,199.126l0,0v0Z",
    transform: "translate(-783.217 -136.078)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.15,199.176l0,0v0Z",
    transform: "translate(-783.253 -136.113)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.049,199.077l0,0v0Z",
    transform: "translate(-783.183 -136.045)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.791,198.827l0,0v0Z",
    transform: "translate(-783.007 -135.874)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.583,198.626l0,0v0Z",
    transform: "translate(-782.865 -135.736)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.634,198.677l0,0v0Z",
    transform: "translate(-782.9 -135.771)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.738,198.776l0,0v0Z",
    transform: "translate(-782.971 -135.839)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.687,198.727h0Z",
    transform: "translate(-782.936 -135.806)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146,199.026l0,0v0Z",
    transform: "translate(-783.147 -136.01)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.613,199.625l0,0v0Z",
    transform: "translate(-783.569 -136.419)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.563,199.577l0,0v0Z",
    transform: "translate(-783.535 -136.386)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.719,199.727l0,0v0Z",
    transform: "translate(-783.642 -136.489)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.512,199.528l0,0v0Z",
    transform: "translate(-783.5 -136.353)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.2,199.227l0,0v0Z",
    transform: "translate(-783.289 -136.147)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.666,199.676l0,0v0Z",
    transform: "translate(-783.605 -136.454)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.461,199.477l0,0v0Z",
    transform: "translate(-783.465 -136.318)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.254,199.276l0,0v0Z",
    transform: "translate(-783.324 -136.181)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.3,199.327l0,0v0Z",
    transform: "translate(-783.358 -136.215)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.357,199.377l0,0v0Z",
    transform: "translate(-783.394 -136.25)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.408,199.426l0,0v0Z",
    transform: "translate(-783.429 -136.283)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.173,198.228h0Z",
    transform: "translate(-782.585 -135.464)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.655,197.726h0Z",
    transform: "translate(-782.231 -135.121)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.606,197.677h0Z",
    transform: "translate(-782.198 -135.088)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.708,197.777h0Z",
    transform: "translate(-782.267 -135.156)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.862,197.927h0Z",
    transform: "translate(-782.373 -135.259)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.553,197.626",
    transform: "translate(-782.161 -135.053)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.809,197.876h0Z",
    transform: "translate(-782.336 -135.224)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.758,197.825h0Z",
    transform: "translate(-782.302 -135.189)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.5,197.577",
    transform: "translate(-782.127 -135.02)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.3,197.376",
    transform: "translate(-781.985 -134.882)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.242,197.326h0Z",
    transform: "translate(-781.949 -134.848)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.4,197.476h0Z",
    transform: "translate(-782.055 -134.951)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.088,197.175",
    transform: "translate(-781.844 -134.745)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.913,197.976h0Z",
    transform: "translate(-782.407 -135.292)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.224,198.276h0Z",
    transform: "translate(-782.62 -135.497)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.274,198.327h0Z",
    transform: "translate(-782.654 -135.532)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.325,198.376l0,0v0Z",
    transform: "translate(-782.689 -135.566)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.378,198.427l0,0v0Z",
    transform: "translate(-782.725 -135.6)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.427,198.475l0,0v0Z",
    transform: "translate(-782.759 -135.634)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.016,198.077h0Z",
    transform: "translate(-782.478 -135.361)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.768,199.776l0,0v0Z",
    transform: "translate(-783.675 -136.522)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.966,198.026h0Z",
    transform: "translate(-782.443 -135.327)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.48,198.526l0,0v0Z",
    transform: "translate(-782.795 -135.668)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.12,198.177h0Z",
    transform: "translate(-782.549 -135.429)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.067,198.126h0Z",
    transform: "translate(-782.513 -135.395)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.369,201.328l.006.006,0-.006Z",
    transform: "translate(-784.769 -137.583)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.521,201.476l.006.006,0-.006Z",
    transform: "translate(-784.873 -137.684)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.47,201.427l.006.006,0-.006Z",
    transform: "translate(-784.838 -137.651)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.419,201.377l.006.006,0-.006Z",
    transform: "translate(-784.803 -137.616)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.625,201.576l.008.008,0-.008Z",
    transform: "translate(-784.944 -137.752)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.3,202.226l.008.008,0-.008Z",
    transform: "translate(-785.402 -138.197)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.574,201.527l.006.006,0-.006Z",
    transform: "translate(-784.909 -137.719)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.109,201.076l.006.006,0-.006Z",
    transform: "translate(-784.591 -137.411)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.316,201.277l.006.006,0-.006Z",
    transform: "translate(-784.733 -137.548)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.677,201.626l.006.007,0-.007Z",
    transform: "translate(-784.98 -137.787)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.161,201.127l.006.006,0-.006Z",
    transform: "translate(-784.627 -137.445)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.214,201.177l.006.006,0-.006Z",
    transform: "translate(-784.663 -137.48)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.263,201.226l.007.006,0-.006Z",
    transform: "translate(-784.697 -137.513)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.832,201.777l.007.007,0-.007Z",
    transform: "translate(-785.086 -137.89)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.088,202.027l.007.006,0-.006Z",
    transform: "translate(-785.26 -138.061)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.141,202.077l.008.007,0-.007Z",
    transform: "translate(-785.297 -138.095)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.244,202.177l.008.008,0-.008Z",
    transform: "translate(-785.367 -138.163)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.039,201.978l.007.007,0-.007Z",
    transform: "translate(-785.227 -138.027)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.192,202.126l.008.008,0-.008Z",
    transform: "translate(-785.331 -138.129)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.986,201.927l.008.007,0-.007Z",
    transform: "translate(-785.191 -137.992)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.779,201.726l.007.007,0-.007Z",
    transform: "translate(-785.049 -137.855)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.06,201.027l.006.006,0-.006Z",
    transform: "translate(-784.558 -137.377)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.885,201.828l.006.007,0-.007Z",
    transform: "translate(-785.122 -137.924)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.728,201.677l.006.006,0-.006Z",
    transform: "translate(-785.015 -137.822)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.933,201.876l.008.007,0-.007Z",
    transform: "translate(-785.155 -137.958)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.079,200.076l0,0v0Z",
    transform: "translate(-783.887 -136.728)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.131,200.127l0,0v0Z",
    transform: "translate(-783.923 -136.762)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.233,200.227l0,0v0Z",
    transform: "translate(-783.993 -136.83)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.182,200.176l0,0v0Z",
    transform: "translate(-783.958 -136.796)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.284,200.275l.006.005,0-.005Z",
    transform: "translate(-784.028 -136.864)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.337,200.326l.005,0,0,0Z",
    transform: "translate(-784.064 -136.898)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.975,199.977l0,0v0Z",
    transform: "translate(-783.817 -136.66)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.82,199.826l0,0v0Z",
    transform: "translate(-783.711 -136.557)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.922,199.926l0,0v0Z",
    transform: "translate(-783.78 -136.625)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.873,199.877l0,0v0Z",
    transform: "translate(-783.747 -136.592)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.028,200.028l0,0v0Z",
    transform: "translate(-783.853 -136.694)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.389,200.377l0,0v0Z",
    transform: "translate(-784.1 -136.933)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.9,200.877l.006.005,0-.005Z",
    transform: "translate(-784.451 -137.275)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.851,200.826l.006.006,0-.006Z",
    transform: "translate(-784.415 -137.24)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.749,200.726l0,0v0Z",
    transform: "translate(-784.345 -137.172)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.8,200.777l.005.005v-.005Z",
    transform: "translate(-784.38 -137.207)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.954,200.926l.006.006,0-.006Z",
    transform: "translate(-784.486 -137.308)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.007,200.976l.006.006,0-.006Z",
    transform: "translate(-784.522 -137.343)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.544,200.527l.005.005,0-.005Z",
    transform: "translate(-784.205 -137.036)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.438,200.426l.005.005v-.005Z",
    transform: "translate(-784.133 -136.966)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.7,200.678l.005.005v-.005Z",
    transform: "translate(-784.311 -137.139)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.491,200.477l0,0v0Z",
    transform: "translate(-784.169 -137.001)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.645,200.627l.005.005v-.005Z",
    transform: "translate(-784.275 -137.104)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.593,200.576l.005.005v-.005Z",
    transform: "translate(-784.239 -137.069)",
    fill: "#8feab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.318,200.308h17.229l-3.292-3.182h-17.218l.016.016.016.016h0l.032.031h0l.016.015.032.032h0l.033.031.016.016.017.016h0l.015.015h0l.016.016h0l.015.014h0l.016.015h0l.015.015h0l.015.015h0l.016.015h0v0l.016.015h0l.015.015h0l.015.015h0l.016.016h0l.016.014h0l.015.015h0l.014.014h0v0l.015.014h0v0l.013.013h0v0l.014.013h0v0l.015.014h0v0l.014.014h0v0l.014.014h0v0l.014.014h0l.014.014h0v0l.014.014h0v0l.015.014h0v0l.014.013h0v0l.014.013h0v0l.013.013h0v0l.014.014h0v0l.014.014h0v0l.013.013h0v0l.014.013h0v0l.014.013h0v0l.013.014h0v0l.013.013h0v0l.014.013h0v0l.013.012h0l0,0,.013.013h0v0l.012.012h0v0l.012.012h0v0l.013.012h0v0l.013.012h0v0l.011.012h0v0l.012.012h0v0l.013.013h0v0l.012.012h0v0l.012.012h0v0l.012.012h0v0l.012.011h0v0l.013.011h0v0l.013.012h0v0l.012.012h0v0l.011.011h0l0,.005.011.011h0l0,0,.012.011h0v0l.012.012h0v.005l.011.011h0v0l.012.011h0l0,.005.01.01h0v.005l.012.011h0v.005l.012.011h0v.005l.011.01h0v0l.011.011h0v.005l.011.01h0l0,.006.01.01h0l0,.005.01.01h0l0,.006.011.01h0l0,.006.011.01h0l0,.007.01.009h0l0,.006.011.01h0l0,.006.011.01h0l0,.006.01.009h0l0,.007.01.009h0l0,.006.01.01h0l0,.006.011.01h0l0,.006.01.01h0l0,.006.01.009h0l0,.006.01.01h0l0,.006.009.009h.005l0,.008.009.009h0l0,.007.01.009h0l0,.007.01.009h.005l0,.007.009.009h.005l0,.007.01.009h0l0,.007.009.008h.005l0,.007.009.009h.005l0,.007.009.009h.005l0,.007.008.009h.005l0,.006.01.01h0l0,.007.009.008h.006l0,.009.009.008h.005l0,.008.009.008h.006l0,.008.009.009h.005l0,.008.008.008h.005l0,.008.008.008h.006l0,.009.008.008h.005l0,.008.009.009h.005l0,.008.008.008h.007l0,.008.008.008h.006l0,.009.008.008h.005l0,.008.008.008h.006l0,.008.008.008h.006l0,.008.007.007h.007l0,.009.008.008h.006l0,.009.008.007h.006l0,.01.006.007h.006l0,.009.008.007h.006l0,.008.008.007h.007l0,.009.008.007h.007l0,.009.007.007H1146l0,.009.007.007h.006l0,.009.008.007h.006l0,.009.008.007h.006l0,.009.006.006h.007l0,.009.006.007h.007l0,.01.006.007h.007l0,.009.007.006h.006l0,.01.006.006h.007l0,.01.006.006h.007l0,.009.006.007h.007l0,.009.006.006h.007l0,.01.007.006h.006l0,.01.006.006h.007l0,.01.006.005h.008l0,.01.006.006h.007l0,.01.005.005h.008l0,.01.006.006h.008l0,.011,0,0h.008l0,.011.006.005h.008l0,.01.005.006h.007l0,.01,0,.005h.008l0,.012,0,0h.008l0,.011.006.005h.007l0,.01.006.005h.008l0,.011.005,0h.008l0,.011.005.005h.008l0,.011,0,0h.008l0,.011.005.005h.008l0,.011,0,0h.009l0,.012,0,0h.008l0,.011,0,0h.008l0,.012,0,0h.008l0,.012,0,0h.008l0,.011,0,0h.009l0,.012,0,0h.009l0,.012,0,0h.008l0,.012,0,0h.008l0,.012,0,0h.008l0,.011,0,0h.009l0,.012,0,0h.008l0,.012,0,0h.008l0,.011,0,0h.009l0,.012,0,0h.009l0,.013,0,0h.009l0,.013,0,0h.01l0,.012,0,0h.009l0,.013,0,0h.009l0,.013,0,0h.009l0,.013,0,0h.009l0,.012,0,0h.009l0,.013,0,0h.009l0,.012,0,0h.009l0,.013,0,0h.009l0,.013,0,0h.009l0,.014,0,0h.01l0,.013,0,0h.01l0,.013,0,0h.009l0,.014,0,0h.01l0,.014,0,0h.01l0,.014,0,0h.01l0,.013,0,0h.01l0,.014,0,0h.009l0,.014,0,0h.01l0,.014,0,0h.01l0,.013,0,0h.01l0,.014h.012l0,.014,0,0h.01l0,.014,0,0h.01l0,.014,0,0h.01l.005.015h.011l0,.015h.011l0,.014,0,0h.01l.005.015h.011l0,.015,0,0h.01l0,.015h.012l.005.014h.012l.005.016h.011l0,.015h.012l.005.015h.011l.005.015h.012Z",
    transform: "translate(-781.809 -134.711)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.955,4.218l-10.081,20.677L1201.8,4.218h-18.608l20.072,36.1V65.3h16.37V40.315l20.245-36.1Z",
    transform: "translate(-808.563 -2.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1262.118,4.218l-9.211,18.891L1245.25,7.4h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.015h-.008l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.015h-.008L1245,7.163H1245l-.008-.016h-.008l-.007-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008L1244.841,7h-.008l-.008-.016h-.009l-.008-.015h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.015h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.016h-.009l-.007-.016h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.007-.016h-.009l-.007-.015h-.009l-.008-.016h-.008l-.008-.016h-.008l-.007-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.007-.016h-.009l-.008-.016h-.009l-.008-.015h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.016h-.009l-.007-.016h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.016h-.009l-.008-.015h-.009l-.007-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.015h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016H1244l-.008-.015h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.007-.016h-.008l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.015h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.015h-.009L1243.6,5.8h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.015h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.015h-.008l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.007-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.007-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.016h-.009l-.007-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.015h-.008l-.008-.016H1243l-.007-.016h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.015h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.007-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.007-.016h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.015h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.016h-.009l-.007-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.015h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.007-.015h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.015h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.015h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016H1242l-.008-.016h-.008l-.008-.016h-.009l-.008-.016,10.079,20.677Z",
    transform: "translate(-848.726 -2.882)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.152,200.554h.011l-.011-.01Z",
    transform: "translate(-854.325 -137.047)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.945,200.352h.011l-.011-.012Z",
    transform: "translate(-854.184 -136.908)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.256,200.654h.011l-.011-.011Z",
    transform: "translate(-854.396 -137.115)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.1,200.5h.012l-.012-.012Z",
    transform: "translate(-854.289 -137.011)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250,200.4h.011l-.011-.011Z",
    transform: "translate(-854.218 -136.942)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.048,200.453h.011l-.011-.011Z",
    transform: "translate(-854.254 -136.977)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.2,200.6h.012l-.012-.011Z",
    transform: "translate(-854.36 -137.08)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.514,200.905h.01l-.01-.01Z",
    transform: "translate(-854.573 -137.287)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.463,200.854h.01l-.01-.01Z",
    transform: "translate(-854.538 -137.252)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.306,200.7h.011l-.011-.01Z",
    transform: "translate(-854.431 -137.149)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.41,200.8h.01l-.01-.01Z",
    transform: "translate(-854.502 -137.217)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.357,200.753h.012l-.012-.011Z",
    transform: "translate(-854.466 -137.183)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.788,200.2h.012l-.012-.012Z",
    transform: "translate(-854.077 -136.805)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.53,199.95h.012l-.012-.012Z",
    transform: "translate(-853.9 -136.633)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.479,199.9h.012l-.012-.012Z",
    transform: "translate(-853.866 -136.6)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.325,199.75h.012l-.012-.012Z",
    transform: "translate(-853.76 -136.497)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.427,199.851h.013l-.013-.012Z",
    transform: "translate(-853.83 -136.565)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.376,199.8h.012l-.012-.012Z",
    transform: "translate(-853.795 -136.53)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.738,200.152h.012l-.012-.011Z",
    transform: "translate(-854.042 -136.772)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.634,200.051h.012l-.012-.012Z",
    transform: "translate(-853.971 -136.702)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.841,200.252h.011l-.011-.011Z",
    transform: "translate(-854.113 -136.84)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.564,200.954h.01l-.01-.01Z",
    transform: "translate(-854.607 -137.32)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.687,200.1h.011l-.011-.012Z",
    transform: "translate(-854.007 -136.737)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.894,200.3h.011l-.011-.011Z",
    transform: "translate(-854.149 -136.874)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.583,200h.012l-.012-.012Z",
    transform: "translate(-853.937 -136.669)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.393,201.758h.009l-.009-.009Z",
    transform: "translate(-855.174 -137.871)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.548,201.908h.009l-.009-.009Z",
    transform: "translate(-855.279 -137.973)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.5,201.859h.008l-.008-.008Z",
    transform: "translate(-855.244 -137.94)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.444,201.808h.01l-.01-.009Z",
    transform: "translate(-855.208 -137.905)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.34,201.707h.009l-.009-.009Z",
    transform: "translate(-855.137 -137.836)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.29,201.658h.01l-.01-.009Z",
    transform: "translate(-855.103 -137.803)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.651,202.009h.009l-.009-.008Z",
    transform: "translate(-855.35 -138.043)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.808,202.161h.008l-.008-.008Z",
    transform: "translate(-855.457 -138.147)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.755,202.109h.008l-.008-.008Z",
    transform: "translate(-855.421 -138.111)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.7,202.058h.009l-.009-.009Z",
    transform: "translate(-855.385 -138.076)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.6,201.959h.009l-.009-.009Z",
    transform: "translate(-855.315 -138.008)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.239,201.609h.009l-.009-.008Z",
    transform: "translate(-855.068 -137.769)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.186,201.557h.009l-.009-.009Z",
    transform: "translate(-855.032 -137.733)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.824,201.206h.01l-.01-.01Z",
    transform: "translate(-854.785 -137.493)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.875,201.257h.01l-.01-.009Z",
    transform: "translate(-854.82 -137.528)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.771,201.155h.011l-.011-.01Z",
    transform: "translate(-854.749 -137.458)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.721,201.106h.01l-.01-.009Z",
    transform: "translate(-854.714 -137.425)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.67,201.057h.01l-.01-.009Z",
    transform: "translate(-854.679 -137.392)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.083,201.457h.01l-.01-.009Z",
    transform: "translate(-854.961 -137.665)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.617,201h.01l-.01-.01Z",
    transform: "translate(-854.643 -137.355)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.133,201.506h.01l-.01-.009Z",
    transform: "translate(-854.996 -137.698)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.979,201.356h.01l-.01-.009Z",
    transform: "translate(-854.89 -137.596)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.928,201.307h.01l-.01-.009Z",
    transform: "translate(-854.856 -137.562)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.032,201.407h.01l-.01-.01Z",
    transform: "translate(-854.927 -137.63)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321.795,7.433l.009-.016h-.025l.009-.016h-.025l.008-.015h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.025l.009-.016h-.025l.008-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.015h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.015h-.025l.009-.016h-.025l.008-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.026l.009-.016h-.025l.009-.015h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.026l.009-.016h-.024l.008-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.015h-.026l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.026l.009-.015h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.008-.015h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.015h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.015h-.025l.009-.016h-.026l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.015h-.026l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.008-.015h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.026l.009-.015h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.008-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.026l.009-.015h-.026l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.008-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.008-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.008-.016h-.025l.009-.016h-.025l.008-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.008-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.015h-.025l.008-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.008-.016h-.025l.009-.016h-.025l.009-.015h-.026l.009-.016h-.025L1319.3,5h-.025l.008-.016h-.025l.009-.015h-.026l.009-.016h-.025l.009-.016h-.025l.008-.016h-.025l.009-.016h-.025l.008-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.008-.016h-.025l.009-.016h-.026L1319,4.71h-.025l.009-.016h-.025l.009-.016h-.026l.009-.015h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.015h-.025l.009-.016h-.025l.008-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.008-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.015h-.025l.009-.016h-.026l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.008-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l-20.236,36.082V65.33l3.292,3.182V43.531l20.245-36.1Z",
    transform: "translate(-887.217 -2.915)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.616,198.094h.015l-.015-.015Z",
    transform: "translate(-852.593 -135.363)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.669,198.145h.015l-.015-.015Z",
    transform: "translate(-852.629 -135.397)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.72,198.2h.016l-.016-.015Z",
    transform: "translate(-852.663 -135.432)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.513,197.994h.016l-.016-.015Z",
    transform: "translate(-852.522 -135.295)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.566,198.045h.015l-.015-.015Z",
    transform: "translate(-852.558 -135.329)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.773,198.246h.014l-.014-.014Z",
    transform: "translate(-852.7 -135.467)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.875,198.345h.015l-.015-.014Z",
    transform: "translate(-852.769 -135.535)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.082,198.546h.015l-.015-.014Z",
    transform: "translate(-852.911 -135.672)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.98,198.446h.014l-.014-.014Z",
    transform: "translate(-852.841 -135.604)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.824,198.295h.015l-.015-.015Z",
    transform: "translate(-852.734 -135.5)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.462,197.945h.015l-.015-.014Z",
    transform: "translate(-852.487 -135.261)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.927,198.4h.015l-.015-.014Z",
    transform: "translate(-852.805 -135.57)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.031,198.5h.014l-.014-.014Z",
    transform: "translate(-852.876 -135.639)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.893,197.394h.016v.016h.016l-.032-.031Z",
    transform: "translate(-852.098 -134.884)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247,197.493h.016l-.016-.016Z",
    transform: "translate(-852.169 -134.952)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.047,197.543h.016v.016h.016l-.032-.032Z",
    transform: "translate(-852.204 -134.985)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.686,197.191h.016v.016h.017v.016h.016l-.049-.048Z",
    transform: "translate(-851.957 -134.745)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.84,197.341h.016l-.016-.016Z",
    transform: "translate(-852.062 -134.848)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.409,197.893h.016l-.016-.015Z",
    transform: "translate(-852.451 -135.225)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.151,197.643h.016l-.016-.016Z",
    transform: "translate(-852.274 -135.054)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.306,197.792h.015l-.015-.016Z",
    transform: "translate(-852.38 -135.156)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.359,197.844h.016l-.016-.015Z",
    transform: "translate(-852.416 -135.192)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.255,197.743h.016l-.016-.016Z",
    transform: "translate(-852.346 -135.123)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.2,197.694h.016l-.016-.015Z",
    transform: "translate(-852.311 -135.089)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.185,198.646h.014l-.014-.014Z",
    transform: "translate(-852.981 -135.74)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.911,199.349h.013l-.013-.013Z",
    transform: "translate(-853.477 -136.222)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.135,198.6h.014l-.014-.014Z",
    transform: "translate(-852.947 -135.707)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.961,199.4h.013l-.013-.013Z",
    transform: "translate(-853.512 -136.255)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.754,199.2h.014l-.014-.014Z",
    transform: "translate(-853.37 -136.118)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.807,199.248h.013l-.013-.013Z",
    transform: "translate(-853.406 -136.153)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.219,199.649h.013l-.013-.012Z",
    transform: "translate(-853.688 -136.427)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.7,199.148h.013l-.013-.013Z",
    transform: "translate(-853.335 -136.085)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.014,199.45h.013l-.013-.012Z",
    transform: "translate(-853.548 -136.291)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.169,199.6h.012l-.012-.012Z",
    transform: "translate(-853.653 -136.394)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.065,199.5h.014l-.014-.013Z",
    transform: "translate(-853.583 -136.325)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.118,199.55h.012l-.012-.012Z",
    transform: "translate(-853.619 -136.359)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.858,199.3h.014l-.014-.013Z",
    transform: "translate(-853.441 -136.187)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.342,198.8h.014l-.014-.014Z",
    transform: "translate(-853.088 -135.844)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.238,198.7h.014l-.014-.014Z",
    transform: "translate(-853.017 -135.775)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.289,198.747h.014l-.014-.014Z",
    transform: "translate(-853.052 -135.81)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.859,202.209h.008l-.008-.008Z",
    transform: "translate(-855.491 -138.18)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.272,199.7h.013l-.013-.012Z",
    transform: "translate(-853.724 -136.462)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.6,199.049h.014l-.014-.013Z",
    transform: "translate(-853.264 -136.017)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.651,199.1h.014l-.014-.013Z",
    transform: "translate(-853.299 -136.05)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.549,199h.013l-.013-.013Z",
    transform: "translate(-853.23 -135.982)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.443,198.9h.014l-.014-.014Z",
    transform: "translate(-853.158 -135.912)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.5,198.948h.014l-.014-.014Z",
    transform: "translate(-853.194 -135.947)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.393,198.847h.014l-.014-.014Z",
    transform: "translate(-853.123 -135.878)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.946,203.265h.007l-.007-.006Z",
    transform: "translate(-856.234 -138.902)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.686,205.922h0l0,0Z",
    transform: "translate(-858.107 -140.721)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.272,205.52h0l0,0Z",
    transform: "translate(-857.824 -140.446)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.375,205.621h0l0,0Z",
    transform: "translate(-857.895 -140.515)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.325,205.571h0l0,0Z",
    transform: "translate(-857.86 -140.481)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.168,205.419h0l0,0Z",
    transform: "translate(-857.753 -140.376)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.067,205.321h0l0,0Z",
    transform: "translate(-857.684 -140.31)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.117,205.37h0l0,0Z",
    transform: "translate(-857.719 -140.343)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.428,205.672h0l0,0Z",
    transform: "translate(-857.931 -140.55)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.635,205.873h0l0,0Z",
    transform: "translate(-858.073 -140.687)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.583,205.821h0l0,0Z",
    transform: "translate(-858.036 -140.651)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.479,205.722h0l0,0Z",
    transform: "translate(-857.966 -140.583)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.532,205.772h0l0,0Z",
    transform: "translate(-858.002 -140.618)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.221,205.471h0l0,0Z",
    transform: "translate(-857.789 -140.412)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.652,204.92h0l0,0Z",
    transform: "translate(-857.401 -140.035)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.6,204.868h0l0,0Z",
    transform: "translate(-857.364 -139.999)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.7,204.969h0l0,0Z",
    transform: "translate(-857.435 -140.068)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.548,204.818h0l0,0Z",
    transform: "translate(-857.33 -139.965)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.445,204.717h0l0,0Z",
    transform: "translate(-857.259 -139.896)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.859,205.12h0l0,0Z",
    transform: "translate(-857.542 -140.172)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.756,205.019h0l0,0Z",
    transform: "translate(-857.471 -140.103)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.961,205.218h0l0,0Z",
    transform: "translate(-857.612 -140.239)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.91,205.17h0l0,0Z",
    transform: "translate(-857.577 -140.206)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.807,205.07h0l0,0Z",
    transform: "translate(-857.506 -140.138)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.014,205.269h0l0,0Z",
    transform: "translate(-857.648 -140.274)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.5,204.769h0l0,0Z",
    transform: "translate(-857.295 -139.932)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.566,206.775h0Z",
    transform: "translate(-858.708 -141.305)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.617,206.825h0Z",
    transform: "translate(-858.743 -141.338)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.513,206.725h0Z",
    transform: "translate(-858.672 -141.27)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.67,206.876h0Z",
    transform: "translate(-858.779 -141.373)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.359,206.575h0Z",
    transform: "translate(-858.567 -141.168)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.462,206.674h0Z",
    transform: "translate(-858.638 -141.236)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.411,206.625h0Z",
    transform: "translate(-858.603 -141.202)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.877,207.077h0Z",
    transform: "translate(-858.921 -141.512)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.72,206.926h0Z",
    transform: "translate(-858.814 -141.408)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.927,207.127h0Z",
    transform: "translate(-858.956 -141.545)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.773,206.977h0Z",
    transform: "translate(-858.85 -141.443)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.824,207.026h0Z",
    transform: "translate(-858.885 -141.476)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.306,206.523h0v0Z",
    transform: "translate(-858.531 -141.132)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.944,206.173h0l0,0Z",
    transform: "translate(-858.284 -140.893)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.893,206.122h0l0,0Z",
    transform: "translate(-858.249 -140.858)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.79,206.023h0l0,0Z",
    transform: "translate(-858.178 -140.79)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256,206.224h0l0,0Z",
    transform: "translate(-858.32 -140.928)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.843,206.074h0l0,0Z",
    transform: "translate(-858.214 -140.825)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.2,206.425h0Z",
    transform: "translate(-858.461 -141.065)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.255,206.474h0l0,0Z",
    transform: "translate(-858.496 -141.098)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.737,205.971h0l0,0Z",
    transform: "translate(-858.142 -140.754)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.1,206.324h0l0,0Z",
    transform: "translate(-858.391 -140.996)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.048,206.273h0l0,0Z",
    transform: "translate(-858.354 -140.961)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.151,206.373h0l0,0Z",
    transform: "translate(-858.425 -141.029)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.013,202.36h.008l-.008-.008Z",
    transform: "translate(-855.597 -138.283)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.685,203.011h.007l-.007-.007Z",
    transform: "translate(-856.057 -138.728)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.738,203.062h.007l-.007-.007Z",
    transform: "translate(-856.093 -138.763)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.842,203.163h.006l-.006-.006Z",
    transform: "translate(-856.164 -138.833)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.789,203.113h.007l-.007-.007Z",
    transform: "translate(-856.128 -138.798)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.635,202.963h.007l-.007-.007Z",
    transform: "translate(-856.022 -138.695)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.584,202.912h.007l-.007-.007Z",
    transform: "translate(-855.987 -138.66)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.1,203.414h.006l-.006-.006Z",
    transform: "translate(-856.34 -139.005)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.531,202.861h.007l-.007-.007Z",
    transform: "translate(-855.951 -138.626)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.047,203.362h.006l-.006-.006Z",
    transform: "translate(-856.304 -138.969)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.893,203.212h.007l-.007-.007Z",
    transform: "translate(-856.198 -138.866)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.635,197.142h.016l-.016-.016Z",
    transform: "translate(-851.922 -134.712)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.153,203.465h.006l-.006-.006Z",
    transform: "translate(-856.376 -139.039)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253,203.313H1253l-.007-.006Z",
    transform: "translate(-856.269 -138.935)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.117,202.46h.008l-.008-.008Z",
    transform: "translate(-855.668 -138.351)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.066,202.411h.008l-.008-.008Z",
    transform: "translate(-855.633 -138.318)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.962,202.31h.008l-.008-.008Z",
    transform: "translate(-855.562 -138.248)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.169,202.51h.008l-.008-.008Z",
    transform: "translate(-855.704 -138.386)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.909,202.259h.008l-.008-.008Z",
    transform: "translate(-855.526 -138.213)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.478,202.811h.008l-.008-.008Z",
    transform: "translate(-855.915 -138.591)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.22,202.561h.008l-.008-.008Z",
    transform: "translate(-855.739 -138.42)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.427,202.761h.007l-.007-.007Z",
    transform: "translate(-855.88 -138.558)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.377,202.713h.008l-.008-.007Z",
    transform: "translate(-855.846 -138.524)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.273,202.612h.007l-.007-.008Z",
    transform: "translate(-855.775 -138.455)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.324,202.66h.007l-.007-.008Z",
    transform: "translate(-855.81 -138.488)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.2,203.514h.006l-.006-.006Z",
    transform: "translate(-856.411 -139.073)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.083,204.368h0l0,0Z",
    transform: "translate(-857.012 -139.657)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.98,204.267h.005l-.005-.005Z",
    transform: "translate(-856.941 -139.588)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.03,204.316h.005l-.005-.005Z",
    transform: "translate(-856.976 -139.621)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.876,204.165h.005l-.005-.005Z",
    transform: "translate(-856.87 -139.518)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.823,204.115h.006l-.006-.006Z",
    transform: "translate(-856.834 -139.484)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.929,204.217h.005l-.005,0Z",
    transform: "translate(-856.906 -139.554)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.341,204.618h0l0,0Z",
    transform: "translate(-857.188 -139.828)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.29,204.568h0l0,0Z",
    transform: "translate(-857.153 -139.795)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.238,204.518h.005l-.005,0Z",
    transform: "translate(-857.117 -139.76)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.134,204.417h.005l-.005-.005Z",
    transform: "translate(-857.047 -139.691)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.187,204.467h0l0,0Z",
    transform: "translate(-857.083 -139.725)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.618,203.915h.005l-.005-.005Z",
    transform: "translate(-856.694 -139.348)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.411,203.715h.006l-.006-.006Z",
    transform: "translate(-856.552 -139.21)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.462,203.764h.006l-.006-.006Z",
    transform: "translate(-856.587 -139.244)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.772,204.066h.005l-.005-.005Z",
    transform: "translate(-856.799 -139.45)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.254,203.563h.006l-.006-.006Z",
    transform: "translate(-856.445 -139.106)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.307,203.614h.006l-.006-.006Z",
    transform: "translate(-856.481 -139.141)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.358,203.664h.006l-.006-.006Z",
    transform: "translate(-856.516 -139.175)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.514,203.816h.006l-.006-.005Z",
    transform: "translate(-856.623 -139.28)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.721,204.016h.005l-.005,0Z",
    transform: "translate(-856.765 -139.417)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.669,203.966h.006l-.006-.005Z",
    transform: "translate(-856.728 -139.382)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.392,204.666h0l0,0Z",
    transform: "translate(-857.223 -139.861)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.565,203.865h.006l-.006-.006Z",
    transform: "translate(-856.658 -139.313)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.23,198.677l0,0v0Z",
    transform: "translate(-853.012 -135.771)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.989,202.327l.008.008v-.008Z",
    transform: "translate(-855.58 -138.266)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.841,204.128l.011.01v-.01Z",
    transform: "translate(-856.847 -139.496)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.687,203.977l.011.011v-.011Z",
    transform: "translate(-856.741 -139.393)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.583,203.878l.011.01v-.01Z",
    transform: "translate(-856.67 -139.325)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.738,204.026l.011.011v-.011Z",
    transform: "translate(-856.776 -139.427)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.789,204.077l.011.01v-.01Z",
    transform: "translate(-856.811 -139.461)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.533,203.827l.01.01v-.01Z",
    transform: "translate(-856.636 -139.291)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.275,203.577l.01.009v-.009Z",
    transform: "translate(-856.459 -139.12)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.482,203.778l.011.01v-.01Z",
    transform: "translate(-856.601 -139.257)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.222,203.526l.01.009v-.009Z",
    transform: "translate(-856.423 -139.085)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.429,203.727l.01.01v-.01Z",
    transform: "translate(-856.565 -139.223)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.376,203.676l.011.01v-.01Z",
    transform: "translate(-856.529 -139.188)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.328,203.628l.01.009v-.009Z",
    transform: "translate(-856.495 -139.155)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.254,204.528l.011.012v-.012Z",
    transform: "translate(-857.128 -139.77)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.892,204.176l.012.012v-.012Z",
    transform: "translate(-856.881 -139.529)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.355,204.627l.012.011v-.011Z",
    transform: "translate(-857.198 -139.838)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.406,204.676l.012.012v-.012Z",
    transform: "translate(-857.233 -139.871)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.2,204.477l.012.012v-.012Z",
    transform: "translate(-857.092 -139.735)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.3,204.576l.012.012v-.012Z",
    transform: "translate(-857.162 -139.803)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254,204.278l.011.01v-.01Z",
    transform: "translate(-856.952 -139.599)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.945,204.227l.011.011v-.011Z",
    transform: "translate(-856.917 -139.564)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.047,204.327l.012.012v-.012Z",
    transform: "translate(-856.987 -139.632)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.15,204.428l.012.011v-.011Z",
    transform: "translate(-857.058 -139.702)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.1,204.377l.011.011v-.011Z",
    transform: "translate(-857.023 -139.667)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.968,203.278l.009.009v-.009Z",
    transform: "translate(-856.25 -138.916)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.3,202.628l.008.008v-.008Z",
    transform: "translate(-855.791 -138.471)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.4,202.728l.008.008v-.008Z",
    transform: "translate(-855.862 -138.539)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.348,202.677l.009.009v-.009Z",
    transform: "translate(-855.826 -138.505)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.5,202.827l.009.008v-.008Z",
    transform: "translate(-855.932 -138.607)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.45,202.776l.009.008v-.008Z",
    transform: "translate(-855.896 -138.573)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.143,202.478l.008.008v-.008Z",
    transform: "translate(-855.686 -138.369)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.092,202.427l.008.008v-.008Z",
    transform: "translate(-855.651 -138.334)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.039,202.376l.008.008v-.008Z",
    transform: "translate(-855.615 -138.299)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.194,202.526l.008.008v-.008Z",
    transform: "translate(-855.721 -138.402)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.553,202.876l.01.009v-.009Z",
    transform: "translate(-855.966 -138.641)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.686,197.175",
    transform: "translate(-851.957 -134.745)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.915,203.228l.01.009v-.009Z",
    transform: "translate(-856.214 -138.881)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.606,202.927l.009.009v-.009Z",
    transform: "translate(-856.002 -138.676)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.173,203.477l.01.01v-.01Z",
    transform: "translate(-856.39 -139.052)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.019,203.327l.009.009v-.009Z",
    transform: "translate(-856.284 -138.949)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.12,203.427l.01.01v-.01Z",
    transform: "translate(-856.354 -139.017)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.067,203.376l.01.01v-.01Z",
    transform: "translate(-856.318 -138.982)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.459,204.727l.012.012v-.012Z",
    transform: "translate(-857.269 -139.906)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.862,203.177l.01.009v-.009Z",
    transform: "translate(-856.177 -138.846)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.708,203.026l.01.009v-.009Z",
    transform: "translate(-856.072 -138.744)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.657,202.978l.009.008v-.008Z",
    transform: "translate(-856.037 -138.71)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.811,203.128l.01.009v-.009Z",
    transform: "translate(-856.143 -138.813)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.761,203.077l.009.009v-.009Z",
    transform: "translate(-856.108 -138.778)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.634,203.926l.011.011v-.011Z",
    transform: "translate(-856.705 -139.359)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.054,206.277l.015.014v-.014Z",
    transform: "translate(-858.359 -140.965)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.363,206.578l.016.015v-.015Z",
    transform: "translate(-858.569 -141.17)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.107,206.328l.014.014v-.014Z",
    transform: "translate(-858.395 -141)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.16,206.378l.014.014v-.014Z",
    transform: "translate(-858.431 -141.034)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.261,206.478l.014.014v-.014Z",
    transform: "translate(-858.5 -141.102)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.31,206.527l.016.015v-.015Z",
    transform: "translate(-858.533 -141.136)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.745,205.976l.014.014v-.014Z",
    transform: "translate(-858.148 -140.759)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.849,206.078l.014.014v-.014Z",
    transform: "translate(-858.218 -140.829)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.8,206.027l.014.014v-.014Z",
    transform: "translate(-858.184 -140.794)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.9,206.127l.014.014v-.014Z",
    transform: "translate(-858.253 -140.862)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256,206.228l.014.014v-.014Z",
    transform: "translate(-858.324 -140.932)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.952,206.177l.014.014v-.014Z",
    transform: "translate(-858.289 -140.897)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.208,206.427l.015.014v-.014Z",
    transform: "translate(-858.464 -141.068)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.775,206.978l.016.015v-.015Z",
    transform: "translate(-858.852 -141.444)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.414,206.626l.015.015v-.015Z",
    transform: "translate(-858.604 -141.204)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.93,207.128l.016.016v-.016Z",
    transform: "translate(-858.957 -141.547)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.724,206.927l.015.016v-.016Z",
    transform: "translate(-858.817 -141.409)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.879,207.077l.016.016v-.016Z",
    transform: "translate(-858.922 -141.512)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.828,207.029l.016.016v-.016Z",
    transform: "translate(-858.888 -141.479)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.517,206.728l.016.015v-.015Z",
    transform: "translate(-858.675 -141.273)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.674,206.878l.015.015v-.015Z",
    transform: "translate(-858.782 -141.376)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.466,206.677l.015.015v-.015Z",
    transform: "translate(-858.64 -141.238)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.568,206.777l.016.015v-.015Z",
    transform: "translate(-858.71 -141.306)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.621,206.827l.016.015v-.015Z",
    transform: "translate(-858.746 -141.341)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.385,205.627l.013.014v-.014Z",
    transform: "translate(-857.902 -140.521)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.871,205.127l.013.012v-.012Z",
    transform: "translate(-857.55 -140.179)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.821,205.078l.012.012v-.012Z",
    transform: "translate(-857.516 -140.146)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.075,205.326l.014.013v-.013Z",
    transform: "translate(-857.689 -140.315)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.973,205.227l.013.012v-.012Z",
    transform: "translate(-857.62 -140.247)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.026,205.277l.013.013v-.013Z",
    transform: "translate(-857.656 -140.282)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.922,205.178l.012.012v-.012Z",
    transform: "translate(-857.585 -140.214)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.614,204.877l.012.012v-.012Z",
    transform: "translate(-857.374 -140.008)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.768,205.027l.012.012v-.012Z",
    transform: "translate(-857.48 -140.111)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.561,204.826l.012.012v-.012Z",
    transform: "translate(-857.338 -139.974)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.694,205.927l.014.013v-.013Z",
    transform: "translate(-858.113 -140.726)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.664,204.928l.012.012v-.012Z",
    transform: "translate(-857.409 -140.043)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.715,204.977l.013.012v-.012Z",
    transform: "translate(-857.444 -140.076)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.54,205.777l.014.013v-.013Z",
    transform: "translate(-858.007 -140.623)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.489,205.728l.014.013v-.013Z",
    transform: "translate(-857.973 -140.59)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.641,205.877l.014.014v-.014Z",
    transform: "translate(-858.077 -140.691)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.436,205.678l.014.013v-.013Z",
    transform: "translate(-857.936 -140.555)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.591,205.828l.014.014v-.014Z",
    transform: "translate(-858.042 -140.658)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.51,204.778l.012.012v-.012Z",
    transform: "translate(-857.303 -139.94)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.229,205.477l.014.013v-.013Z",
    transform: "translate(-857.795 -140.418)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.127,205.377l.013.012v-.012Z",
    transform: "translate(-857.725 -140.35)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.18,205.428l.013.013v-.013Z",
    transform: "translate(-857.761 -140.385)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.335,205.578l.013.013v-.013Z",
    transform: "translate(-857.867 -140.487)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.282,205.527l.014.013v-.013Z",
    transform: "translate(-857.831 -140.453)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.247,202.577l.008.008v-.008Z",
    transform: "translate(-855.757 -138.437)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.59,199.026l0,0v0Z",
    transform: "translate(-853.258 -136.01)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.541,198.977l0,0v0Z",
    transform: "translate(-853.224 -135.977)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.642,199.077l0,0v0Z",
    transform: "translate(-853.294 -136.045)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.744,199.176l0,0v0Z",
    transform: "translate(-853.363 -136.113)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.693,199.126l0,0v0Z",
    transform: "translate(-853.328 -136.078)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.488,198.926l0,0v0Z",
    transform: "translate(-853.188 -135.942)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.8,199.227l0,0v0Z",
    transform: "translate(-853.399 -136.147)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.283,198.727l0,0v0Z",
    transform: "translate(-853.048 -135.806)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.179,198.626l0,0v0Z",
    transform: "translate(-852.977 -135.736)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.334,198.776l0,0v0Z",
    transform: "translate(-853.083 -135.839)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.386,198.827l0,0v0Z",
    transform: "translate(-853.119 -135.874)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.437,198.878l0,0v0Z",
    transform: "translate(-853.153 -135.908)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.415,199.826l0,0v0Z",
    transform: "translate(-853.821 -136.557)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.156,199.577l0,0v0Z",
    transform: "translate(-853.645 -136.386)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.936,202.277l.008.008v-.008Z",
    transform: "translate(-855.544 -138.231)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.26,199.676l0,0v0Z",
    transform: "translate(-853.716 -136.454)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.362,199.776l0,0v0Z",
    transform: "translate(-853.785 -136.522)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.848,199.276l0,0v0Z",
    transform: "translate(-853.434 -136.181)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.313,199.727l0,0v0Z",
    transform: "translate(-853.752 -136.489)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.9,199.327l0,0v0Z",
    transform: "translate(-853.47 -136.215)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.951,199.377l0,0v0Z",
    transform: "translate(-853.505 -136.25)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.129,198.577l0,0v0Z",
    transform: "translate(-852.943 -135.703)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.108,199.528l0,0v0Z",
    transform: "translate(-853.612 -136.353)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249,199.426l0,0v0Z",
    transform: "translate(-853.539 -136.283)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.055,199.477l0,0v0Z",
    transform: "translate(-853.576 -136.318)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.2,197.677h0Z",
    transform: "translate(-852.309 -135.088)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.253,197.726h0Z",
    transform: "translate(-852.344 -135.121)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.306,197.777",
    transform: "translate(-852.38 -135.156)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.407,197.876h0Z",
    transform: "translate(-852.45 -135.224)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.354,197.825h0Z",
    transform: "translate(-852.414 -135.189)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.84,197.325",
    transform: "translate(-852.062 -134.847)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.891,197.376h0Z",
    transform: "translate(-852.097 -134.882)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.46,197.927h0Z",
    transform: "translate(-852.486 -135.259)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.048,197.527",
    transform: "translate(-852.204 -134.985)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.149,197.626h0Z",
    transform: "translate(-852.273 -135.053)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.995,197.476h0Z",
    transform: "translate(-852.168 -134.951)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.87,198.327h0Z",
    transform: "translate(-852.766 -135.532)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.818,198.276h0Z",
    transform: "translate(-852.73 -135.497)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.921,198.376l0,0v0Z",
    transform: "translate(-852.801 -135.566)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.076,198.526l0,0v0Z",
    transform: "translate(-852.906 -135.668)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.974,198.427l0,0v0Z",
    transform: "translate(-852.837 -135.6)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.025,198.475l0,0v0Z",
    transform: "translate(-852.872 -135.634)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.509,197.976h0Z",
    transform: "translate(-852.519 -135.292)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.562,198.026h0Z",
    transform: "translate(-852.555 -135.327)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.615,198.077h0Z",
    transform: "translate(-852.591 -135.361)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.716,198.177h0Z",
    transform: "translate(-852.661 -135.429)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.769,198.228h0Z",
    transform: "translate(-852.697 -135.464)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.663,198.126h0Z",
    transform: "translate(-852.625 -135.395)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.207,199.625l0,0v0Z",
    transform: "translate(-853.68 -136.419)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.113,201.476l.006.006v-.006Z",
    transform: "translate(-854.982 -137.684)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.062,201.427l.006.006v-.006Z",
    transform: "translate(-854.947 -137.651)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.166,201.527l.006.006v-.006Z",
    transform: "translate(-855.018 -137.719)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.009,201.377l.007.006v-.006Z",
    transform: "translate(-854.911 -137.616)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.215,201.576l.007.008v-.008Z",
    transform: "translate(-855.052 -137.752)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.32,201.677l.006.006v-.006Z",
    transform: "translate(-855.124 -137.822)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.267,201.626l.007.007v-.007Z",
    transform: "translate(-855.088 -137.787)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.8,201.177l.006.006v-.006Z",
    transform: "translate(-854.771 -137.48)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.753,201.127l.006.006v-.006Z",
    transform: "translate(-854.736 -137.445)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.908,201.277l.006.006v-.006Z",
    transform: "translate(-854.842 -137.548)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.855,201.226l.006.006v-.006Z",
    transform: "translate(-854.806 -137.513)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.959,201.328l.006.006v-.006Z",
    transform: "translate(-854.877 -137.583)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.523,201.876l.008.007v-.007Z",
    transform: "translate(-855.262 -137.958)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.731,202.077l.008.007v-.007Z",
    transform: "translate(-855.404 -138.095)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.781,202.126l.008.008v-.008Z",
    transform: "translate(-855.439 -138.129)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.369,201.726l.008.007v-.007Z",
    transform: "translate(-855.157 -137.855)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.68,202.027l.007.007v-.007Z",
    transform: "translate(-855.369 -138.061)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.834,202.177l.008.008v-.008Z",
    transform: "translate(-855.475 -138.163)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.885,202.226l.008.008v-.008Z",
    transform: "translate(-855.51 -138.197)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.467,199.877l0,0v0Z",
    transform: "translate(-853.857 -136.592)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.475,201.828l.007.007v-.007Z",
    transform: "translate(-855.229 -137.924)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.422,201.777l.007.007v-.007Z",
    transform: "translate(-855.193 -137.89)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.7,201.076l.006.006v-.006Z",
    transform: "translate(-854.7 -137.411)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.576,201.927l.007.007v-.007Z",
    transform: "translate(-855.299 -137.992)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.629,201.978l.007.007v-.007Z",
    transform: "translate(-855.335 -138.027)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.774,200.176l0,0v0Z",
    transform: "translate(-854.067 -136.796)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.878,200.275l0,.005v-.005Z",
    transform: "translate(-854.138 -136.864)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.827,200.227l0,0v0Z",
    transform: "translate(-854.103 -136.83)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.032,200.426l.005.005v-.005Z",
    transform: "translate(-854.243 -136.966)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.981,200.377l0,0v0Z",
    transform: "translate(-854.209 -136.933)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.928,200.326l.005,0v0Z",
    transform: "translate(-854.173 -136.898)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.569,199.977l0,0v0Z",
    transform: "translate(-853.927 -136.66)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.516,199.926l0,0v0Z",
    transform: "translate(-853.891 -136.625)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.622,200.028l0,0v0Z",
    transform: "translate(-853.963 -136.694)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.671,200.076l.005,0v0Z",
    transform: "translate(-853.996 -136.728)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.723,200.127l0,0v0Z",
    transform: "translate(-854.032 -136.762)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.65,201.027l.006.006v-.006Z",
    transform: "translate(-854.666 -137.377)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.443,200.826l.006.006v-.006Z",
    transform: "translate(-854.524 -137.24)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.5,200.877l.006.006v-.006Z",
    transform: "translate(-854.56 -137.275)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.546,200.926l.006.006v-.006Z",
    transform: "translate(-854.595 -137.308)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.6,200.976l.006.006v-.006Z",
    transform: "translate(-854.629 -137.343)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.394,200.777l.005.005v-.005Z",
    transform: "translate(-854.491 -137.207)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.186,200.576l.005.005v-.005Z",
    transform: "translate(-854.349 -137.069)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.136,200.527l.005.005v-.005Z",
    transform: "translate(-854.314 -137.036)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.083,200.477l.005,0v0Z",
    transform: "translate(-854.278 -137.001)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.239,200.627l0,.005v-.005Z",
    transform: "translate(-854.385 -137.104)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.341,200.726l.005.005v-.005Z",
    transform: "translate(-854.454 -137.172)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.29,200.678l.005.005v-.005Z",
    transform: "translate(-854.42 -137.139)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.635,197.126l.016.016.049.048.016.016h0l.032.031h0l.016.016.032.032h0l.016.016h0l.016.015h0l.016.016.016.016h0l.016.015h0l.016.015h0v0l.015.014h0l.015.015h0l.016.015h0l.015.015h0l.015.015h0l.016.015h0l.014.014h0l.015.015h0l.015.014h0v0l.015.014h0v0l.014.014h0v0l.014.014h0v0l.015.014h0v0l.014.013h0v0l.014.014h0v0l.014.014h0v0l.014.014h0v0l.014.013h0v0l.014.014h0v0l.014.014h0v0l.014.014h0v0l.013.013h0v0l.013.013h0v0l.014.013h0v0l.013.013h0v0l.013.014h0v0l.013.013h0v0l.013.013h0v0l.013.013h0v0l.013.013h0v0l.013.012h0v0l.014.013h0v0l.012.012h0v0l.012.012h0v0l.013.012h0v0l.013.012h0v0l.011.011h0v0l.012.012h0v0l.013.012h0v0l.012.012h0v0l.012.012h0v0l.012.011h0v0l.011.012h.005v0l.011.012h0v0l.012.011h0v0l.012.011h0v0l.011.011h.005v.005l.011.011h.005v0l.011.012h0v0l.012.011h.005v.005l.011.011h0v0l.012.012h.005v.005l.011.01h.005v.005l.012.011h.005v.005l.011.011h.005v.005l.011.01h.005v.005l.012.011h.005v.005l.01.01h.007v.006l.01.01h.006v.006l.01.009h.006v.006l.01.01h.006v.006l.01.01h.006v.006l.01.009h.007v.006l.01.009h.006v.006l.01.01h.006v.006l.01.01h.006v.006l.01.01h.007v.006l.01.01h.006v.006l.01.01h.007v.007l.01.01h.006v.006l.01.009h.006v.006l.01.01h.006v.006l.009.009h.008v.008l.009.008h.007v.007l.01.009h.006v.006l.009.009h.008v.007l.009.009h.007v.007l.01.009h.007v.007l.008.008h.008v.007l.009.009h.007v.007l.009.009h.007v.007l.009.008h.007v.007l.009.009h.008v.007l.008.009h.008v.008l.008.008h.008v.008l.009.008h.008v.008l.008.008h.008v.008l.008.008h.008v.008l.008.008h.009v.008l.008.008h.007v.008l.009.008h.008v.008l.008.008h.008v.009l.008.008h.009v.008l.008.008h.009v.008l.008.008h.009v.009l.008.007h.008v.009l.007.007h.009v.008l.008.008h.009v.008l.007.007h.01v.009l.007.007h.009v.009l.007.007h.009v.009l.007.007h.01V199l.007.007h.009v.009l.007.007h.01v.009l.006.006h.01v.009l.007.007h.01v.01l.007.006h.009v.009l.007.007h.009v.009l.006.006h.01v.01l.006.006h.01v.01l.007.006h.01v.01l.006.006h.01v.01l.006.006h.01v.01l.006.006h.01v.01l.006.006h.011v.01l.006.006h.01v.01l.007.007h.01v.01l.006.005h.01v.01l.006.006h.011v.01l.005.005h.011v.011l.005.005h.011v.011l.005,0h.011v.011l0,.005h.011v.01l.006.006h.011v.01l.005.005h.012v.011l.005,0h.011v.011l.005.005h.011v.01l.005.005h.012v.012l.005,0h.011v.011l.005.005h.012v.011l0,0h.011v.012l.005,0h.011v.012l0,0h.012v.012l0,0h.012v.011l0,0h.012v.011l0,0h.012v.012l0,0h.012v.012l0,0h.012v.011l0,0h.012v.012l0,0h.012v.011l0,0h.013v.012l0,0h.012v.012l0,0h.012v.012l0,0h.012v.012l0,0h.012v.012l0,0h.013v.012l0,0h.013v.013l0,0h.014v.013l0,0h.013v.012l0,0h.013v.013l0,0h.013v.013l0,0h.013v.013l0,0h.013v.013l0,0h.014v.014l0,0h.014v.013l0,0h.013v.013l0,0h.013v.013l0,0h.014v.013l0,0h.014v.014l0,0h.014v.013l0,0h.014v.014l0,0h.014v.014l0,0h.014v.014l0,0h.014v.014l0,0h.014v.014l0,0h.014v.013l0,0h.015v.014l0,0h.014v.014l0,0h.014v.014h.016v.014l0,0h.014v.015h.015v.015h.017v.015h.016v.015h.016v.016h.016v.015h.016v.015h.017v.015h.016v.015h.017v.015h.016v.015h.016v.016h.016v.016h.017v.016h16.37l-3.292-3.182Z",
    transform: "translate(-851.922 -134.712)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.531,433.79h.011l-.011-.01Z",
    transform: "translate(-356.402 -296.435)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.583,433.841h.01l-.01-.01Z",
    transform: "translate(-356.438 -296.471)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.634,433.89h.011l-.011-.01Z",
    transform: "translate(-356.473 -296.503)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.48,433.74h.01l-.01-.01Z",
    transform: "translate(-356.367 -296.401)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.429,433.691h.01l-.01-.009Z",
    transform: "translate(-356.333 -296.368)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.841,434.091h.01l-.01-.009Z",
    transform: "translate(-356.614 -296.641)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.892,434.14h.01l-.01-.01Z",
    transform: "translate(-356.649 -296.674)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.376,433.64h.011l-.011-.01Z",
    transform: "translate(-356.297 -296.332)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.945,434.192h.009l-.009-.009Z",
    transform: "translate(-356.685 -296.711)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.791,434.042h.01l-.01-.009Z",
    transform: "translate(-356.58 -296.608)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.687,433.941h.01l-.01-.01Z",
    transform: "translate(-356.509 -296.538)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.738,433.989h.01l-.01-.01Z",
    transform: "translate(-356.544 -296.571)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.858,433.138h.012l-.012-.012Z",
    transform: "translate(-355.943 -295.988)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.911,433.188h.011l-.011-.011Z",
    transform: "translate(-355.979 -296.023)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.962,433.238h.012l-.012-.011Z",
    transform: "translate(-356.013 -296.058)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522,434.243h.009l-.009-.009Z",
    transform: "translate(-356.721 -296.746)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.015,433.289h.012l-.012-.011Z",
    transform: "translate(-356.049 -296.092)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.755,433.036h.012l-.012-.012Z",
    transform: "translate(-355.872 -295.919)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.807,433.088h.012l-.012-.011Z",
    transform: "translate(-355.908 -295.955)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.065,433.338h.011l-.011-.011Z",
    transform: "translate(-356.084 -296.126)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.273,433.538h.011l-.011-.01Z",
    transform: "translate(-356.226 -296.263)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.222,433.49h.011l-.011-.01Z",
    transform: "translate(-356.191 -296.23)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.118,433.389h.011l-.011-.011Z",
    transform: "translate(-356.12 -296.16)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.323,433.588h.011l-.011-.011Z",
    transform: "translate(-356.26 -296.296)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.169,433.438h.011l-.011-.011Z",
    transform: "translate(-356.155 -296.194)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.567,434.795h.009l-.009-.008Z",
    transform: "translate(-357.11 -297.123)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.721,434.945h.009l-.009-.008Z",
    transform: "translate(-357.216 -297.226)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.928,435.145h.008l-.008-.008Z",
    transform: "translate(-357.357 -297.363)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.979,435.195h.008l-.008-.008Z",
    transform: "translate(-357.392 -297.397)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.825,435.045h.008l-.008-.008Z",
    transform: "translate(-357.287 -297.294)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.032,435.247h.008l-.008-.008Z",
    transform: "translate(-357.428 -297.433)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.772,434.994h.008l-.008-.008Z",
    transform: "translate(-357.25 -297.259)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.875,435.094h.009l-.009-.009Z",
    transform: "translate(-357.321 -297.327)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.083,435.3h.008l-.008-.008Z",
    transform: "translate(-357.463 -297.466)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.29,435.5h.008l-.008-.007Z",
    transform: "translate(-357.604 -297.603)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.237,435.446h.008l-.008-.008Z",
    transform: "translate(-357.568 -297.569)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.136,435.347h.008l-.008-.008Z",
    transform: "translate(-357.499 -297.501)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.186,435.4h.008l-.008-.008Z",
    transform: "translate(-357.534 -297.534)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.514,434.744h.009l-.009-.008Z",
    transform: "translate(-357.074 -297.088)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.256,434.493h.009l-.009-.009Z",
    transform: "translate(-356.898 -296.916)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.359,434.594h.009l-.009-.009Z",
    transform: "translate(-356.969 -296.986)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.307,434.542h.01l-.01-.01Z",
    transform: "translate(-356.932 -296.95)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.2,434.442h.01l-.01-.009Z",
    transform: "translate(-356.862 -296.882)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.1,434.342h.01l-.01-.009Z",
    transform: "translate(-356.791 -296.814)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.152,434.393h.009l-.009-.009Z",
    transform: "translate(-356.827 -296.848)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.461,434.692h.009l-.009-.009Z",
    transform: "translate(-357.038 -297.052)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.41,434.643h.009l-.009-.009Z",
    transform: "translate(-357.003 -297.019)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.618,434.843h.008l-.008-.008Z",
    transform: "translate(-357.145 -297.156)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.7,432.987h.012l-.012-.012Z",
    transform: "translate(-355.837 -295.885)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.668,434.894h.009l-.009-.008Z",
    transform: "translate(-357.18 -297.191)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.049,434.292h.01l-.01-.01Z",
    transform: "translate(-356.756 -296.779)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.633,430.979h.016l-.016-.015Z",
    transform: "translate(-354.422 -294.511)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.048,431.381h.014l-.014-.014Z",
    transform: "translate(-354.706 -294.786)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.894,431.23h.014l-.014-.014Z",
    transform: "translate(-354.6 -294.683)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.359,431.683h.014l-.014-.014Z",
    transform: "translate(-354.918 -294.993)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.944,431.281h.015l-.015-.014Z",
    transform: "translate(-354.635 -294.718)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.841,431.18h.016l-.016-.015Z",
    transform: "translate(-354.564 -294.649)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.653,432.938h.012l-.012-.011Z",
    transform: "translate(-355.802 -295.852)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.1,431.433h.014l-.014-.014Z",
    transform: "translate(-354.742 -294.822)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.308,431.632h.014l-.014-.014Z",
    transform: "translate(-354.883 -294.958)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.739,431.08h.014l-.014-.014Z",
    transform: "translate(-354.494 -294.581)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.255,431.582h.014l-.014-.014Z",
    transform: "translate(-354.847 -294.923)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.2,431.531h.014l-.014-.014Z",
    transform: "translate(-354.811 -294.889)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.152,431.482h.015l-.015-.014Z",
    transform: "translate(-354.776 -294.855)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519,431.332h.015l-.015-.014Z",
    transform: "translate(-354.671 -294.753)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.17,430.529h.016l-.016-.015Z",
    transform: "translate(-354.106 -294.203)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.117,430.478h.016l-.016-.016Z",
    transform: "translate(-354.07 -294.168)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.065,430.427h.016l-.016-.016Z",
    transform: "translate(-354.033 -294.133)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.221,430.579h.016l-.016-.015Z",
    transform: "translate(-354.141 -294.238)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.272,430.628h.015l-.015-.016Z",
    transform: "translate(-354.175 -294.271)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.375,430.729h.016l-.016-.015Z",
    transform: "translate(-354.246 -294.34)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.479,430.829h.016l-.016-.016Z",
    transform: "translate(-354.317 -294.408)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.583,430.93h.016l-.016-.015Z",
    transform: "translate(-354.388 -294.478)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.343,435.547h.007l-.007-.007Z",
    transform: "translate(-357.641 -297.638)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.532,430.881h.015l-.015-.014Z",
    transform: "translate(-354.353 -294.444)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.428,430.78h.016l-.016-.015Z",
    transform: "translate(-354.282 -294.375)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.686,431.03h.016l-.016-.015Z",
    transform: "translate(-354.458 -294.546)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.79,431.131h.015l-.015-.014Z",
    transform: "translate(-354.529 -294.615)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.342,432.636h.012l-.012-.012Z",
    transform: "translate(-355.59 -295.645)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.186,432.485h.013l-.013-.013Z",
    transform: "translate(-355.483 -295.541)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.289,432.586h.013l-.013-.012Z",
    transform: "translate(-355.554 -295.611)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.239,432.536h.012l-.012-.012Z",
    transform: "translate(-355.519 -295.577)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.084,432.386h.012l-.012-.012Z",
    transform: "translate(-355.414 -295.475)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.135,432.435h.012l-.012-.012Z",
    transform: "translate(-355.448 -295.508)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.446,432.737h.012l-.012-.012Z",
    transform: "translate(-355.661 -295.715)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.547,432.835h.012l-.012-.012Z",
    transform: "translate(-355.73 -295.781)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.6,432.885h.012l-.012-.012Z",
    transform: "translate(-355.766 -295.816)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.409,431.731h.014l-.014-.014Z",
    transform: "translate(-354.953 -295.026)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.393,432.685h.012l-.012-.012Z",
    transform: "translate(-355.625 -295.679)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.031,432.334h.013l-.013-.013Z",
    transform: "translate(-355.377 -295.438)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.5,432.787h.013l-.013-.012Z",
    transform: "translate(-355.695 -295.748)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.617,431.933h.014l-.014-.014Z",
    transform: "translate(-355.094 -295.164)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.566,431.883h.014l-.014-.013Z",
    transform: "translate(-355.06 -295.13)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.462,431.782h.014l-.014-.014Z",
    transform: "translate(-354.989 -295.061)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.67,431.985h.014l-.014-.013Z",
    transform: "translate(-355.13 -295.2)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.979,432.283h.013l-.013-.013Z",
    transform: "translate(-355.341 -295.404)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.513,431.833h.014l-.014-.014Z",
    transform: "translate(-355.023 -295.096)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.928,432.235h.014l-.014-.013Z",
    transform: "translate(-355.307 -295.37)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.72,432.034h.014l-.014-.013Z",
    transform: "translate(-355.165 -295.233)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.877,432.184h.013l-.013-.013Z",
    transform: "translate(-355.272 -295.336)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.773,432.084h.014l-.014-.013Z",
    transform: "translate(-355.201 -295.268)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.824,432.134h.014l-.014-.014Z",
    transform: "translate(-355.236 -295.301)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.963,436.148h.006l-.006-.006Z",
    transform: "translate(-358.064 -298.049)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.549,438.657h0l0,0Z",
    transform: "translate(-359.831 -299.766)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.86,438.959h0l0,0Z",
    transform: "translate(-360.044 -299.973)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.807,438.907h0l0,0Z",
    transform: "translate(-360.008 -299.937)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.7,438.807h0l0,0Z",
    transform: "translate(-359.937 -299.869)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.652,438.758h0l0,0Z",
    transform: "translate(-359.902 -299.836)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.6,438.708h0l0,0Z",
    transform: "translate(-359.868 -299.801)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.756,438.858h0l0,0Z",
    transform: "translate(-359.973 -299.904)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.91,439.008h0l0,0Z",
    transform: "translate(-360.079 -300.007)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.118,439.209h0l0,0Z",
    transform: "translate(-360.22 -300.144)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.065,439.158h0l0,0Z",
    transform: "translate(-360.184 -300.109)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.963,439.059h0l0,0Z",
    transform: "translate(-360.115 -300.041)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.014,439.109h0l0,0Z",
    transform: "translate(-360.149 -300.076)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.17,439.259h0Z",
    transform: "translate(-360.256 -300.179)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.134,438.255h0l0,0Z",
    transform: "translate(-359.548 -299.492)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.083,438.205h0l0,0Z",
    transform: "translate(-359.513 -299.457)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.98,438.105h0l0,0Z",
    transform: "translate(-359.443 -299.389)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.927,438.055h0l0,0Z",
    transform: "translate(-359.407 -299.354)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.187,438.306h0l0,0Z",
    transform: "translate(-359.584 -299.526)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.291,438.407h0l0,0Z",
    transform: "translate(-359.655 -299.596)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.445,438.557h0l0,0Z",
    transform: "translate(-359.761 -299.698)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.394,438.507h0l0,0Z",
    transform: "translate(-359.726 -299.664)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.238,438.356h0l0,0Z",
    transform: "translate(-359.619 -299.56)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.342,438.456h0l0,0Z",
    transform: "translate(-359.69 -299.629)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.5,438.606h0l0,0Z",
    transform: "translate(-359.795 -299.732)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.033,438.156h0l0,0Z",
    transform: "translate(-359.479 -299.423)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.048,440.112h0Z",
    transform: "translate(-360.856 -300.762)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.841,439.911h0Z",
    transform: "translate(-360.714 -300.624)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.894,439.961h0Z",
    transform: "translate(-360.75 -300.659)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.1,440.162h0Z",
    transform: "translate(-360.892 -300.797)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.946,440.013",
    transform: "translate(-360.786 -300.695)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528,440.062",
    transform: "translate(-360.821 -300.728)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.359,440.414",
    transform: "translate(-361.068 -300.969)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.205,440.263",
    transform: "translate(-360.963 -300.866)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.255,440.313h0Z",
    transform: "translate(-360.998 -300.899)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.152,440.213h0Z",
    transform: "translate(-360.927 -300.832)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.325,439.409h0Z",
    transform: "translate(-360.362 -300.281)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.429,439.511h0Z",
    transform: "translate(-360.433 -300.351)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.79,439.862h0Z",
    transform: "translate(-360.68 -300.591)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.376,439.459h0l0,0Z",
    transform: "translate(-360.396 -300.315)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.272,439.359h0l0,0Z",
    transform: "translate(-360.326 -300.247)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.221,439.31h0Z",
    transform: "translate(-360.291 -300.213)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.479,439.56h0Z",
    transform: "translate(-360.467 -300.384)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.687,439.761h0Z",
    transform: "translate(-360.609 -300.522)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.739,439.811Z",
    transform: "translate(-360.645 -300.556)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.532,439.61h0Z",
    transform: "translate(-360.503 -300.419)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.583,439.661h0Z",
    transform: "translate(-360.538 -300.454)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.636,439.711h0Z",
    transform: "translate(-360.574 -300.488)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.582,436.75h.006l-.006-.006Z",
    transform: "translate(-358.487 -298.461)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.324,436.5h.006l-.006-.006Z",
    transform: "translate(-358.311 -298.289)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.273,436.45h.006l-.006-.006Z",
    transform: "translate(-358.276 -298.256)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.17,436.35h.006l-.006-.006Z",
    transform: "translate(-358.206 -298.188)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.013,436.2h.007l-.007-.007Z",
    transform: "translate(-358.099 -298.082)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.117,436.3h.006l-.006-.006Z",
    transform: "translate(-358.17 -298.152)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.066,436.249h.006l-.006-.006Z",
    transform: "translate(-358.135 -298.119)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.221,436.4h.006l-.006-.006Z",
    transform: "translate(-358.24 -298.221)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.394,435.6h.008l-.008-.008Z",
    transform: "translate(-357.675 -297.672)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.377,436.55h.006l-.006-.006Z",
    transform: "translate(-358.347 -298.324)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.531,436.7h.006l-.006-.006Z",
    transform: "translate(-358.453 -298.427)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.481,436.65h.005l-.005-.005Z",
    transform: "translate(-358.418 -298.393)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.428,436.6h.006l-.006-.006Z",
    transform: "translate(-358.382 -298.359)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.7,435.9h.007l-.007-.007Z",
    transform: "translate(-357.888 -297.878)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.876,438.005h0l0,0Z",
    transform: "translate(-359.372 -299.321)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.6,435.8h.007l-.007-.006Z",
    transform: "translate(-357.817 -297.81)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.5,435.7h.008l-.008-.007Z",
    transform: "translate(-357.746 -297.741)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.652,435.848h.008l-.008-.007Z",
    transform: "translate(-357.852 -297.844)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.444,435.645h.008l-.008-.008Z",
    transform: "translate(-357.71 -297.705)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.859,436.048h.006l-.006-.006Z",
    transform: "translate(-357.993 -297.981)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.912,436.1h.006l-.006-.006Z",
    transform: "translate(-358.029 -298.016)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.325,430.679h.016l-.016-.016Z",
    transform: "translate(-354.211 -294.306)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.635,436.8h.005l-.005-.005Z",
    transform: "translate(-358.523 -298.496)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.755,435.947h.007l-.007-.007Z",
    transform: "translate(-357.922 -297.912)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.806,436h.008l-.008-.007Z",
    transform: "translate(-357.957 -297.946)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.548,435.747h.008l-.008-.008Z",
    transform: "translate(-357.781 -297.774)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.307,437.454h0l0,0Z",
    transform: "translate(-358.983 -298.943)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.462,437.6h0l0,0Z",
    transform: "translate(-359.089 -299.045)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.688,436.851h.005l-.005-.005Z",
    transform: "translate(-358.56 -298.531)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.565,437.7h0l0,0Z",
    transform: "translate(-359.159 -299.114)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.358,437.5h.005l-.005,0Z",
    transform: "translate(-359.018 -298.977)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.515,437.653h0l0,0Z",
    transform: "translate(-359.125 -299.079)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.825,437.955h0l0,0Z",
    transform: "translate(-359.337 -299.286)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.773,437.9h0l0,0Z",
    transform: "translate(-359.301 -299.251)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.669,437.8h0l0,0Z",
    transform: "translate(-359.23 -299.182)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.72,437.854h0l0,0Z",
    transform: "translate(-359.265 -299.217)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.618,437.754h0l0,0Z",
    transform: "translate(-359.196 -299.149)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.411,437.554h0l0,0Z",
    transform: "translate(-359.054 -299.011)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.842,437h.005l-.005-.005Z",
    transform: "translate(-358.665 -298.634)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.257,437.4h0l0,0Z",
    transform: "translate(-358.948 -298.908)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.789,436.951h.005l-.005-.005Z",
    transform: "translate(-358.629 -298.599)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.739,436.9h.006l-.006-.005Z",
    transform: "translate(-358.594 -298.565)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.946,437.1h.005l-.005-.005Z",
    transform: "translate(-358.736 -298.702)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.893,437.051h.006l-.006-.006Z",
    transform: "translate(-358.7 -298.667)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.151,437.3h.005l-.005,0Z",
    transform: "translate(-358.876 -298.839)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.2,437.353h0l0,0Z",
    transform: "translate(-358.912 -298.874)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.1,437.252h.005l-.005-.005Z",
    transform: "translate(-358.841 -298.804)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525,437.152H525l-.005-.005Z",
    transform: "translate(-358.771 -298.736)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.049,437.2h0l0,0Z",
    transform: "translate(-358.807 -298.771)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.036,274.548H594.58V261.109H534.036V251.46h62.61V237.5H518.014v61.079h78.8V284.369H534.036Z",
    transform: "translate(-353.999 -162.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.124,297.086a26.561,26.561,0,0,0,9.909-1.721,22.923,22.923,0,0,0,7.279-4.523,19.265,19.265,0,0,0,4.521-6.332,17.815,17.815,0,0,0,1.552-7.235,17.294,17.294,0,0,0-4.48-12.019q-4.481-4.952-13.352-6.677l-7.668-1.464a7.136,7.136,0,0,1-4.006-1.853,4.549,4.549,0,0,1-1.251-3.229,5.066,5.066,0,0,1,1.94-3.921,7.287,7.287,0,0,1,4.953-1.678,9.839,9.839,0,0,1,3.79.646,7.738,7.738,0,0,1,2.542,1.637,6.557,6.557,0,0,1,1.464,2.153,10.557,10.557,0,0,1,.646,2.2l14.474-2.671a20.507,20.507,0,0,0-1.9-5.946,18,18,0,0,0-4.179-5.47,21.1,21.1,0,0,0-6.847-4,28.262,28.262,0,0,0-9.909-1.552,25.5,25.5,0,0,0-8.787,1.508,23.568,23.568,0,0,0-7.235,4.135,19.421,19.421,0,0,0-4.909,6.288,17.737,17.737,0,0,0-1.811,7.969,16.935,16.935,0,0,0,4.48,11.975q4.481,4.825,12.665,6.374l7.58,1.467a7.62,7.62,0,0,1,4.222,1.937,4.717,4.717,0,0,1,1.379,3.4,4.937,4.937,0,0,1-1.9,3.921,7.781,7.781,0,0,1-5.169,1.593,12.106,12.106,0,0,1-4.436-.731,9.859,9.859,0,0,1-3.144-1.94,8.136,8.136,0,0,1-1.981-2.843,9.8,9.8,0,0,1-.774-3.358l-14.646,2.5a20.568,20.568,0,0,0,6.332,12.922,23.47,23.47,0,0,0,7.58,4.693,29.661,29.661,0,0,0,11.069,1.853",
    transform: "translate(-540.648 -159.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.7,418.642a26.569,26.569,0,0,1-9.909,1.721,29.667,29.667,0,0,1-11.07-1.853,23.476,23.476,0,0,1-7.58-4.693l.007.006.01.009a.017.017,0,0,0,.006.006l.01.01.007.007.009.009.006,0,.011.011.007.006.009.01.007.006.01.009.006.005.01.01.008.006.009.01.006.005.009.011.007.005.01.01.006.005.01.011.007.006.01.009.006.006.01.01.007.006.009.009.007.006.01.01.007.006.01.01.007.006a.114.114,0,0,1,.01.009l.006.006.01.01.008.006.009.009.007.005.01.01.007.007.01.009.006.005.01.011.006.005.011.01.006.005.01.011.007.006.009.009.007.006.01.01.007.006s.006.007.01.009l.007.006.009.009.006,0,.01.011.008.007.009.009.007.006.01.01.007.006.01.01.006.005.01.01.008.007.009.01.005,0,.011.012.007.006.009.01.006.005.01.011.007.006.01.009.007.007.009.01.006.005.01.01.008.006.009.01.005,0,.011.011.007.007a.094.094,0,0,1,.01.009l.006.006.01.01.008.006.009.01.007.005.01.01.007.007.01.009.005,0,.011.011.007.006.01.01.007.006.009.009.007.006.01.01.008.007.009.009.006.005.01.01s0,0,.006.006a.1.1,0,0,0,.01.01l.006.006.01.01.008.006.009.009.007.006.01.01.007.006.01.01.006.005.01.01.008.006.009.009.007.005.01.01.007.006.009.011.008.006.009.009.006.006.01.01.007.006.009.01.006.005.009.01.007.006.01.01.006.006.01.01.007.006.01.009.006.006.01.01.008.007.009.009.007.006.009.01.006,0,.01.012.008.006.009.01.006.006.01.01.007.006.009.009.007.006.009.01.008.006.009.01.006.005.01.01s0,0,.006.006a.079.079,0,0,0,.01.01l.006.006.009.01.008.006.009.009.007.006.009.009.006.005.01.011.007.006.009.01.006,0,.011.012.007.006.009.009.007.006.009.01.008.007.009.009.006.006.01.01.007.006.009.01.006,0,.01.011.008.007.009.01.007.006.009.01.006.005.01.01.007.006.009.009.007.005.01.011.007.006.009.01.006,0,.01.012.008.006.009.01.006.006.01.01.007.007.009.009.007.006.009.01a.019.019,0,0,1,.006.006l.01.01.006.005.01.01.006.006.01.01.007.007.009.009.007.005.01.01.007.006.009.01.006.005.01.011.006.005a.1.1,0,0,0,.01.01l.006.005.01.011.007.006.009.01.007.006.009.009.006.005.01.01.007.007.01.009.006.006.009.01.007.005.01.01.007.006.01.01.007.007.009.01.006.005a.14.14,0,0,0,.01.01l.007.006.009.01.007.005.01.011.007.005.009.01a.046.046,0,0,1,.007.007l.009.009.006.006.01.01.007.006.009.01.007.005.01.01.007.007.009.009.006,0,.011.012.007.006s.006.007.009.009l.006.006.01.01.007.007.009.01.007.005.01.01.007.006.009.01.007.006.01.01.005,0,.011.011.007.007s.006.006.009.009,0,0,.007.006l.01.011.007.006.009.01.006.005.01.01.007.007.01.01.005,0,.011.012.007.006.009.009.006.006a.131.131,0,0,1,.011.01l.007.006.009.009.007.006.01.01.006.005.009.011.007.005.01.01.006.006.01.01.007.007.009.009.006.006.01.01.007.006.009.01.007.005.01.01.007.006.009.009.006,0,.011.011.007.006.009.009.007.006.009.01.007.005.01.011.008.006.009.009.006.005.01.011.006.005.01.01.006.006.01.01.007.006a.123.123,0,0,0,.01.009s0,0,.007.006l.01.01.007.006.009.01.006.005.011.01.006.006a.1.1,0,0,1,.01.01l.007.006.009.009.007.005.01.01.008.006.009.01.006.005.01.011.007.006.01.009.006.005.01.011.007.005.01.01.006.006.01.01.007.006.009.009.006.006.01.01.007.007.01.01.007.006.009.009.006.005a.1.1,0,0,1,.01.011l.008.006.009.009.006.005.01.01.007.007.01.009.007.005.01.011.008.006.009.01.005,0,.011.011.007.006.009.009.006.006.01.01.007.006s.006.007.01.009l.007.006.009.009.006.006.01.01.008.007.009.009.005.005.011.011.007.006.01.01.007.005.009.01.008.007.009.01.006.005.01.011.007.006.01.01.005,0,.011.011.007.006.009.009a23.478,23.478,0,0,0,7.58,4.693,29.658,29.658,0,0,0,11.069,1.853,26.568,26.568,0,0,0,9.909-1.721c.5-.2.971-.426,1.445-.649l-3.219-3.215c-.5.235-.992.471-1.518.682",
    transform: "translate(-554.315 -282.794)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.3,373.256a10.909,10.909,0,0,1-1.314-.654,8.091,8.091,0,0,1-.519-.948,9.8,9.8,0,0,1-.774-3.358l-.014,0c0-.006,0-.012,0-.018l-.014,0a.152.152,0,0,1,0-.018l-.014,0a.139.139,0,0,0,0-.018l-.013,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.17.17,0,0,0,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0a.158.158,0,0,0,0-.018l-.013,0c0-.006,0-.013,0-.019l-.014,0a.181.181,0,0,1,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.013,0c0-.006,0-.012,0-.018l-.013,0a.15.15,0,0,1,0-.018l-.014,0a.149.149,0,0,0,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.013,0a.122.122,0,0,1,0-.018l-.014,0a.176.176,0,0,0,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.019l-.013,0c0-.006,0-.011,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0a.168.168,0,0,0,0-.018l-.014,0a.141.141,0,0,1,0-.018l-.014,0a.143.143,0,0,0,0-.018l-.013,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.161.161,0,0,0,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0a.156.156,0,0,0,0-.018l-.013,0c0-.006,0-.012,0-.019l-.014,0a.149.149,0,0,1,0-.019l-.014,0c0-.006,0-.011,0-.018l-.014,0a.166.166,0,0,0,0-.019l-.013,0a.168.168,0,0,0,0-.018l-.013,0a.147.147,0,0,1,0-.018l-.014,0a.155.155,0,0,0,0-.018l-.014,0a.175.175,0,0,1,0-.018l-.014,0a.177.177,0,0,0,0-.018l-.013,0c0-.006,0-.012,0-.018l-.014,0a.169.169,0,0,0,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0a.18.18,0,0,1,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.019l-.013,0c0-.006,0-.011,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.156.156,0,0,0,0-.018l-.014,0a.137.137,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.018l-.013,0a.157.157,0,0,1,0-.018l-.014,0a.154.154,0,0,0,0-.019l-.013,0c0-.007,0-.012,0-.018l-.014,0c0-.006,0-.013,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0a.147.147,0,0,0,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0a.173.173,0,0,1,0-.019l-.014,0c0-.006,0-.011,0-.018l-.014,0a.166.166,0,0,1,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0a.158.158,0,0,1,0-.018l-.014,0a.146.146,0,0,0,0-.018l-.014,0a.156.156,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.018l-.013,0c0-.007,0-.012,0-.018l-.014,0a.157.157,0,0,0,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0a.171.171,0,0,1,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.019l-.013,0c0-.006,0-.012,0-.018l-.014,0a.177.177,0,0,1,0-.018l-.014,0a.177.177,0,0,0,0-.018l-.014,0a.172.172,0,0,1,0-.018l-.014,0a.159.159,0,0,0,0-.018l-.013,0a.144.144,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.007,0-.012,0-.018l-.014,0c0-.007,0-.013,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.179.179,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.018l-.013,0a.128.128,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.156.156,0,0,1,0-.018l-.014,0a.151.151,0,0,0,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.013,0c0-.006,0-.012,0-.018l-.014,0a.177.177,0,0,0,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0a.148.148,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0a.11.11,0,0,0,0-.018l-.013,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.169.169,0,0,1,0-.018l-.014,0a.137.137,0,0,0,0-.018l-.013,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.013,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.151.151,0,0,1,0-.018l-.014,0a.152.152,0,0,0,0-.018l-.014,0c0-.007,0-.013,0-.019l-.013,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0a.175.175,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.011,0-.018l-.014,0c0-.007,0-.012,0-.018l-.014,0a.167.167,0,0,0,0-.018l-.014,0a.167.167,0,0,1,0-.019l-.014,0a.17.17,0,0,0,0-.018l-.014,0c0-.007,0-.013,0-.019l-.014,0a.177.177,0,0,0,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0a.186.186,0,0,1,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0a.171.171,0,0,1,0-.018l-.014,0c0-.006,0-.011,0-.018l-.013,0c0-.007,0-.012,0-.018l-.014,0a.18.18,0,0,0,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0a.156.156,0,0,0,0-.018l-.014,0c0-.006,0-.013,0-.018l-.013,0c0-.007,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0a.156.156,0,0,1,0-.018l-.014,0c0-.007,0-.012,0-.018l-.013,0a.181.181,0,0,1,0-.018l-.014,0c0-.006,0-.011,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.156.156,0,0,0,0-.018l-.013,0a.132.132,0,0,1,0-.019l-.014,0a.158.158,0,0,0,0-.018l-.014,0c0-.006,0-.013,0-.019l-.014,0a.168.168,0,0,0,0-.019l-.014,0c0-.006,0-.012,0-.018l-.013,0a.179.179,0,0,1,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.011,0-.018l-.014,0c0-.007,0-.012,0-.018l-.014,0a.165.165,0,0,1,0-.018l-.014,0c0-.006,0-.011,0-.018l-.013,0c0-.006,0-.012,0-.018l-.014,0a.156.156,0,0,0,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0a.146.146,0,0,0,0-.018l-.014,0c0-.006,0-.013,0-.019l-.013,0a.172.172,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.163.163,0,0,0,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0a.138.138,0,0,1,0-.018l-.014,0a.147.147,0,0,0,0-.018l-.013,0a.179.179,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.018l-.014,0a.179.179,0,0,1,0-.018l-.014,0a.162.162,0,0,0,0-.018l-.013,0c0-.007,0-.012,0-.019l-.014,0a.146.146,0,0,0,0-.018l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.013,0c0-.007,0-.012,0-.019l-.014,0c0-.006,0-.012,0-.018l-.014,0c0-.006,0-.011,0-.018l-.014,0a.154.154,0,0,0,0-.018l-.014,0a.176.176,0,0,1,0-.018l-.014,0c0-.006,0-.012,0-.018l-.013,0c0-.006,0-.012,0-.018l-.014,0a.18.18,0,0,0,0-.018l-.014,0c0-.007,0-.012,0-.019l-.014,0a.17.17,0,0,0,0-.018l-.014,0c0-.006,0-.012,0-.019l-.013,0a.149.149,0,0,1,0-.019l-.014,0c0-.006,0-.011,0-.018a9.8,9.8,0,0,0,.774,3.358,8.139,8.139,0,0,0,1.981,2.843,9.863,9.863,0,0,0,3.144,1.94",
    transform: "translate(-572.259 -249.511)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.6,276.794a7.741,7.741,0,0,0-2.542-1.637,9.838,9.838,0,0,0-3.79-.646,7.287,7.287,0,0,0-4.953,1.677,5.066,5.066,0,0,0-1.94,3.921c0,.064.014.122.016.185a4.526,4.526,0,0,0,1.235,3.045,5.686,5.686,0,0,0,2.26,1.37,4.895,4.895,0,0,1-.218-1.417,4.754,4.754,0,0,1,1.062-3,6.68,6.68,0,0,1,.879-.924,7.287,7.287,0,0,1,4.953-1.678,9.838,9.838,0,0,1,3.79.646c.2.082.353.188.536.279.054.111.131.215.178.329a6.563,6.563,0,0,0-1.464-2.154",
    transform: "translate(-578.39 -187.595)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.707,356.4a17.814,17.814,0,0,0,1.551-7.235,17.293,17.293,0,0,0-4.48-12.019l-.015-.013,0,0s-.009-.008-.014-.012l0,0-.015-.013,0,0c0-.005-.01-.009-.014-.013l0,0-.014-.013,0,0s-.01-.008-.014-.012l0,0a.164.164,0,0,0-.015-.013l0,0s-.009-.008-.013-.012l0,0s-.01-.008-.014-.013l0,0-.014-.013,0,0s-.01-.008-.014-.013l0,0s-.01-.008-.015-.013l0,0s-.01-.008-.014-.013l0,0-.014-.013,0,0s-.01-.008-.014-.012l0,0-.014-.013,0,0a.151.151,0,0,0-.014-.013l0,0-.015-.013,0,0-.013-.012,0,0c0-.005-.01-.008-.014-.013s0,0,0,0l-.013-.012,0,0s-.01-.008-.014-.013l0,0a.169.169,0,0,0-.015-.013l0,0s-.01-.008-.014-.012l0,0s-.01-.008-.014-.013l0,0a.136.136,0,0,1-.014-.013l0,0-.014-.012,0,0-.013-.013a.005.005,0,0,1,0,0l-.015-.013,0,0c0-.005-.01-.008-.014-.013l0,0-.014-.013,0,0s-.009-.008-.014-.012l0,0c0-.005-.01-.008-.015-.013l0,0s-.009-.008-.013-.012l0,0-.014-.012,0,0a.106.106,0,0,0-.014-.013l0,0-.014-.012,0,0s-.01-.008-.015-.013l0,0s-.009-.008-.014-.013l0,0-.014-.012,0,0s-.01-.009-.014-.013l0,0a.189.189,0,0,1-.014-.013l0,0a.176.176,0,0,0-.014-.013l0,0-.015-.013,0,0s-.01-.008-.014-.013l0,0s-.01-.008-.014-.012l0,0-.014-.013,0,0-.014-.012,0,0c0-.005-.01-.008-.015-.013l0,0a.173.173,0,0,0-.014-.012l0,0s-.01-.008-.014-.013l0,0a.119.119,0,0,1-.014-.013l0,0-.014-.012,0,0-.013-.013,0,0-.015-.013,0,0c0-.005-.01-.008-.014-.013l0,0-.014-.012,0,0s-.01-.008-.014-.013l0,0-.013-.012,0,0-.015-.013,0,0-.014-.012,0,0a.143.143,0,0,0-.014-.013l0,0-.014-.012,0,0-.015-.013,0,0-.013-.012,0,0-.015-.013,0,0s-.01-.008-.014-.013l0,0-.014-.012,0,0c0-.005-.01-.008-.014-.013l0,0-.014-.012,0,0s-.01-.008-.014-.013l0,0s-.01-.008-.014-.012l0,0-.014-.013,0,0a.112.112,0,0,1-.014-.012l0,0c0-.005-.01-.008-.015-.013l0,0-.014-.012,0,0s-.01-.008-.014-.013l0,0s-.01-.008-.014-.012l0,0c0-.005-.01-.008-.014-.013l0,0-.014-.013,0,0-.014-.012,0,0a.152.152,0,0,0-.014-.013l0,0-.014-.012,0,0s-.01-.008-.014-.012l0,0-.013-.013,0,0-.015-.013,0,0-.014-.012,0,0a.182.182,0,0,0-.014-.013l0,0-.014-.013,0,0-.014-.013s0,0,0,0l-.013-.012,0,0-.014-.013,0,0s-.01-.008-.014-.013l0,0-.014-.012,0,0c0-.005-.01-.009-.014-.013l0,0-.014-.012,0,0s-.01-.008-.014-.012l0,0s-.01-.008-.014-.013l0,0a.141.141,0,0,0-.014-.013l0,0a.131.131,0,0,1-.014-.013l0,0a.1.1,0,0,1-.014-.013l0,0s-.01-.008-.014-.013l0,0-.013-.012,0,0a.143.143,0,0,0-.014-.013l0,0c0-.005-.009-.009-.014-.013l0,0s-.01-.008-.014-.013l0,0-.014-.012,0,0a.11.11,0,0,0-.014-.013l0,0-.014-.013,0,0-.013-.012,0,0c0-.005-.01-.008-.014-.013l0,0s-.01-.008-.014-.012l0,0s-.01-.008-.014-.013l0,0-.014-.013,0,0s-.01-.008-.014-.013l0,0-.013-.012,0,0s-.01-.009-.014-.013l0,0-.014-.013a.006.006,0,0,0,0,0l-.014-.013,0,0a.178.178,0,0,1-.014-.013l0,0-.013-.013,0,0-.013-.012,0,0a.116.116,0,0,1-.014-.012l0,0c0-.005-.01-.008-.014-.013l0,0a.155.155,0,0,0-.014-.012l0,0a.127.127,0,0,1-.014-.013l0,0a.143.143,0,0,1-.014-.013l0,0s-.01-.008-.014-.013l0,0-.013-.012,0,0a.176.176,0,0,0-.014-.013l0,0c0-.005-.01-.009-.014-.013l0,0-.013-.012,0,0a.16.16,0,0,1-.015-.013l0,0-.014-.013,0,0s-.01-.008-.014-.012l0,0-.013-.012,0,0c0-.005-.01-.008-.014-.013l0,0s-.01-.008-.014-.012l0,0s-.01-.008-.014-.013l0,0s-.009-.008-.014-.013l0,0-.014-.012,0,0a.185.185,0,0,1-.014-.013l0,0-.014-.012,0,0a.148.148,0,0,0-.015-.013l0,0a.151.151,0,0,0-.014-.012l0,0a.131.131,0,0,1-.014-.013l0,0-.013-.013,0,0a.18.18,0,0,1-.014-.012l0,0a.181.181,0,0,1-.014-.012l0,0c0-.005-.01-.009-.014-.013l0,0-.014-.012,0,0a.141.141,0,0,1-.014-.013l0,0-.015-.013,0,0a.156.156,0,0,0-.014-.012l0,0-.015-.013,0,0s-.01-.008-.014-.012l0,0c0-.005-.01-.008-.014-.013s0,0,0,0a.154.154,0,0,0-.013-.012l0,0a.184.184,0,0,1-.015-.013l0,0s-.009-.008-.014-.012l0,0s-.01-.008-.014-.013,0,0,0,0l-.013-.012,0,0c0-.005-.01-.009-.014-.013l0,0-.015-.013,0,0s-.01-.008-.014-.013l0,0a.149.149,0,0,0-.014-.013l0,0s-.01-.008-.013-.012l0,0-.014-.013,0,0s-.01-.008-.014-.012l0,0c0-.005-.01-.008-.015-.013l0,0a.161.161,0,0,0-.014-.012l0,0s-.01-.008-.014-.013l0,0s-.009-.008-.013-.012l0,0a.144.144,0,0,1-.014-.013l0,0s-.01-.008-.015-.013l0,0s-.009-.008-.014-.013l0,0a.177.177,0,0,0-.014-.013l0,0a.163.163,0,0,1-.013-.013l0,0a.179.179,0,0,1-.014-.012l0,0c0-.005-.01-.008-.014-.013l0,0-.015-.013,0,0-.014-.012,0,0c0-.005-.01-.008-.014-.013s0,0,0,0l-.013-.012,0,0s-.01-.008-.015-.013l0,0s-.01-.008-.014-.013,0,0,0,0-.009-.008-.014-.012l0,0s-.01-.008-.014-.013l0,0a.108.108,0,0,1-.013-.013.006.006,0,0,1,0,0l-.015-.013,0,0-.014-.013,0,0-.014-.012,0,0c0-.005-.01-.008-.013-.013l0,0-.014-.013,0,0s-.01-.008-.014-.012l0,0c0-.005-.01-.008-.015-.013l0,0s-.009-.008-.014-.013l0,0-.013-.011,0,0a.107.107,0,0,0-.014-.013l0,0a.148.148,0,0,1-.014-.012l0,0a.167.167,0,0,1-.015-.013,17.3,17.3,0,0,1,4.478,12.017,17.814,17.814,0,0,1-1.552,7.235,19.265,19.265,0,0,1-4.521,6.332,22.155,22.155,0,0,1-5.761,3.842l3.219,3.215a22.191,22.191,0,0,0,5.834-3.874,19.265,19.265,0,0,0,4.521-6.332",
    transform: "translate(-619.231 -228.224)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.4,370.7l-.054-.018a4.694,4.694,0,0,1,.247.769,5.322,5.322,0,0,0-.194-.751",
    transform: "translate(-609.123 -253.315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.727,334.1l.014.013h0l-.014-.012",
    transform: "translate(-554.032 -228.314)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.224,343.9A7.619,7.619,0,0,0,831,341.964l-7.58-1.467a25.5,25.5,0,0,1-8.812-3.32,18.469,18.469,0,0,1-3.839-3.041l0,0,.013.012,0,0s.01.008.014.012l0,0,.013.012,0,0c0,.005.009.008.013.013l0,0a.1.1,0,0,1,.014.012l0,0,.014.011,0,0s.01.008.014.012l0,0,.013.012,0,0a.094.094,0,0,1,.013.012l0,0,.014.011,0,0s.01.008.014.012l0,0s.009.008.013.012l0,0,.014.012,0,0s.009.008.013.012l0,0,.013.012,0,0,.013.012,0,0,.014.012,0,0,.015.012,0,0a.131.131,0,0,1,.012.011l0,0a.16.16,0,0,1,.014.012l0,0s.009.007.014.012a.011.011,0,0,0,0,0l.013.012,0,0,.013.011,0,0s.01.008.013.012l0,0,.013.012,0,0s.01.008.014.012l0,0c0,.005.009.008.013.013l0,0,.013.011,0,0,.014.012,0,0,.013.012,0,0,.013.012,0,0,.013.012,0,0,.015.012,0,0,.012.011,0,.005.014.012,0,0s.01.008.013.012l0,0s.01.008.013.012l0,0,.014.012,0,0s.01.008.013.012l0,0c0,.005.009.008.014.013l0,0s.009.007.013.012l0,0s.01.008.014.012l0,0,.014.012,0,0a.165.165,0,0,0,.014.012l0,0a.133.133,0,0,1,.013.012l0,0,.013.012,0,0,.013.011,0,.005.014.012,0,0,.013.012,0,0a.161.161,0,0,1,.013.012l0,0,.014.012,0,0,.013.011,0,0s.009.008.013.012l0,0s.009.008.013.012l0,0,.014.012,0,0s.009.008.012.012l0,0,.014.012,0,0,.014.012,0,0,.014.012,0,0,.013.011,0,0,.013.012,0,0,.014.012,0,0s.01.008.014.012l0,0a.173.173,0,0,0,.013.012l0,0,.013.011,0,0s.009.008.013.012l0,0,.013.012,0,0a.127.127,0,0,1,.013.012l0,0a.15.15,0,0,0,.013.012l0,0,.014.012,0,0a.11.11,0,0,0,.013.012l0,0,.013.012,0,0,.014.012s0,0,0,0a.159.159,0,0,0,.014.012l0,0a.128.128,0,0,0,.014.012l0,0,.013.012,0,0a.129.129,0,0,1,.014.012l0,0,.014.011,0,0s.009.008.013.012l0,0a.132.132,0,0,0,.014.012l0,0,.014.012,0,0,.013.012,0,0,.014.011,0,0s.01.008.013.012l0,0,.013.012,0,0s.009.008.013.012l0,0s.01.008.014.012l0,0,.014.012s0,0,0,0a.131.131,0,0,0,.014.012l0,0,.014.012,0,0a.14.14,0,0,1,.012.011l0,0c0,.005.01.008.014.013l0,0s.009.008.014.012l0,0a.125.125,0,0,1,.013.012l0,0s.01.008.014.012l0,0s.01.007.013.011,0,0,0,0l.013.011,0,0s.009.007.013.012l0,0,.014.012,0,0a.134.134,0,0,0,.014.012l0,0a.117.117,0,0,0,.013.012l0,0c0,.005.01.008.014.013l0,0,.013.012,0,0s.009.007.013.012l0,0,.014.012,0,0s.009.008.013.012a.006.006,0,0,1,0,0s.01.007.014.012l0,0,.014.012,0,0s.01.007.013.011l0,0,.013.011,0,0a.083.083,0,0,0,.013.012l0,0,.013.012,0,0s.009.008.014.012l0,0,.014.011,0,0c0,.005.01.008.014.013l0,0a.117.117,0,0,0,.013.012l0,0,.014.012,0,0s.009.008.013.012l0,0,.013.012,0,0,.014.012,0,0,.013.012,0,0s.01.007.014.012l0,0s.009.007.012.011l0,0a.118.118,0,0,1,.013.012l0,0s.01.008.013.012l0,0s.009.008.013.012l0,0,.013.012,0,0c0,.005.009.008.013.013s0,0,0,0,.009.007.013.012l0,0s.009.008.014.012l0,0,.014.012,0,0s.01.008.014.012l0,0s.009.007.013.011l0,0,.013.012,0,0,.014.012,0,0s.009.007.013.012l0,0s.01.008.013.012l0,0s.009.008.012.012l0,0a.121.121,0,0,1,.013.012l0,0a.114.114,0,0,1,.013.012l0,0c0,.005.01.008.013.013s0,0,0,0l.013.011,0,0a.167.167,0,0,0,.013.012s0,0,0,0,.01.008.014.012l0,0,.014.012,0,0,.014.011,0,0a.1.1,0,0,0,.014.011.01.01,0,0,0,0,0s.009.007.013.012l0,0s.009.008.013.012l0,0,.014.012,0,0s.01.008.014.012l0,0s.01.008.014.012l0,0,.012.012,0,0a.108.108,0,0,1,.013.013.006.006,0,0,1,0,0s.009.007.013.011l0,0s.009.008.013.012l0,0,.014.012,0,0s.009.007.013.012l0,0,.014.011,0,0,.013.011,0,0s.01.007.014.012l0,0,.014.012,0,0,.013.012,0,0,.013.012,0,0,.014.012,0,0,.013.012,0,0,.013.012,0,0s.009.008.013.012l0,0,.013.011,0,0,.014.012,0,0s.009.007.013.012l0,0,.014.012,0,0a.1.1,0,0,0,.013.011l0,0,.014.011,0,0,.013.012,0,0s.01.008.014.012l0,0,.014.012,0,0s.009.008.013.012l0,0,.013.012,0,0,.013.012,0,0s.01.008.014.012l0,0a.115.115,0,0,1,.013.011l0,0s.01.008.013.012l0,0s.009.007.013.012l0,0,.014.012,0,0s.009.007.013.011l0,0,.014.012,0,0,.014.012,0,0,.014.012,0,0a.159.159,0,0,0,.013.013l0,0s.01.008.014.012l0,0,.015.012,0,0a.108.108,0,0,0,.013.012l0,0a.134.134,0,0,1,.014.012l0,0,.013.011a.008.008,0,0,0,0,0l.014.012,0,0s.01.007.013.012l0,0,.013.012,0,0a.137.137,0,0,1,.013.012l0,0s.009.008.013.012,0,0,0,0a18.384,18.384,0,0,0,3.576,2.884,25.257,25.257,0,0,0,9.088,3.489l7.581,1.467a10.717,10.717,0,0,1,1.988.562,4.683,4.683,0,0,0-1.057-1.806",
    transform: "translate(-554.062 -228.342)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.434,288.855l-4.591.847a.121.121,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.019l.012,0a.157.157,0,0,1,0,.018l.013,0a.143.143,0,0,0,0,.019l.012,0a.156.156,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.018l.013,0a.154.154,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.019l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.018l.012,0c0,.006,0,.012,0,.018l.013,0a.112.112,0,0,0,0,.018l.012,0a.121.121,0,0,0,0,.018l.012,0a.158.158,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0a.142.142,0,0,1,0,.019l.012,0c0,.006,0,.012,0,.018l.013,0a.17.17,0,0,0,0,.019l.012,0c0,.006,0,.012,0,.018l.012,0a.184.184,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.013,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.013,0c0,.006,0,.012,0,.019l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.018l.012,0a.112.112,0,0,1,0,.018l.013,0a.172.172,0,0,0,0,.018l.012,0a.17.17,0,0,0,0,.018l.012,0,0,.018.012,0c0,.006,0,.011,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.011,0a.143.143,0,0,1,0,.018l.012,0a.171.171,0,0,1,0,.018l.013,0a.133.133,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.007,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.019l.013,0c0,.006,0,.012,0,.018l.012,0a.159.159,0,0,0,0,.018l.012,0c0,.006,0,.013,0,.018l.012,0a.175.175,0,0,1,0,.018l.013,0c0,.006,0,.012,0,.018l.012,0a.131.131,0,0,0,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.019l.012,0c0,.006,0,.012,0,.018l.012,0a.143.143,0,0,0,0,.019l.011,0a.174.174,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.013,0a.114.114,0,0,0,0,.018l.012,0a.164.164,0,0,0,0,.018l.012,0a.157.157,0,0,1,0,.018l.012,0c0,.006,0,.013,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0,0,.019.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.019l.013,0c0,.006,0,.012,0,.018l.012,0a.157.157,0,0,0,0,.018l.012,0c0,.007,0,.013,0,.018l.012,0c0,.006,0,.012,0,.018l.013,0c0,.006,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.005,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0a.145.145,0,0,0,0,.018l.012,0a.156.156,0,0,0,0,.019l.011,0a.176.176,0,0,1,0,.018l.012,0a.172.172,0,0,1,0,.018l.013,0a.142.142,0,0,0,0,.018l.012,0a.161.161,0,0,0,0,.018l.012,0a.166.166,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.005,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.019l.011,0c0,.006,0,.012,0,.018l.012,0c0,.007,0,.013,0,.018l.013,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.011,0a.145.145,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.005,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0a.127.127,0,0,0,0,.018l.011,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.013,0a.156.156,0,0,0,0,.018l.012,0a.158.158,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.005,0,.011,0,.018l.012,0,0,.018.012,0c0,.006,0,.013,0,.019l.012,0a.177.177,0,0,0,0,.018l.011,0a.161.161,0,0,1,0,.018l.012,0c0,.007,0,.013,0,.018l.013,0a.168.168,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.011,0c0,.006,0,.012,0,.018l.012,0a.172.172,0,0,1,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.019l.012,0,0,.018.012,0c0,.007,0,.013,0,.019l.012,0a.17.17,0,0,1,0,.018l.013,0c0,.006,0,.012,0,.018l.012,0a.124.124,0,0,0,0,.018l.011,0c0,.006,0,.012,0,.018l.012,0a.174.174,0,0,1,0,.018l.013,0a.159.159,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.019l.012,0,0,.018.012,0c0,.007,0,.013,0,.019l.012,0a.122.122,0,0,0,0,.018l.011,0a.16.16,0,0,1,0,.018l.012,0c0,.006,0,.013,0,.018l.013,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.011,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0c0,.005,0,.011,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.019l.012,0,0,.018.012,0c0,.006,0,.013,0,.018l.012,0c0,.006,0,.012,0,.018l.013,0c0,.006,0,.012,0,.018l.012,0c0,.006,0,.013,0,.018l.011,0a.147.147,0,0,1,0,.018l.012,0a.17.17,0,0,1,0,.018l.013,0a.171.171,0,0,0,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0a.182.182,0,0,1,0,.018l.012,0c0,.006,0,.012,0,.018l.012,0,0,.018.012,0c0,.006,0,.012,0,.019l.012,0,0,.018.012,0c0,.006,0,.013,0,.019l.012,0c0,.006,0,.012,0,.018l14.365-2.651-3.2-3.2Z",
    transform: "translate(-611.515 -196.155)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.379,264.207a21.135,21.135,0,0,0-1.578-4.585,18,18,0,0,0-4.178-5.47l0,0-.014-.013h0l-.015-.016,0,0a.139.139,0,0,0-.014-.014h0l-.014-.015,0,0-.014-.014h0l-.015-.014,0,0-.014-.014h0l-.016-.016,0,0-.014-.014h0l-.014-.015,0,0-.014-.014,0,0-.014-.014h0l-.015-.015,0,0-.013-.014h0l-.015-.015,0,0c-.005,0-.009-.01-.014-.014h0l-.015-.015,0,0-.014-.014h0l-.015-.014,0,0-.014-.013h0l-.016-.016,0,0-.014-.014,0,0c-.005,0-.009-.009-.014-.014h0l-.016-.015,0,0-.013-.014h0c-.005,0-.009-.01-.014-.015h0l-.015-.014h0l-.015-.015,0,0c-.005,0-.009-.01-.014-.013h0l-.015-.015,0,0-.014-.014h0l-.015-.014,0,0-.014-.013h0l-.015-.015h0l-.015-.014,0,0-.013-.014h0c-.005,0-.009-.009-.014-.015s0,0,0,0L924,253.55h0l-.016-.015h0l-.015-.014h0l-.015-.015,0,0-.014-.013h0l-.015-.015,0,0-.014-.014,0,0-.013-.014h0l-.015-.015,0,0-.014-.014h0l-.014-.014,0,0c-.005,0-.009-.009-.014-.014h0l-.016-.015,0,0-.013-.013h0l-.014-.015h0l-.015-.014h0l-.015-.015,0,0c-.005,0-.009-.009-.014-.013l0,0-.013-.013h0l-.015-.015,0,0-.014-.014h0l-.016-.016,0,0-.014-.014h0l-.015-.014,0,0s-.009-.009-.014-.014h0l-.014-.015,0,0-.014-.013h0l-.016-.015,0,0-.014-.014,0,0-.014-.014h0l-.015-.014,0,0-.014-.013h0l-.015-.015,0,0-.013-.014h0l-.016-.016,0,0-.014-.014h0l-.014-.014,0,0-.014-.014h0l-.015-.015,0,0-.013-.014h0l-.014-.014h0l-.015-.015,0,0-.014-.014h0l-.015-.014,0,0-.013-.014h0l-.015-.015h0l-.015-.014h0c-.005-.005-.009-.01-.014-.015l0,0-.014-.014h0l-.015-.014,0,0-.014-.013,0,0-.014-.014h0l-.015-.015h0l-.015-.014h0l-.015-.015,0,0-.014-.014h0l-.015-.014,0,0-.014-.014h0l-.015-.015h0l-.015-.014h0l-.016-.015,0,0-.014-.014,0,0-.014-.014h0l-.015-.015,0,0-.014-.014h0l-.016-.016,0,0s-.008-.009-.014-.014h0l-.015-.015s0,0,0,0l-.014-.014h0l-.015-.014,0,0-.013-.014,0,0-.014-.014h0l-.015-.015,0,0-.014-.014h0l-.015-.015,0,0-.014-.014h0l-.015-.015,0,0-.014-.013h0l-.015-.016,0,0-.013-.014h0l-.015-.015,0,0-.014-.014,0,0-.014-.014h0l-.015-.015h0a.19.19,0,0,1-.014-.015h0l-.015-.014,0,0a.178.178,0,0,1-.014-.013h0l-.015-.015,0,0-.014-.014h0l-.015-.015,0,0-.014-.013h0l-.015-.016,0,0s-.009-.01-.014-.014l0,0-.014-.014h0l-.015-.015,0,0-.014-.013h0l-.015-.015h0l-.015-.015h0l-.015-.014,0,0-.014-.013h0l-.015-.015,0,0-.014-.014h0l-.015-.015h0l-.014-.014,0,0-.014-.014h0l-.015-.014,0,0-.014-.014h0l-.015-.015,0,0-.014-.013h0a.147.147,0,0,0-.015-.015h0l-.014-.015h0l-.015-.014,0,0a.169.169,0,0,1-.014-.013v0l-.015-.015,0,0-.014-.014,0,0c-.005,0-.009-.01-.014-.014h0c-.006,0-.01-.01-.015-.015l0,0-.014-.014h0l-.015-.014,0,0-.014-.014h0l-.015-.015,0,0-.014-.013h0l-.015-.015,0,0-.014-.014h0l-.015-.014,0,0-.013-.014,0,0-.014-.013h0l-.016-.015,0,0s-.009-.01-.014-.014h0c-.006,0-.01-.01-.016-.015l0,0-.014-.014h0l-.015-.014,0,0-.014-.014h0l-.015-.015,0,0-.014-.014h0l-.016-.015,0,0-.013-.014,0,0-.014-.014h0l-.016-.015,0,0-.014-.013,0,0c-.005,0-.009-.01-.014-.015h0l-.015-.014h0l-.015-.015,0,0-.014-.014h0l-.015-.014,0,0-.014-.013h0l-.015-.015,0,0-.014-.014h0l-.015-.015h0l-.016-.015,0,0-.014-.014h0c-.005,0-.009-.01-.014-.015l0,0-.014-.014h0l-.016-.015h0l-.015-.014h0l-.015-.015,0,0-.014-.014h0l-.015-.014,0,0-.014-.013,0,0-.014-.014h0l-.016-.016,0,0-.014-.014h0l-.014-.015s0,0,0,0l-.014-.013a17.991,17.991,0,0,1,4.179,5.47,20.5,20.5,0,0,1,1.9,5.946l-.018,0,3.2,3.2.109-.02c-.066-.45-.216-.908-.318-1.361",
    transform: "translate(-629.616 -171.506)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.081,237.5,344,258.18,333.921,237.5H315.313l20.072,36.1v24.982h16.37V273.6L372,237.5Z",
    transform: "translate(-215.478 -162.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.244,237.5l-9.211,18.891-7.657-15.709h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016H377.3l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.015h-.008l-.008-.016H377.2l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.015h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.015h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.015h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.015h-.008l-.008-.016h-.008l-.008-.016h-.009l-.008-.015h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016H376.7l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.015h-.009l-.008-.016h-.008l-.008-.016H376.6l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.016h-.009l-.008-.016H376.5l-.008-.016h-.009l-.008-.015h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.016H376.4l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.016h-.009l-.008-.015h-.009l-.008-.016H376.3l-.008-.016h-.008l-.008-.016h-.009l-.008-.015h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016H376.2l-.008-.016h-.008l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.015h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.015h-.009l-.008-.016h-.009l-.008-.015h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.015h-.009l-.008-.016h-.009l-.008-.016H375.7l-.008-.016h-.008l-.008-.015h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016H375.6l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.015h-.008l-.008-.016H375.5l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016H375.4l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016H375.3l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016H375.2l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.015h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.015h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008L375,238.39h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.015h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016H374.8l-.008-.016h-.009l-.008-.015h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016H374.7l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016H374.6l-.008-.016h-.008l-.008-.016h-.009l-.008-.015h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016H374.5l-.008-.016h-.008l-.008-.015h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016H374.4l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016H374.3l-.008-.016h-.009l-.008-.016h-.009l-.008-.015h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.008l-.008-.015h-.009l-.008-.016h-.008l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016h-.009l-.008-.016,10.079,20.677Z",
    transform: "translate(-255.64 -162.304)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.278,433.839h.011l-.011-.01Z",
    transform: "translate(-261.24 -296.469)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.07,433.637h.012l-.012-.012Z",
    transform: "translate(-261.098 -296.33)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.381,433.939h.011l-.011-.011Z",
    transform: "translate(-261.311 -296.537)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.225,433.788h.012l-.012-.012Z",
    transform: "translate(-261.204 -296.433)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.121,433.687h.012l-.012-.011Z",
    transform: "translate(-261.133 -296.364)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.174,433.738h.011l-.011-.011Z",
    transform: "translate(-261.169 -296.399)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.328,433.888h.012l-.012-.011Z",
    transform: "translate(-261.275 -296.502)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.639,434.191h.01l-.01-.009Z",
    transform: "translate(-261.487 -296.709)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.589,434.14h.01l-.01-.01Z",
    transform: "translate(-261.452 -296.674)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.432,433.989h.011l-.011-.01Z",
    transform: "translate(-261.345 -296.571)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.536,434.089h.01l-.01-.01Z",
    transform: "translate(-261.416 -296.639)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.483,434.039h.012l-.012-.011Z",
    transform: "translate(-261.38 -296.605)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.914,433.487h.012l-.012-.012Z",
    transform: "translate(-260.991 -296.227)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.656,433.236h.012l-.012-.012Z",
    transform: "translate(-260.815 -296.055)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.605,433.186h.012l-.012-.012Z",
    transform: "translate(-260.78 -296.022)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.451,433.036h.012l-.012-.012Z",
    transform: "translate(-260.675 -295.919)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.552,433.136h.013l-.013-.012Z",
    transform: "translate(-260.744 -295.987)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.5,433.085h.012l-.012-.012Z",
    transform: "translate(-260.709 -295.952)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.863,433.438h.012l-.012-.011Z",
    transform: "translate(-260.957 -296.194)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.76,433.337h.012l-.012-.012Z",
    transform: "translate(-260.886 -296.124)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.967,433.537h.012l-.012-.011Z",
    transform: "translate(-261.027 -296.262)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.69,434.239h.01l-.01-.01Z",
    transform: "translate(-261.522 -296.742)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.813,433.387h.012l-.012-.012Z",
    transform: "translate(-260.922 -296.159)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.02,433.588h.011l-.011-.011Z",
    transform: "translate(-261.064 -296.296)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.709,433.288h.012l-.012-.012Z",
    transform: "translate(-260.851 -296.091)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.519,435.043h.009l-.009-.009Z",
    transform: "translate(-262.088 -297.293)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.673,435.194h.009l-.009-.009Z",
    transform: "translate(-262.194 -297.395)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.623,435.144h.008l-.008-.008Z",
    transform: "translate(-262.159 -297.362)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.57,435.094h.009l-.009-.009Z",
    transform: "translate(-262.123 -297.327)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.466,434.992h.009l-.009-.009Z",
    transform: "translate(-262.052 -297.258)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.415,434.944h.01l-.01-.009Z",
    transform: "translate(-262.017 -297.225)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.777,435.294h.009l-.009-.008Z",
    transform: "translate(-262.264 -297.465)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.934,435.446h.008l-.008-.008Z",
    transform: "translate(-262.371 -297.569)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.881,435.394h.008l-.008-.008Z",
    transform: "translate(-262.335 -297.533)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.828,435.344h.009l-.009-.009Z",
    transform: "translate(-262.299 -297.498)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.726,435.244h.009l-.009-.009Z",
    transform: "translate(-262.23 -297.43)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.365,434.894h.009l-.009-.008Z",
    transform: "translate(-261.983 -297.191)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.312,434.842h.009l-.009-.009Z",
    transform: "translate(-261.947 -297.155)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.95,434.491h.009l-.009-.009Z",
    transform: "translate(-261.699 -296.915)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,434.542h.01l-.01-.01Z",
    transform: "translate(-261.734 -296.95)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.9,434.44h.01l-.01-.01Z",
    transform: "translate(-261.663 -296.88)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.847,434.392h.01l-.01-.009Z",
    transform: "translate(-261.629 -296.847)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.8,434.342h.01l-.01-.009Z",
    transform: "translate(-261.594 -296.814)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.208,434.743h.009l-.009-.009Z",
    transform: "translate(-261.876 -297.087)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.743,434.29h.01l-.01-.01Z",
    transform: "translate(-261.558 -296.777)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.259,434.792h.01l-.01-.01Z",
    transform: "translate(-261.91 -297.12)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.1,434.642h.009l-.009-.01Z",
    transform: "translate(-261.805 -297.018)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.054,434.593h.01l-.01-.01Z",
    transform: "translate(-261.77 -296.984)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.157,434.692h.01l-.01-.009Z",
    transform: "translate(-261.841 -297.052)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.92,240.719l.009-.016H453.9l.009-.016h-.025l.009-.015h-.025l.009-.016h-.026l.009-.016h-.025l.009-.015h-.025l.009-.016h-.025l.009-.016h-.025l.008-.015h-.025l.009-.016h-.025l.009-.016h-.026l.009-.015h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.015h-.025l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.026l.009-.016h-.025l.009-.015h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016H453.4l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016H453.3l.009-.016h-.024l.008-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016H453.2l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.015h-.026l.009-.016h-.026l.009-.016H453.1l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.008-.016h-.025l.009-.016H453l.009-.016h-.025L453,239.8h-.025l.009-.016h-.026l.009-.016h-.026l.009-.015h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.008-.015h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.015h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.015h-.025l.009-.016h-.026l.009-.016h-.026l.009-.016H452.5l.009-.016h-.025l.009-.015h-.026l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016H452.4l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016H452.3l.009-.016h-.026l.009-.016h-.025l.008-.015h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016H452.2l.009-.016h-.026l.009-.015h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016H452.1l.009-.016h-.025l.008-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016H452l.009-.016h-.025l.009-.016h-.026l.009-.015h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.008-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.008-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.008-.016h-.025l.009-.016h-.025l.008-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.008-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016H451.6l.009-.015h-.025l.008-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016H451.5l.009-.016h-.025l.008-.016h-.025l.009-.016h-.025l.009-.015h-.026l.009-.016h-.025l.009-.016H451.4l.008-.016h-.025l.009-.015h-.026l.009-.016h-.025l.009-.016h-.025l.008-.016h-.025l.009-.016H451.3l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.016h-.026l.009-.016h-.025l.009-.015H451.2l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.008-.016h-.025l.009-.016h-.026l.009-.016H451.1l.009-.016h-.025l.009-.016h-.026l.009-.015h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l.009-.015h-.025l.009-.016h-.025l.008-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.008-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.015h-.025l.009-.016h-.026l.009-.016h-.026l.009-.016h-.024l.009-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.008-.016h-.025l.009-.016h-.026l.009-.016h-.025l.009-.016h-.025l.009-.016h-.026l-20.236,36.082v24.982L433.7,301.8V276.816l20.245-36.1Z",
    transform: "translate(-294.132 -162.337)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.742,431.379h.015l-.015-.015Z",
    transform: "translate(-259.507 -294.785)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.8,431.43h.015l-.015-.015Z",
    transform: "translate(-259.543 -294.819)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.846,431.481h.016l-.016-.015Z",
    transform: "translate(-259.578 -294.854)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.639,431.28h.016l-.016-.015Z",
    transform: "translate(-259.436 -294.717)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.691,431.331h.016l-.016-.015Z",
    transform: "translate(-259.472 -294.751)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.9,431.531h.014l-.014-.014Z",
    transform: "translate(-259.614 -294.889)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,431.631h.015l-.015-.014Z",
    transform: "translate(-259.683 -294.957)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.208,431.832h.015l-.015-.014Z",
    transform: "translate(-259.825 -295.094)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.106,431.731h.014l-.014-.014Z",
    transform: "translate(-259.756 -295.026)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.949,431.58h.015l-.015-.015Z",
    transform: "translate(-259.649 -294.922)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.588,431.23h.015l-.015-.014Z",
    transform: "translate(-259.402 -294.683)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.053,431.681h.015l-.015-.014Z",
    transform: "translate(-259.72 -294.991)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.157,431.782h.014l-.014-.014Z",
    transform: "translate(-259.79 -295.061)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.019,430.679h.016v.015h.016l-.032-.031Z",
    transform: "translate(-259.013 -294.306)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.123,430.779h.016l-.016-.016Z",
    transform: "translate(-259.084 -294.374)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.173,430.828h.016v.016h.016l-.032-.032Z",
    transform: "translate(-259.118 -294.407)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.812,430.477h.016v.016h.017v.016h.016l-.049-.048Z",
    transform: "translate(-258.871 -294.167)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.966,430.627h.016l-.016-.016Z",
    transform: "translate(-258.977 -294.27)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.535,431.179h.016l-.016-.016Z",
    transform: "translate(-259.366 -294.647)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.277,430.929h.016l-.016-.016Z",
    transform: "translate(-259.189 -294.476)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.431,431.077h.016l-.016-.016Z",
    transform: "translate(-259.295 -294.578)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.484,431.129h.015l-.015-.015Z",
    transform: "translate(-259.331 -294.614)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.381,431.029h.016l-.016-.016Z",
    transform: "translate(-259.26 -294.545)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.33,430.979h.016l-.016-.015Z",
    transform: "translate(-259.225 -294.511)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.311,431.931h.014l-.014-.014Z",
    transform: "translate(-259.896 -295.162)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.036,432.635h.013l-.013-.013Z",
    transform: "translate(-260.392 -295.644)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.26,431.882h.014l-.014-.014Z",
    transform: "translate(-259.861 -295.129)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.087,432.684h.013l-.013-.013Z",
    transform: "translate(-260.426 -295.677)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.88,432.483h.014l-.014-.014Z",
    transform: "translate(-260.285 -295.54)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.933,432.533h.013l-.013-.013Z",
    transform: "translate(-260.321 -295.575)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.345,432.935h.013l-.013-.012Z",
    transform: "translate(-260.603 -295.849)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.829,432.434h.013l-.013-.013Z",
    transform: "translate(-260.25 -295.507)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.14,432.736h.013l-.013-.012Z",
    transform: "translate(-260.462 -295.713)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.294,432.885h.012l-.012-.012Z",
    transform: "translate(-260.568 -295.816)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.191,432.785h.014l-.014-.013Z",
    transform: "translate(-260.497 -295.747)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.244,432.835h.012l-.012-.012Z",
    transform: "translate(-260.533 -295.781)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.984,432.584H381l-.014-.013Z",
    transform: "translate(-260.355 -295.609)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.467,432.083h.014l-.014-.014Z",
    transform: "translate(-260.003 -295.266)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.364,431.982h.014l-.014-.014Z",
    transform: "translate(-259.932 -295.197)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.415,432.032h.014l-.014-.014Z",
    transform: "translate(-259.967 -295.232)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.984,435.495h.008l-.008-.008Z",
    transform: "translate(-262.406 -297.602)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.4,432.986h.013l-.013-.012Z",
    transform: "translate(-260.639 -295.884)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.725,432.334h.014l-.014-.013Z",
    transform: "translate(-260.179 -295.438)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.776,432.383h.014l-.014-.013Z",
    transform: "translate(-260.214 -295.472)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.675,432.283h.013l-.013-.013Z",
    transform: "translate(-260.144 -295.404)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.569,432.183h.014l-.014-.014Z",
    transform: "translate(-260.072 -295.334)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.622,432.233h.014l-.014-.014Z",
    transform: "translate(-260.108 -295.369)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.518,432.132h.014l-.014-.014Z",
    transform: "translate(-260.038 -295.3)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.071,436.55h.007l-.007-.006Z",
    transform: "translate(-263.149 -298.324)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.812,439.208h0l0,0Z",
    transform: "translate(-265.022 -300.143)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.4,438.806h0l0,0Z",
    transform: "translate(-264.739 -299.868)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.5,438.907h0l0,0Z",
    transform: "translate(-264.809 -299.937)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.45,438.857h0l0,0Z",
    transform: "translate(-264.775 -299.903)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.294,438.7h0l0,0Z",
    transform: "translate(-264.668 -299.798)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.192,438.606h0l0,0Z",
    transform: "translate(-264.598 -299.732)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.243,438.656h0l0,0Z",
    transform: "translate(-264.633 -299.765)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.554,438.958h0l0,0Z",
    transform: "translate(-264.845 -299.972)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.761,439.158h0l0,0Z",
    transform: "translate(-264.987 -300.109)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.708,439.107h0l0,0Z",
    transform: "translate(-264.951 -300.073)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.6,439.007h0l0,0Z",
    transform: "translate(-264.88 -300.005)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.658,439.057h0l0,0Z",
    transform: "translate(-264.916 -300.04)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.347,438.757h0l0,0Z",
    transform: "translate(-264.704 -299.834)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.778,438.205h0l0,0Z",
    transform: "translate(-264.315 -299.457)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.725,438.153h0l0,0Z",
    transform: "translate(-264.279 -299.421)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.829,438.254h0l0,0Z",
    transform: "translate(-264.35 -299.49)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.674,438.1h0l0,0Z",
    transform: "translate(-264.244 -299.387)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.571,438h0l0,0Z",
    transform: "translate(-264.174 -299.318)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.985,438.406h0l0,0Z",
    transform: "translate(-264.457 -299.594)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.881,438.3h0l0,0Z",
    transform: "translate(-264.386 -299.525)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.087,438.5h0l0,0Z",
    transform: "translate(-264.526 -299.661)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.036,438.455h0l0,0Z",
    transform: "translate(-264.491 -299.628)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.932,438.356h0l0,0Z",
    transform: "translate(-264.421 -299.56)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.139,438.555h0l0,0Z",
    transform: "translate(-264.562 -299.696)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.623,438.055h0l0,0Z",
    transform: "translate(-264.21 -299.354)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.692,440.061h0Z",
    transform: "translate(-265.623 -300.727)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.742,440.11h0Z",
    transform: "translate(-265.658 -300.76)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.639,440.011h0Z",
    transform: "translate(-265.587 -300.692)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.8,440.161h0Z",
    transform: "translate(-265.694 -300.795)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.484,439.86h0Z",
    transform: "translate(-265.481 -300.59)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.588,439.96h0Z",
    transform: "translate(-265.552 -300.658)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.537,439.911h0Z",
    transform: "translate(-265.517 -300.624)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,440.363h0Z",
    transform: "translate(-265.835 -300.934)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.846,440.211h0Z",
    transform: "translate(-265.729 -300.83)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.053,440.412h0Z",
    transform: "translate(-265.87 -300.967)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.9,440.262h0Z",
    transform: "translate(-265.765 -300.865)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.95,440.311h0Z",
    transform: "translate(-265.799 -300.898)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.431,439.808h0v0Z",
    transform: "translate(-265.445 -300.554)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.07,439.459h0l0,0Z",
    transform: "translate(-265.198 -300.315)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.019,439.408h0l0,0Z",
    transform: "translate(-265.163 -300.28)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.915,439.308h0l0,0Z",
    transform: "translate(-265.093 -300.212)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.123,439.51h0l0,0Z",
    transform: "translate(-265.234 -300.35)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.968,439.359h0l0,0Z",
    transform: "translate(-265.129 -300.247)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.33,439.71h0Z",
    transform: "translate(-265.376 -300.487)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.381,439.76h0l0,0Z",
    transform: "translate(-265.411 -300.52)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.863,439.256h0l0,0Z",
    transform: "translate(-265.057 -300.176)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.226,439.609h0l0,0Z",
    transform: "translate(-265.305 -300.417)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.173,439.558h0l0,0Z",
    transform: "translate(-265.269 -300.383)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.277,439.659h0l0,0Z",
    transform: "translate(-265.34 -300.451)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.139,435.645h.008l-.008-.008Z",
    transform: "translate(-262.512 -297.705)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.811,436.3h.007l-.007-.007Z",
    transform: "translate(-262.971 -298.151)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.864,436.348h.007l-.007-.007Z",
    transform: "translate(-263.007 -298.185)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.968,436.449h.006l-.006-.006Z",
    transform: "translate(-263.078 -298.255)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.915,436.4h.007l-.007-.007Z",
    transform: "translate(-263.042 -298.22)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.76,436.248h.007l-.007-.007Z",
    transform: "translate(-262.936 -298.117)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.71,436.2h.007l-.007-.007Z",
    transform: "translate(-262.902 -298.082)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.226,436.7h.006l-.006-.006Z",
    transform: "translate(-263.254 -298.427)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.657,436.146h.007l-.007-.007Z",
    transform: "translate(-262.866 -298.048)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.173,436.648h.006l-.006-.006Z",
    transform: "translate(-263.218 -298.391)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.018,436.5h.007l-.007-.007Z",
    transform: "translate(-263.113 -298.288)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.761,430.427h.016l-.016-.016Z",
    transform: "translate(-258.837 -294.133)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.278,436.75h.006l-.006-.006Z",
    transform: "translate(-263.29 -298.461)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.122,436.6h.007l-.007-.006Z",
    transform: "translate(-263.184 -298.357)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.242,435.746h.008l-.008-.008Z",
    transform: "translate(-262.582 -297.773)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.191,435.7h.008l-.008-.008Z",
    transform: "translate(-262.548 -297.74)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.088,435.6h.008l-.008-.008Z",
    transform: "translate(-262.477 -297.67)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.3,435.8h.008l-.008-.008Z",
    transform: "translate(-262.618 -297.808)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.035,435.544h.008l-.008-.008Z",
    transform: "translate(-262.441 -297.635)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.6,436.1h.008l-.008-.008Z",
    transform: "translate(-262.83 -298.013)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.346,435.846h.008l-.008-.008Z",
    transform: "translate(-262.653 -297.842)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.553,436.047h.007l-.007-.007Z",
    transform: "translate(-262.795 -297.98)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.5,436h.008l-.008-.007Z",
    transform: "translate(-262.76 -297.946)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.4,435.9h.008l-.008-.008Z",
    transform: "translate(-262.689 -297.877)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.449,435.946h.008l-.008-.008Z",
    transform: "translate(-262.724 -297.91)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.329,436.8h.006l-.006-.006Z",
    transform: "translate(-263.325 -298.495)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.209,437.653h.005l-.005,0Z",
    transform: "translate(-263.926 -299.079)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.105,437.552h.005l-.005-.005Z",
    transform: "translate(-263.856 -299.01)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.156,437.6h.005l-.005-.005Z",
    transform: "translate(-263.89 -299.043)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,437.451h.005l-.005-.005Z",
    transform: "translate(-263.785 -298.94)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.949,437.4h.006l-.006-.006Z",
    transform: "translate(-263.749 -298.906)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.055,437.5h.005l-.005,0Z",
    transform: "translate(-263.821 -298.977)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.467,437.9h0l0,0Z",
    transform: "translate(-264.103 -299.25)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.416,437.854h0l0,0Z",
    transform: "translate(-264.068 -299.217)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.363,437.8h.005l-.005,0Z",
    transform: "translate(-264.032 -299.182)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.26,437.7h.005l-.005-.005Z",
    transform: "translate(-263.961 -299.112)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.313,437.753h0l0,0Z",
    transform: "translate(-263.997 -299.147)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.744,437.2h.005l-.005-.005Z",
    transform: "translate(-263.608 -298.77)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.536,437h.006l-.006-.006Z",
    transform: "translate(-263.467 -298.632)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.587,437.05h.006l-.006-.006Z",
    transform: "translate(-263.501 -298.666)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.9,437.351h.005l-.005-.005Z",
    transform: "translate(-263.714 -298.872)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.38,436.849h.006l-.006-.006Z",
    transform: "translate(-263.36 -298.528)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.433,436.9h.006l-.006-.006Z",
    transform: "translate(-263.396 -298.563)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.484,436.95h.006l-.006-.006Z",
    transform: "translate(-263.431 -298.597)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.64,437.1h.006l-.006-.005Z",
    transform: "translate(-263.538 -298.702)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.847,437.3h.005l-.005,0Z",
    transform: "translate(-263.679 -298.839)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.794,437.252h.006l-.006-.005Z",
    transform: "translate(-263.643 -298.804)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.518,437.952h0l0,0Z",
    transform: "translate(-264.137 -299.283)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.691,437.151h.006l-.006-.006Z",
    transform: "translate(-263.572 -298.735)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.356,431.962l0,0v0Z",
    transform: "translate(-259.926 -295.193)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.114,435.613l.008.008v-.008Z",
    transform: "translate(-262.495 -297.688)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.967,437.413l.011.01v-.01Z",
    transform: "translate(-263.761 -298.918)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.813,437.263l.011.011v-.011Z",
    transform: "translate(-263.656 -298.815)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.709,437.163l.011.01v-.01Z",
    transform: "translate(-263.585 -298.747)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.864,437.311l.011.011v-.011Z",
    transform: "translate(-263.69 -298.849)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.914,437.362l.011.01v-.01Z",
    transform: "translate(-263.725 -298.883)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.658,437.112l.01.01v-.01Z",
    transform: "translate(-263.55 -298.713)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.4,436.862l.01.009v-.009Z",
    transform: "translate(-263.374 -298.542)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.608,437.064l.01.01v-.01Z",
    transform: "translate(-263.515 -298.679)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.347,436.812l.01.01v-.01Z",
    transform: "translate(-263.338 -298.507)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.555,437.013l.01.009v-.009Z",
    transform: "translate(-263.479 -298.645)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.5,436.962l.011.01v-.01Z",
    transform: "translate(-263.443 -298.61)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.453,436.913l.01.009v-.009Z",
    transform: "translate(-263.41 -298.577)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.38,437.813l.012.012v-.012Z",
    transform: "translate(-264.043 -299.192)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.018,437.462l.012.012v-.012Z",
    transform: "translate(-263.796 -298.951)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.481,437.913l.012.011v-.011Z",
    transform: "translate(-264.112 -299.26)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.532,437.961l.012.012v-.012Z",
    transform: "translate(-264.147 -299.293)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.327,437.762l.012.012v-.012Z",
    transform: "translate(-264.007 -299.157)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.428,437.862l.012.012v-.012Z",
    transform: "translate(-264.076 -299.225)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.122,437.563l.011.01v-.01Z",
    transform: "translate(-263.867 -299.021)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.071,437.512l.011.011v-.011Z",
    transform: "translate(-263.832 -298.986)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.172,437.612l.012.012v-.012Z",
    transform: "translate(-263.901 -299.054)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.276,437.714l.012.011v-.011Z",
    transform: "translate(-263.972 -299.124)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.225,437.663l.011.011v-.011Z",
    transform: "translate(-263.937 -299.089)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.094,436.564l.009.009v-.009Z",
    transform: "translate(-263.164 -298.338)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.423,435.914l.008.008v-.008Z",
    transform: "translate(-262.706 -297.893)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.527,436.013l.008.008v-.008Z",
    transform: "translate(-262.777 -297.961)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.474,435.962l.009.009v-.009Z",
    transform: "translate(-262.741 -297.927)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.628,436.113l.009.008v-.008Z",
    transform: "translate(-262.846 -298.029)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.576,436.062l.009.008v-.008Z",
    transform: "translate(-262.81 -297.995)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.269,435.763l.008.008v-.008Z",
    transform: "translate(-262.6 -297.791)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.218,435.712l.008.008v-.008Z",
    transform: "translate(-262.566 -297.756)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.165,435.662l.008.008v-.008Z",
    transform: "translate(-262.53 -297.721)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.319,435.812l.008.008v-.008Z",
    transform: "translate(-262.635 -297.824)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.679,436.161l.01.009v-.009Z",
    transform: "translate(-262.881 -298.063)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.812,430.461",
    transform: "translate(-258.871 -294.167)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.041,436.513l.009.01v-.01Z",
    transform: "translate(-263.128 -298.303)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.732,436.212l.009.009v-.009Z",
    transform: "translate(-262.917 -298.098)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.3,436.763l.01.01v-.01Z",
    transform: "translate(-263.304 -298.474)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.144,436.612l.009.009v-.009Z",
    transform: "translate(-263.199 -298.371)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.246,436.712l.01.01v-.01Z",
    transform: "translate(-263.268 -298.439)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.193,436.661l.01.01v-.01Z",
    transform: "translate(-263.232 -298.404)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.585,438.012l.012.012v-.012Z",
    transform: "translate(-264.183 -299.328)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.988,436.462l.009.009v-.009Z",
    transform: "translate(-263.092 -298.268)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.833,436.312l.01.009v-.009Z",
    transform: "translate(-262.986 -298.166)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.783,436.263l.009.008v-.008Z",
    transform: "translate(-262.952 -298.132)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.937,436.413l.009.009v-.009Z",
    transform: "translate(-263.057 -298.235)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.886,436.363l.009.009v-.009Z",
    transform: "translate(-263.023 -298.2)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.76,437.212l.011.011v-.011Z",
    transform: "translate(-263.62 -298.781)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.18,439.562l.015.014v-.014Z",
    transform: "translate(-265.273 -300.387)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.488,439.863l.016.015v-.015Z",
    transform: "translate(-265.484 -300.592)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.233,439.613l.014.014v-.014Z",
    transform: "translate(-265.309 -300.422)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.285,439.664l.014.014v-.014Z",
    transform: "translate(-265.345 -300.456)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.387,439.764l.014.014v-.014Z",
    transform: "translate(-265.415 -300.524)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.436,439.812l.016.015v-.015Z",
    transform: "translate(-265.448 -300.558)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.871,439.262l.014.014v-.014Z",
    transform: "translate(-265.062 -300.181)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.974,439.363l.014.014v-.014Z",
    transform: "translate(-265.133 -300.251)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.924,439.313l.014.014v-.014Z",
    transform: "translate(-265.098 -300.216)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.025,439.412l.014.014v-.014Z",
    transform: "translate(-265.168 -300.284)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.129,439.514l.014.014v-.014Z",
    transform: "translate(-265.238 -300.354)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.078,439.463l.014.014v-.014Z",
    transform: "translate(-265.204 -300.319)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.334,439.713l.015.014v-.014Z",
    transform: "translate(-265.379 -300.49)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.9,440.263l.016.015v-.015Z",
    transform: "translate(-265.766 -300.866)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.539,439.912l.016.015v-.015Z",
    transform: "translate(-265.519 -300.626)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.055,440.414l.016.016v-.016Z",
    transform: "translate(-265.871 -300.969)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.85,440.213l.016.016v-.016Z",
    transform: "translate(-265.731 -300.831)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,440.363l.016.016v-.016Z",
    transform: "translate(-265.837 -300.934)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.954,440.314l.015.016v-.016Z",
    transform: "translate(-265.802 -300.901)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.643,440.013l.016.015v-.015Z",
    transform: "translate(-265.59 -300.695)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.8,440.164l.015.015v-.015Z",
    transform: "translate(-265.697 -300.798)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.592,439.963l.015.015v-.015Z",
    transform: "translate(-265.555 -300.66)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.694,440.062l.016.015v-.015Z",
    transform: "translate(-265.624 -300.728)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.746,440.113l.016.015v-.015Z",
    transform: "translate(-265.66 -300.763)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.511,438.912l.014.014v-.014Z",
    transform: "translate(-264.816 -299.943)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,438.413l.012.012v-.012Z",
    transform: "translate(-264.465 -299.601)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.946,438.364l.012.012v-.012Z",
    transform: "translate(-264.43 -299.568)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.2,438.612l.014.013v-.013Z",
    transform: "translate(-264.604 -299.737)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.1,438.512l.013.012v-.012Z",
    transform: "translate(-264.534 -299.669)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.152,438.563l.013.013v-.013Z",
    transform: "translate(-264.571 -299.704)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.048,438.463l.012.012v-.012Z",
    transform: "translate(-264.5 -299.636)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.739,438.163l.012.012v-.012Z",
    transform: "translate(-264.289 -299.43)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.894,438.313l.012.012v-.012Z",
    transform: "translate(-264.394 -299.533)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.686,438.112l.012.012v-.012Z",
    transform: "translate(-264.253 -299.396)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.82,439.213l.014.013v-.013Z",
    transform: "translate(-265.027 -300.148)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.79,438.213l.012.012v-.012Z",
    transform: "translate(-264.323 -299.465)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.841,438.262l.013.012v-.012Z",
    transform: "translate(-264.358 -299.498)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.666,439.063l.014.013v-.013Z",
    transform: "translate(-264.922 -300.045)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.615,439.014l.014.013v-.013Z",
    transform: "translate(-264.887 -300.012)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.767,439.162l.014.014v-.014Z",
    transform: "translate(-264.991 -300.113)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.562,438.963l.014.013v-.013Z",
    transform: "translate(-264.851 -299.977)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.716,439.113l.014.014v-.014Z",
    transform: "translate(-264.957 -300.08)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.636,438.063l.012.012v-.012Z",
    transform: "translate(-264.218 -299.362)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.355,438.762l.014.013v-.013Z",
    transform: "translate(-264.709 -299.84)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.253,438.662l.013.012v-.012Z",
    transform: "translate(-264.64 -299.772)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.306,438.713l.013.013v-.013Z",
    transform: "translate(-264.676 -299.807)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.46,438.864l.013.013v-.013Z",
    transform: "translate(-264.782 -299.909)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.408,438.813l.014.013v-.013Z",
    transform: "translate(-264.746 -299.875)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.372,435.863l.008.008v-.008Z",
    transform: "translate(-262.671 -297.859)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.715,432.311l0,0v0Z",
    transform: "translate(-260.172 -295.432)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.667,432.263l0,0v0Z",
    transform: "translate(-260.139 -295.398)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.768,432.362l0,0v0Z",
    transform: "translate(-260.208 -295.467)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.87,432.462l0,0v0Z",
    transform: "translate(-260.278 -295.535)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.819,432.411l0,0v0Z",
    transform: "translate(-260.243 -295.5)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.614,432.212l0,0v0Z",
    transform: "translate(-260.103 -295.364)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.923,432.513l0,0v0Z",
    transform: "translate(-260.314 -295.569)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.409,432.013l0,0v0Z",
    transform: "translate(-259.963 -295.228)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.3,431.911l0,0v0Z",
    transform: "translate(-259.892 -295.158)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.459,432.062l0,0v0Z",
    transform: "translate(-259.997 -295.261)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.512,432.112l0,0v0Z",
    transform: "translate(-260.033 -295.296)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.563,432.163l0,0v0Z",
    transform: "translate(-260.068 -295.33)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.54,433.112l0,0v0Z",
    transform: "translate(-260.736 -295.979)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.282,432.862l0,0v0Z",
    transform: "translate(-260.56 -295.808)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.061,435.562l.008.008v-.008Z",
    transform: "translate(-262.459 -297.653)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.386,432.962l0,0v0Z",
    transform: "translate(-260.63 -295.876)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.487,433.061l0,0v0Z",
    transform: "translate(-260.7 -295.944)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.973,432.561l0,0v0Z",
    transform: "translate(-260.349 -295.603)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.439,433.012l0,0v0Z",
    transform: "translate(-260.666 -295.911)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.026,432.612l0,0v0Z",
    transform: "translate(-260.385 -295.637)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.077,432.663l0,0v0Z",
    transform: "translate(-260.419 -295.672)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.254,431.862l0,0v0Z",
    transform: "translate(-259.857 -295.125)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.233,432.813l0,0v0Z",
    transform: "translate(-260.526 -295.775)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.128,432.712l0,0v0Z",
    transform: "translate(-260.454 -295.705)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.181,432.762l0,0v0Z",
    transform: "translate(-260.49 -295.74)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.328,430.962h0Z",
    transform: "translate(-259.224 -294.51)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.379,431.011h0Z",
    transform: "translate(-259.259 -294.543)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.431,431.062",
    transform: "translate(-259.294 -294.578)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.533,431.162h0Z",
    transform: "translate(-259.364 -294.646)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.48,431.111h0Z",
    transform: "translate(-259.328 -294.611)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.966,430.611",
    transform: "translate(-258.977 -294.27)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.017,430.662h0Z",
    transform: "translate(-259.012 -294.304)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.586,431.212h0Z",
    transform: "translate(-259.4 -294.681)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.173,430.812",
    transform: "translate(-259.118 -294.407)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.275,430.912h0Z",
    transform: "translate(-259.188 -294.475)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.121,430.761h0Z",
    transform: "translate(-259.082 -294.373)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,431.613h0Z",
    transform: "translate(-259.681 -294.954)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.943,431.562h0Z",
    transform: "translate(-259.645 -294.92)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.047,431.661l0,0v0Z",
    transform: "translate(-259.715 -294.988)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.2,431.812l0,0v0Z",
    transform: "translate(-259.821 -295.09)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.1,431.712l0,0v0Z",
    transform: "translate(-259.752 -295.022)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.151,431.761l0,0v0Z",
    transform: "translate(-259.786 -295.056)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.634,431.261h0Z",
    transform: "translate(-259.434 -294.714)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.687,431.312h0Z",
    transform: "translate(-259.47 -294.749)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.74,431.363h0Z",
    transform: "translate(-259.506 -294.783)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.842,431.462h0Z",
    transform: "translate(-259.575 -294.851)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.895,431.513h0Z",
    transform: "translate(-259.611 -294.886)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.789,431.411h0Z",
    transform: "translate(-259.539 -294.817)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.333,432.911l0,0v0Z",
    transform: "translate(-260.594 -295.841)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.239,434.762l.006.006v-.006Z",
    transform: "translate(-261.897 -297.106)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.188,434.713l.006.006v-.006Z",
    transform: "translate(-261.862 -297.073)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.292,434.813l.006.006v-.006Z",
    transform: "translate(-261.933 -297.141)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.135,434.662l.007.006v-.006Z",
    transform: "translate(-261.826 -297.038)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.34,434.861l.008.008v-.008Z",
    transform: "translate(-261.966 -297.174)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.446,434.963l.006.006v-.006Z",
    transform: "translate(-262.038 -297.244)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.393,434.912l.007.007v-.007Z",
    transform: "translate(-262.002 -297.209)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.93,434.463l.006.006v-.006Z",
    transform: "translate(-261.686 -296.902)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.879,434.412l.006.006v-.006Z",
    transform: "translate(-261.651 -296.867)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.034,434.563l.006.006v-.006Z",
    transform: "translate(-261.756 -296.97)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.981,434.512l.006.006v-.006Z",
    transform: "translate(-261.72 -296.935)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.084,434.613l.006.006v-.006Z",
    transform: "translate(-261.791 -297.005)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.649,435.162l.008.007v-.007Z",
    transform: "translate(-262.177 -297.38)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.856,435.363l.008.007v-.007Z",
    transform: "translate(-262.319 -297.517)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.907,435.412l.008.008v-.008Z",
    transform: "translate(-262.353 -297.55)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.495,435.012l.008.007v-.007Z",
    transform: "translate(-262.072 -297.277)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.806,435.312l.007.007v-.007Z",
    transform: "translate(-262.284 -297.482)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.96,435.463l.008.008v-.008Z",
    transform: "translate(-262.389 -297.585)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.011,435.511l.008.008v-.008Z",
    transform: "translate(-262.424 -297.618)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.593,433.163l0,0v0Z",
    transform: "translate(-260.772 -296.014)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.6,435.113l.007.007v-.007Z",
    transform: "translate(-262.144 -297.346)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.547,435.062l.007.007v-.007Z",
    transform: "translate(-262.108 -297.312)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.826,434.361l.006.006v-.006Z",
    transform: "translate(-261.615 -296.833)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.7,435.213l.008.007v-.007Z",
    transform: "translate(-262.213 -297.414)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.755,435.263l.007.007v-.007Z",
    transform: "translate(-262.249 -297.449)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.9,433.461l0,0v0Z",
    transform: "translate(-260.982 -296.218)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,433.561l.005.005v-.005Z",
    transform: "translate(-261.052 -296.286)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.953,433.512l0,0v0Z",
    transform: "translate(-261.018 -296.252)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.158,433.711l.005.005v-.005Z",
    transform: "translate(-261.158 -296.388)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.107,433.663l0,0v0Z",
    transform: "translate(-261.123 -296.355)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.054,433.612l.005,0v0Z",
    transform: "translate(-261.087 -296.32)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.695,433.262l0,0v0Z",
    transform: "translate(-260.841 -296.082)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.642,433.211l0,0v0Z",
    transform: "translate(-260.805 -296.047)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.747,433.313l0,0v0Z",
    transform: "translate(-260.877 -296.116)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.8,433.362l.005,0v0Z",
    transform: "translate(-260.911 -296.15)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.849,433.413l0,0v0Z",
    transform: "translate(-260.947 -296.184)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.776,434.313l.006.006v-.006Z",
    transform: "translate(-261.58 -296.799)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.568,434.111l.006.006v-.006Z",
    transform: "translate(-261.438 -296.662)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.621,434.162l.006.006v-.006Z",
    transform: "translate(-261.475 -296.697)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.672,434.211l.006.006v-.006Z",
    transform: "translate(-261.509 -296.73)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.723,434.262l.006.006v-.006Z",
    transform: "translate(-261.544 -296.765)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.52,434.063l.005.005v-.005Z",
    transform: "translate(-261.405 -296.629)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.312,433.862l.005.005v-.005Z",
    transform: "translate(-261.263 -296.491)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.261,433.813l.005.005v-.005Z",
    transform: "translate(-261.229 -296.458)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.209,433.762l.005,0v0Z",
    transform: "translate(-261.193 -296.423)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.365,433.912l.005.005v-.005Z",
    transform: "translate(-261.3 -296.526)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.467,434.012l.005.005v-.005Z",
    transform: "translate(-261.369 -296.594)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.416,433.963l.005.005v-.005Z",
    transform: "translate(-261.334 -296.561)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.761,430.412l.016.016.049.047.016.016h0l.032.031h0l.016.016.032.032h0l.016.016h0l.016.015h0l.016.015.016.016h0l.016.015h0l.016.015h0v0l.015.014h0l.015.015h0l.015.015h0l.015.015h0l.015.015h0l.016.015h0l.014.014h0l.015.015h0l.015.014h0v0l.015.014h0v0l.014.014h0v0l.014.014h0v0l.015.014h0v0l.014.013h0v0l.014.014h0v0l.014.014h0v0l.014.014h0v0l.014.013h0v0l.014.014h0v0l.014.014h0v0l.014.014h0v0l.013.013h0v0l.013.013h0v0l.014.013h0v0l.013.013h0v0l.014.014h0v0l.013.013h0v0l.013.013h0v0l.013.013h0v0l.013.013h0v0l.013.012h0v0l.014.013h0v0l.012.012h0v0l.012.012h0v0l.013.012h0v0l.013.012h0v0l.011.011h0v0l.012.012h0v0l.013.012h0v0l.012.012h0v0l.012.012h0v0l.012.011h0v0l.011.012h.005v0l.011.012h0v0l.012.011h0v0l.012.011h0v0l.011.011h.005v.005l.011.011h.005v0l.011.012h0v0l.012.011h.005v.005l.011.011h.005v0l.012.012h.005v.005l.011.01h.005v.005l.011.011h.005v.005l.011.011h.005v.005l.011.01h.005v.005l.012.011h.005v.005l.01.01h.007v.006l.01.01h.006v.006l.01.01H380v.006l.01.01h.006v.006l.01.01h.006v.006l.01.009h.007v.006l.01.009h.006v.006l.01.01h.006v.006l.01.01h.006v.006l.01.01h.006v.006l.009.009h.007v.006l.01.009h.007v.007l.01.01h.006v.006l.01.009h.006v.006l.01.01h.006v.006l.009.009h.008v.008l.009.008h.007v.007l.009.009h.006v.006l.009.009h.008v.007l.009.009h.007v.007l.009.009h.007v.007l.008.008h.008v.007l.009.009h.008v.007l.009.009h.007v.007l.009.008h.007v.007l.009.009h.008v.007l.008.009h.009V432l.008.008h.008v.008l.009.008h.008v.008l.009.008h.008v.008l.008.008h.008v.008l.008.008h.009v.008l.008.008h.008v.008l.009.008h.008v.008l.008.008h.008v.009l.008.008h.009v.008l.008.008h.009v.008l.008.008h.009v.009l.008.007h.008v.009l.007.007h.009v.008l.008.008h.009v.008l.007.007h.01v.009l.007.007h.009v.009l.007.007h.009v.009l.007.007h.01v.009l.007.007h.009v.009l.007.007h.01v.009l.006.006h.01v.009l.007.007h.009v.01l.007.006h.009v.009l.007.007h.009v.009l.006.006h.01v.01l.006.006h.01v.01l.006.006h.009v.01l.006.006h.01v.009l.006.006h.01v.01l.006.006h.01v.01l.006.006h.011v.01l.006.006h.01v.009l.007.007h.01v.01l.006.005h.01v.01l.006.006h.011v.01l.005.005h.011v.011l.006.005H381v.011l.005,0h.011v.011l.005.005h.011v.01l.006.006h.011v.01l.005.005h.012v.011l.005,0h.011v.011l.005.005h.011v.01l.005.005h.012v.012l.005,0h.011v.011l.005.005h.012v.011l0,0h.011v.012l.005,0h.011v.012l0,0h.012v.012l0,0h.012v.011l0,0h.012v.011l0,0h.012v.012l0,0h.012v.012l0,0h.012v.011l0,0h.012v.012l0,0h.012v.011l0,0h.013v.012l0,0h.012v.012l0,0h.012v.012l0,0h.012v.012l0,0h.012v.012l0,0h.013v.012l0,0h.013v.013l0,0h.014v.013l0,0h.013v.012l0,0h.013v.013l0,0h.014v.013l0,0h.013v.013l0,0h.013v.013l0,0h.014v.014l0,0h.014v.013l0,0h.014v.013l0,0h.013v.013l0,0h.014v.013l0,0h.014v.014l0,0h.014v.013l0,0h.014v.014l0,0h.014v.014l0,0h.014v.014l0,0h.014v.014l0,0h.014v.014l0,0h.014v.013l0,0h.015v.014l0,0h.014v.014l0,0h.014v.014h.016v.014l0,0h.014v.015h.015v.015h.017v.015h.016v.015h.016v.016h.016v.015h.016v.015h.017v.015h.016v.015h.017v.015h.016v.015H382v.016h.016v.015h.017v.016h16.37l-3.292-3.182Z",
    transform: "translate(-258.837 -294.134)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.91,284.764l-3.292-3.182v9.649h3.292Z",
    transform: "translate(-388.581 -192.426)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.654,240.719h-.016V240.7h-.016v-.016H769.6v-.015h-.016v-.016h-.017v-.016h-.016v-.015h-.017v-.016h-.016v-.016h-.016v-.015h-.017v-.016h-.017v-.016h-.016v-.015h-.016v-.016h-.017V240.5h-.016v-.016h-.017v-.015h-.016v-.016h-.016v-.016h-.016v-.016h-.017V240.4h-.016v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.017v-.015h-.017v-.016h-.016v-.016H769.2v-.016h-.016v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.017V240.2H769.1v-.016h-.016v-.016h-.017v-.016h-.017v-.016h-.016v-.016h-.016V240.1H769v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.016h-.016v-.016H768.9v-.016h-.017v-.016h-.017v-.015h-.016v-.016h-.016v-.016h-.017v-.016H768.8V239.9h-.016v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.016H768.7V239.8h-.017v-.016h-.016v-.016h-.016v-.015h-.017v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.017v-.015h-.016v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.016v-.015h-.016v-.016h-.017v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.017V239.5h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.017V239.4h-.016v-.015h-.016v-.016h-.016v-.016h-.016v-.016h-.017v-.016H768.2v-.015h-.016v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.016H768.1v-.016h-.016V239.2h-.016v-.016h-.016v-.016h-.017v-.016h-.017v-.016H768v-.016h-.016V239.1h-.017v-.016h-.016v-.016h-.017v-.016h-.016v-.016H767.9v-.015h-.016v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.016v-.016H767.8v-.016h-.017v-.016h-.017V238.9h-.016v-.016h-.016v-.016h-.017v-.016H767.7v-.016h-.017v-.015h-.016V238.8h-.016v-.016h-.016v-.016h-.016v-.016h-.017v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.016h-.016V238.6h-.016v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.016v-.016h-.017V238.5h-.016v-.016h-.016v-.016h-.016v-.015H767.3v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.016h-.016v-.016H767.2v-.016h-.017v-.016h-.016v-.015h-.016V238.3h-.016v-.016h-.017v-.016H767.1v-.015h-.016v-.016h-.016v-.016h-.017V238.2h-.016v-.016h-.016v-.016H767v-.016h-.016v-.016h-.016v-.016h-.016v-.016h-.017v-.015h-.016v-.016H766.9v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.017V238h-.016v-.016H766.8v-.016h-.016v-.015h-.016v-.016h-.017v-.016h-.016V237.9h-.016v-.015h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.016v-.015h-.017v-.016h-.016v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.016h-.016V237.6h-.016v-.016h-.016v-.016h-.017v-.016h-.016v13.941l3.292,3.182Z",
    transform: "translate(-523.714 -162.337)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.182,388.736v-.016h-.016V388.7h-.017v-.015h-.016v-.016h-.017v-.016H770.1v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.017v-.016h-.017v-.016H770v-.015h-.016v-.016h-.016v-.016h-.016V388.5h-.017v-.015h-.016v-.016H769.9v-.016h-.016v-.016h-.017v-.016h-.016V388.4h-.017v-.016h-.016v-.016h-.016v-.016h-.017v-.015h-.017v-.016h-.016v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.016h-.016V388.2h-.016v-.015h-.017v-.016h-.017v-.016h-.016v-.015h-.016v-.016h-.016V388.1h-.016v-.016h-.017v-.015h-.016v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.017v-.016h-.017v-.015H769.4v-.016h-.016v-.016h-.017v-.016h-.017v-.016h-.016V387.9h-.016v-.016H769.3v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.017V387.8h-.016v-.016H769.2v-.015h-.017v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.016v-.015H769.1v-.016h-.017v-.016h-.016v-.016h-.017v-.016h-.016v-.015h-.016V387.6H769v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.017v-.015h-.016V387.5H768.9v-.016h-.016v-.016h-.016v-.016h-.016v-.016h-.017v-.016h-.016v-.015h-.017v-.016h-.016v-.016h-.016v-.016h-.017v-.016h-.017v-.015h-.016v-.016h-.016V387.3h-.017v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.016h-.016V387.2h-.016v-.016h-.017v-.016h-.017v-.016h-.016v-.016h-.016v-.015h-.017v-.016H768.5v-.016h-.017v-.016h-.016v-.016h-.016v-.015h-.016v-.016h-.017v-.016H768.4v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.017v-.016h-.017v-.016H768.3V386.9h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.015h-.016v-.016H768.2V386.8h-.016v-.016h-.016v-.016h-.017v-.016h-.017v-.016h-.016v-.016H768.1v-.016h-.017v-.016h-.016v-.015h-.017v-.016h-.016v-.016h-.017v-.015H768v-.016h-.016V386.6h-.017v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.017v-.016h-.016V386.5h-.017v-.016h-.016v-.015h-.017v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.016v-.016h-.016v-.016h-.017v-.016h-.017v-.015h-.016v-.016h-.016V386.3h-.017v-.016h-.016v-.015h-.017v-.016h-.016v-.016h-.017v-.016h-.016V386.2h-.016v-.016h-.017v-.016h-.016v-.016h-.016v-.016H767.5v-.016h-.017v-.015h-.016v-.016h-.017v-.016h-.016v-.015h-.017v-.016H767.4v-.016h-.017v-.015h-.016V386h-.016v-.016h-.016v-.015h-.016v-.016H767.3v-.016h-.017v-.016h-.016V385.9h-.016v-.016h-.017v-.016h-.016v-.016H767.2v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.017v-.015H767.1v-.016h-.016v-.016h-.016v-.016h-.017V385.7h-.016v-.016h-.016v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.016V385.6h-.017v-.016h-.016v-.016h-.016v14.2l3.292,3.182V388.736Z",
    transform: "translate(-524.086 -263.489)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.128,315.272h-.016v-.016H763.1v-.016h-.016v-.015h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.016H763v-.016h-.016v-.016h-.017v-.016h-.017V315.1h-.016v-.015h-.016v-.016H762.9v-.016h-.016v-.016h-.017v-.015h-.016V315h-.017v-.016h-.016v-.016H762.8v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.017v-.015H762.7v-.016h-.016v-.015h-.016v-.016h-.016v-.016h-.016V314.8h-.017v-.016H762.6v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.017V314.7h-.017v-.016h-.016v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.017v-.016h-.017v-.015h-.016V314.5h-.016v-.016h-.017v-.016h-.017v-.016h-.016v-.015h-.016v-.016h-.016V314.4h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.016v-.015h-.017v-.016H762.1v-.016h-.016v-.016h-.016v-.016h-.017v-.015h-.016v-.016h-.017V314.2H762v-.016h-.016v-.016h-.016v-.015h-.016v-.016h-.017v-.016h-.017V314.1H761.9v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.016h-.016v-.016H761.8v-.016h-.016v-.016h-.017v-.016h-.016v-.015h-.016v-.016h-.016v-.016H761.7v-.016h-.017v-.016h-.017v-.015h-.016v-.016h-.016v-.016h-.017v-.016h-.016V313.8h-.017v-.015h-.016v-.016h-.016v-.016h-.016v-.015h-.016v-.016h-.017V313.7h-.017v-.016h-.016v-.016h-.016v-.015h-.017v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.015h-.016v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.016V313.5h-.016v-.016h-.017v-.016h-.017v-.016h-.016v-.016h-.016v-.016H761.2V313.4h-.016v-.016h-.017v-.015h-.016v-.016h-.016v-.016h-.016v-.016H761.1v-.016h-.017v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.017v-.016H761v-.016h-.017V313.2h-.016v-.016h-.017v-.016h-.016v-.016h-.016v-.016H760.9v-.016h-.016V313.1h-.016v-.016h-.016v-.016h-.017v-.016h-.016v-.016H760.8v-.016h-.016v-.015h-.017v-.016h-.016v-.016h-.017v-.016h-.016v-.016H760.7v-.016h-.016v-.016h-.016V312.9h-.017v-.016h-.016v-.015h-.016v-.016h-.016v-.016h-.017v-.016h-.016V312.8h-.016v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.016v-.015h-.016v-.016h-.017v-.015h-.016v-.016h-.016v-.016h-.016V312.6h-.017v-.016h-.016v-.016h-.017v-.016h-.016v-.016h-.017v-.016h-.016V312.5h-.016v-.016h-.017v-.016h-.016v-.016H760.2v-.015h-.016v-.016h-.017v-.016h-.016v-.015h-.016v-.016h-.016v-.016H760.1v-.015h-.016v-.016h-.016v-.016h-.016V312.3h-.017v-.016h-.016v-.016H760v-.016h-.017v-.015h-.016v-.016h-.016V312.2h-.016v-.016h-.017v-.016H759.9v-.016h-.016v-.016h-.016v-.016h-.017V312.1h-.016v13.424l3.292,3.182Z",
    transform: "translate(-519.255 -213.285)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.91,357.683l-3.292-3.182v9.822h3.292Z",
    transform: "translate(-388.581 -242.258)",
    fill: "#3dcc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.52,284.764l-3.292-3.182h-62.61l3.292,3.182Z",
    transform: "translate(-388.58 -192.426)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.454,357.683l-3.292-3.182H568.618l3.292,3.182Z",
    transform: "translate(-388.581 -242.258)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.638,439.713l.016.015v-.015Z",
    transform: "translate(-360.576 -300.49)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.806,436.962l.012.011v-.011Z",
    transform: "translate(-358.64 -298.61)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.859,437.013l.011.01v-.01Z",
    transform: "translate(-358.676 -298.645)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.962,437.112l.011.011v-.011Z",
    transform: "translate(-358.747 -298.713)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.911,437.064l.011.01v-.01Z",
    transform: "translate(-358.712 -298.679)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.117,437.263l.011.011v-.011Z",
    transform: "translate(-358.853 -298.815)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.064,437.212l.012.011v-.011Z",
    transform: "translate(-358.817 -298.781)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.013,437.163l.012.011v-.011Z",
    transform: "translate(-358.782 -298.747)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.757,436.913l.01.01v-.01Z",
    transform: "translate(-358.607 -298.577)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.55,436.712l.01.01v-.01Z",
    transform: "translate(-358.465 -298.439)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.6,436.763l.01.01v-.01Z",
    transform: "translate(-358.501 -298.474)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.651,436.812l.012.011v-.011Z",
    transform: "translate(-358.535 -298.507)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.7,436.862l.011.011v-.011Z",
    transform: "translate(-358.571 -298.542)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.476,437.612l.012.012v-.012Z",
    transform: "translate(-359.098 -299.054)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.529,437.663l.012.012v-.012Z",
    transform: "translate(-359.134 -299.089)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.58,437.714l.012.012v-.012Z",
    transform: "translate(-359.169 -299.124)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.683,437.813l.012.012v-.012Z",
    transform: "translate(-359.24 -299.192)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.63,437.762l.012.012v-.012Z",
    transform: "translate(-359.204 -299.157)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.5,436.661l.011.01v-.01Z",
    transform: "translate(-358.429 -298.404)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.425,437.563l.012.011v-.011Z",
    transform: "translate(-359.064 -299.021)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.218,437.362l.012.012v-.012Z",
    transform: "translate(-358.922 -298.883)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.167,437.311l.012.012v-.012Z",
    transform: "translate(-358.887 -298.849)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.271,437.413l.012.012v-.012Z",
    transform: "translate(-358.958 -298.918)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.375,437.512l.012.012v-.012Z",
    transform: "translate(-359.029 -298.986)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.322,437.462l.012.012v-.012Z",
    transform: "translate(-358.993 -298.951)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.036,436.212l.01.01v-.01Z",
    transform: "translate(-358.114 -298.098)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.623,435.812l.009.009v-.009Z",
    transform: "translate(-357.832 -297.824)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.448,436.612l.01.01v-.01Z",
    transform: "translate(-358.396 -298.371)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.522,435.712l.008.008v-.008Z",
    transform: "translate(-357.763 -297.756)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.676,435.863l.009.009v-.009Z",
    transform: "translate(-357.868 -297.859)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.727,435.914l.009.008v-.008Z",
    transform: "translate(-357.903 -297.893)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.778,435.962l.009.009v-.009Z",
    transform: "translate(-357.938 -297.927)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.365,435.562l.009.008v-.008Z",
    transform: "translate(-357.656 -297.653)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.314,435.511l.009.009v-.009Z",
    transform: "translate(-357.621 -297.618)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.264,435.463l.008.008v-.008Z",
    transform: "translate(-357.586 -297.585)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.418,435.613l.008.008v-.008Z",
    transform: "translate(-357.692 -297.688)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.83,436.013l.009.009v-.009Z",
    transform: "translate(-357.974 -297.961)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.469,435.662l.009.009v-.009Z",
    transform: "translate(-357.727 -297.721)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.572,435.763l.009.009v-.009Z",
    transform: "translate(-357.797 -297.791)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.241,436.413l.01.01v-.01Z",
    transform: "translate(-358.254 -298.235)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.292,436.462l.01.01v-.01Z",
    transform: "translate(-358.289 -298.268)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.19,436.363l.009.009v-.009Z",
    transform: "translate(-358.22 -298.2)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.344,436.513l.01.01v-.01Z",
    transform: "translate(-358.325 -298.303)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.4,436.564l.009.009v-.009Z",
    transform: "translate(-358.361 -298.338)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.932,436.113l.01.009v-.009Z",
    transform: "translate(-358.043 -298.029)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.879,436.062l.01.009v-.009Z",
    transform: "translate(-358.007 -297.995)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.137,436.312l.01.01v-.01Z",
    transform: "translate(-358.183 -298.166)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.983,436.161l.01.009v-.009Z",
    transform: "translate(-358.078 -298.063)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.086,436.263l.009.009v-.009Z",
    transform: "translate(-358.149 -298.132)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.732,437.862l.013.012v-.012Z",
    transform: "translate(-359.273 -299.225)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.536,439.613l.015.015v-.015Z",
    transform: "translate(-360.506 -300.422)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.483,439.562l.016.015v-.015Z",
    transform: "translate(-360.47 -300.387)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.211,435.412l.008.008v-.008Z",
    transform: "translate(-357.55 -297.55)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.739,439.812l.016.016v-.016Z",
    transform: "translate(-360.645 -300.558)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.382,439.463l.015.015v-.015Z",
    transform: "translate(-360.401 -300.319)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.589,439.664l.015.015v-.015Z",
    transform: "translate(-360.542 -300.456)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.691,439.764l.016.015v-.015Z",
    transform: "translate(-360.612 -300.524)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.433,439.514l.015.014v-.014Z",
    transform: "translate(-360.435 -300.354)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.174,439.262l.015.015v-.015Z",
    transform: "translate(-360.259 -300.181)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.124,439.213l.015.014v-.014Z",
    transform: "translate(-360.224 -300.148)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.278,439.363l.015.014v-.014Z",
    transform: "translate(-360.33 -300.251)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.329,439.412l.015.014v-.014Z",
    transform: "translate(-360.364 -300.284)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.227,439.313l.014.014v-.014Z",
    transform: "translate(-360.295 -300.216)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.946,440.013l.016.016v-.016Z",
    transform: "translate(-360.787 -300.695)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.2,440.263l.016.016v-.016Z",
    transform: "translate(-360.963 -300.866)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.792,439.863l.016.015v-.015Z",
    transform: "translate(-360.681 -300.592)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.359,440.414l.016.016v-.016Z",
    transform: "translate(-361.068 -300.969)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.1,440.164l.016.016v-.016Z",
    transform: "translate(-360.894 -300.798)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.273,440.329v-.016h-.016l.032.032v-.016Z",
    transform: "translate(-360.999 -300.9)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.154,440.213l.016.016v-.016Z",
    transform: "translate(-360.928 -300.831)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.05,440.113l.016.016v-.016Z",
    transform: "translate(-360.857 -300.763)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.9,439.963l.016.016v-.016Z",
    transform: "translate(-360.752 -300.66)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.843,439.912l.016.015v-.015Z",
    transform: "translate(-360.716 -300.626)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.071,439.162l.015.014v-.014Z",
    transform: "translate(-360.188 -300.113)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528,440.062l.016.016v-.016Z",
    transform: "translate(-360.821 -300.728)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.043,438.163l.013.012v-.012Z",
    transform: "translate(-359.486 -299.43)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.25,438.364l.013.013v-.013Z",
    transform: "translate(-359.627 -299.568)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.2,438.313l.013.012v-.012Z",
    transform: "translate(-359.591 -299.533)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.094,438.213l.013.012v-.012Z",
    transform: "translate(-359.52 -299.465)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.144,438.262l.014.013v-.013Z",
    transform: "translate(-359.555 -299.498)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.352,438.463l.014.013v-.013Z",
    transform: "translate(-359.697 -299.636)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.3,438.413l.013.013v-.013Z",
    transform: "translate(-359.662 -299.601)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.785,437.913l.013.012v-.012Z",
    transform: "translate(-359.309 -299.26)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.4,438.512l.014.014v-.014Z",
    transform: "translate(-359.731 -299.669)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.836,437.961l.013.013v-.013Z",
    transform: "translate(-359.344 -299.293)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.888,438.012l.012.012v-.012Z",
    transform: "translate(-359.38 -299.328)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.939,438.063l.013.012v-.012Z",
    transform: "translate(-359.415 -299.362)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.99,438.112l.014.013v-.013Z",
    transform: "translate(-359.45 -299.396)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.815,438.912l.014.014v-.014Z",
    transform: "translate(-360.013 -299.943)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.02,439.113l.014.014v-.014Z",
    transform: "translate(-360.154 -300.08)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.455,438.563l.013.013v-.013Z",
    transform: "translate(-359.768 -299.704)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.866,438.963l.014.014v-.014Z",
    transform: "translate(-360.048 -299.977)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.969,439.063l.014.014v-.014Z",
    transform: "translate(-360.119 -300.045)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.919,439.014l.014.014v-.014Z",
    transform: "translate(-360.084 -300.012)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.764,438.864l.014.013v-.013Z",
    transform: "translate(-359.979 -299.909)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.5,438.612l.014.014v-.014Z",
    transform: "translate(-359.801 -299.737)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.557,438.662l.014.014v-.014Z",
    transform: "translate(-359.837 -299.772)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.711,438.813l.014.014v-.014Z",
    transform: "translate(-359.943 -299.875)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.659,438.762l.014.014v-.014Z",
    transform: "translate(-359.906 -299.84)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.61,438.713l.014.014v-.014Z",
    transform: "translate(-359.873 -299.807)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.579,430.912h0Z",
    transform: "translate(-354.385 -294.475)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.816,432.112l0,0v0Z",
    transform: "translate(-355.23 -295.296)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.763,432.062l0,0v0Z",
    transform: "translate(-355.194 -295.261)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.712,432.013l0,0v0Z",
    transform: "translate(-355.16 -295.228)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.867,432.163l0,0v0Z",
    transform: "translate(-355.265 -295.33)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.97,432.263l0,0v0Z",
    transform: "translate(-355.336 -295.398)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.019,432.311l0,0v0Z",
    transform: "translate(-355.369 -295.432)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.917,432.212l0,0v0Z",
    transform: "translate(-355.3 -295.364)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.454,431.761l0,0v0Z",
    transform: "translate(-354.983 -295.056)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.505,431.812l0,0v0Z",
    transform: "translate(-355.018 -295.09)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.4,431.712l0,0v0Z",
    transform: "translate(-354.948 -295.022)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.609,431.911l0,0v0Z",
    transform: "translate(-355.089 -295.158)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.659,431.962l0,0v0Z",
    transform: "translate(-355.123 -295.193)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.558,431.862l0,0v0Z",
    transform: "translate(-355.054 -295.125)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.381,432.663l0,0v0Z",
    transform: "translate(-355.616 -295.672)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.072,432.362l0,0v0Z",
    transform: "translate(-355.405 -295.467)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.484,432.762l0,0v0Z",
    transform: "translate(-355.687 -295.74)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.537,432.813l0,0v0Z",
    transform: "translate(-355.723 -295.775)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.586,432.862l0,0v0Z",
    transform: "translate(-355.756 -295.808)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.432,432.712l0,0v0Z",
    transform: "translate(-355.651 -295.705)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.174,432.462l0,0v0Z",
    transform: "translate(-355.475 -295.535)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.123,432.411l0,0v0Z",
    transform: "translate(-355.44 -295.5)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.226,432.513l0,0v0Z",
    transform: "translate(-355.511 -295.569)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.277,432.561l0,0v0Z",
    transform: "translate(-355.546 -295.603)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.33,432.612l0,0v0Z",
    transform: "translate(-355.582 -295.637)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.477,430.812h0Z",
    transform: "translate(-354.315 -294.407)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.528,430.863h0Z",
    transform: "translate(-354.35 -294.442)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.351,431.661l0,0v0Z",
    transform: "translate(-354.912 -294.988)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.115,430.461h0Z",
    transform: "translate(-354.068 -294.167)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.631,430.962h0Z",
    transform: "translate(-354.421 -294.51)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.682,431.011h0Z",
    transform: "translate(-354.456 -294.543)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.424,430.761h0Z",
    transform: "translate(-354.279 -294.373)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.166,430.512h0Z",
    transform: "translate(-354.103 -294.202)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.219,430.562h0Z",
    transform: "translate(-354.139 -294.236)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.373,430.713h0Z",
    transform: "translate(-354.245 -294.339)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.735,431.062h0Z",
    transform: "translate(-354.492 -294.578)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.27,430.611h0Z",
    transform: "translate(-354.174 -294.27)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.321,430.662h0Z",
    transform: "translate(-354.208 -294.304)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.637,432.911l.005.005v-.005Z",
    transform: "translate(-355.791 -295.841)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.145,431.462l0,0v0Z",
    transform: "translate(-354.772 -294.851)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.093,431.411l0,0v0Z",
    transform: "translate(-354.736 -294.817)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.2,431.513h0Z",
    transform: "translate(-354.808 -294.886)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.784,431.111l0,0v0Z",
    transform: "translate(-354.525 -294.611)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.3,431.613l0,0v0Z",
    transform: "translate(-354.878 -294.954)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.247,431.562l0,0v0Z",
    transform: "translate(-354.842 -294.92)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.837,431.162h0Z",
    transform: "translate(-354.561 -294.646)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.89,431.212h0Z",
    transform: "translate(-354.597 -294.681)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.938,431.261l0,0v0Z",
    transform: "translate(-354.631 -294.714)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.044,431.363h0Z",
    transform: "translate(-354.703 -294.783)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.991,431.312l0,0v0Z",
    transform: "translate(-354.667 -294.749)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.69,432.962l0,0v0Z",
    transform: "translate(-355.827 -295.876)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.337,434.563l.007.007v-.007Z",
    transform: "translate(-356.953 -296.97)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.234,434.463l.007.006v-.006Z",
    transform: "translate(-356.883 -296.902)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.284,434.512l.007.006v-.006Z",
    transform: "translate(-356.917 -296.935)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.542,434.762l.008.008v-.008Z",
    transform: "translate(-357.094 -297.106)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.492,434.713l.007.007v-.007Z",
    transform: "translate(-357.059 -297.073)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.439,434.662l.007.006v-.006Z",
    transform: "translate(-357.023 -297.038)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.388,434.613l.007.006v-.006Z",
    transform: "translate(-356.988 -297.005)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.026,434.262l.007.006v-.006Z",
    transform: "translate(-356.741 -296.765)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.976,434.211l.007.007v-.007Z",
    transform: "translate(-356.706 -296.73)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.183,434.412l.006.006v-.006Z",
    transform: "translate(-356.848 -296.867)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.079,434.313l.006.006v-.006Z",
    transform: "translate(-356.777 -296.799)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.13,434.361l.007.007v-.007Z",
    transform: "translate(-356.812 -296.833)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.058,435.263l.008.008v-.008Z",
    transform: "translate(-357.446 -297.449)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.16,435.363l.008.008v-.008Z",
    transform: "translate(-357.516 -297.517)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.6,434.813l.007.007v-.007Z",
    transform: "translate(-357.13 -297.141)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.925,434.162l.006.006v-.006Z",
    transform: "translate(-356.671 -296.697)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.109,435.312l.008.008v-.008Z",
    transform: "translate(-357.481 -297.482)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.9,435.113l.008.008v-.008Z",
    transform: "translate(-357.341 -297.346)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.953,435.162l.008.008v-.008Z",
    transform: "translate(-357.374 -297.38)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.7,434.912l.008.008v-.008Z",
    transform: "translate(-357.199 -297.209)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.644,434.861l.008.008v-.008Z",
    transform: "translate(-357.163 -297.174)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.851,435.062l.008.007v-.007Z",
    transform: "translate(-357.305 -297.312)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.8,435.012l.008.008v-.008Z",
    transform: "translate(-357.268 -297.277)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.75,434.963l.007.007v-.007Z",
    transform: "translate(-357.235 -297.244)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.006,435.213l.008.008v-.008Z",
    transform: "translate(-357.41 -297.414)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521,433.262l.005.005v-.005Z",
    transform: "translate(-356.038 -296.082)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.051,433.313l0,0v0Z",
    transform: "translate(-356.074 -296.116)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.1,433.362l.006.005v-.005Z",
    transform: "translate(-356.108 -296.15)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.153,433.413l.005,0v0Z",
    transform: "translate(-356.144 -296.184)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.2,433.461l.006.006v-.006Z",
    transform: "translate(-356.179 -296.218)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.945,433.211l.005.005v-.005Z",
    transform: "translate(-356.002 -296.047)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.791,433.061l.005.005v-.005Z",
    transform: "translate(-355.897 -295.944)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.742,433.012l0,0v0Z",
    transform: "translate(-355.863 -295.911)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.844,433.112l0,0v0Z",
    transform: "translate(-355.933 -295.979)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.872,434.111l.006.006v-.006Z",
    transform: "translate(-356.635 -296.662)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.256,433.512l.005.005v-.005Z",
    transform: "translate(-356.215 -296.252)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.9,433.163l0,0v0Z",
    transform: "translate(-355.969 -296.014)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.719,433.963l.006.005v-.005Z",
    transform: "translate(-356.531 -296.561)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.616,433.862l.006.006v-.006Z",
    transform: "translate(-356.46 -296.491)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.307,433.561l.005.005v-.005Z",
    transform: "translate(-356.249 -296.286)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.823,434.063l.006.006v-.006Z",
    transform: "translate(-356.602 -296.629)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.77,434.012l.006.006v-.006Z",
    transform: "translate(-356.566 -296.594)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.669,433.912l.006.006v-.006Z",
    transform: "translate(-356.497 -296.526)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.411,433.663l.006.006v-.006Z",
    transform: "translate(-356.32 -296.355)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.358,433.612l.006.006v-.006Z",
    transform: "translate(-356.284 -296.32)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.565,433.813l.006.006v-.006Z",
    transform: "translate(-356.426 -296.458)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.461,433.711l.006.006v-.006Z",
    transform: "translate(-356.355 -296.388)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.512,433.762l.006.006v-.006Z",
    transform: "translate(-356.39 -296.423)",
    fill: "#437ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.065,430.412l.016.016h0l.016.016h0l.015.015h0l.016.015h0l.016.016h0l.015.015h0l.016.015h0v0l.015.015h0l.016.015h0l.015.014h0l.016.015h0l.016.015h0l.015.015h0l.014.014h0v0l.015.014h0l.016.015h0v0l.014.014h0v0l.015.014h0v0l.015.014h0l.014.014h0v0l.014.013h0v0l.015.014h0l.014.014h0v0l.014.014h0v0l.014.013h0v0l.014.013h0v0l.014.014h0v0l.013.014h0v0l.014.014h0v0l.014.013h0v0l.014.014h0v0l.014.013h0v0l.013.013h0v0l.013.013h0v0l.014.013h0v0l.013.013h0v0l.014.013h0v0l.013.013h0v0l.013.013h0v0l.012.011h0v0l.012.012h0v0l.013.013h0v0l.012.011h0v0l.013.012h0v0l.012.012h0v0l.012.012h0v0l.012.012h0v0l.013.012h0v0l.012.012h0v0l.012.012h.005v.005l.012.011h0v0l.012.012h0v0l.011.011h.005v.005l.011.011h0v0l.012.012h0v0l.011.011h.005v.005l.012.011H519v.005l.012.011h0v0l.011.011h.006v.005l.011.011h.005v0l.011.011h.006v.006l.011.01h.005v.005l.011.01h.005v.005l.011.011h.006v.006l.011.01h.006v.006l.01.009h.006v.006l.01.01h.006v.006l.011.01h.006v.006l.01.01h.006v.006l.011.01h.006v.006l.01.01h.006v.005l.01.01h.006v.006l.01.01h.006v.006l.01.01h.007v.006l.01.01h.006v.007l.01.009h.007v.007l.009.009h.007v.006l.01.01h.006v.006l.01.009h.007v.007l.009.009h.006v.007l.01.01h.007v.006l.009.009h.007v.006l.01.01h.007v.007l.009.009h.007v.007l.009.009h.007v.007l.01.01h.007v.007l.009.009h.008v.008l.009.009h.007v.007l.008.008h.008v.008l.009.008h.008v.008l.009.009h.007v.007l.009.009h.008v.008l.009.008h.008v.007l.009.009h.008v.008l.008.008h.008v.008l.008.009h.008v.008l.009.008h.008v.008l.008.008h.008v.009l.008.008h.009v.008l.008.008h.009V432l.008.008h.008v.008l.008.007h.009v.009l.007.007h.009v.009l.008.008h.009v.008l.008.008h.009v.009l.008.007h.008v.008l.008.008h.009v.009l.007.006h.009v.009l.008.007h.009v.009l.007.007h.009v.008l.007.007h.009v.009l.008.007h.009v.009l.007.006h.01v.01l.006.007h.01v.009l.006.007h.01v.009l.007.007h.009v.01l.007.006h.009v.009l.007.006H520v.01l.006.006h.01v.009l.006.006h.01v.01l.006.006h.01v.01l.007.006h.01v.01l.007.006h.009v.009l.006.006h.01v.01l.005.005h.011v.01l.006.006h.01v.01l.006.006h.01v.01l.005.005h.011v.011l.005.005h.011v.011l.006.005h.01v.01l.005.005h.012v.011l.005.005h.011v.01l.006.006h.011v.01l.005.005h.011v.011l.005.005h.012v.011l0,0h.012v.011l.005.005h.011v.011l.005,0h.011v.012l0,0h.012v.012l0,0h.012v.012l0,0h.012v.011l.005,0h.011v.011l0,0h.011v.011l0,0h.012v.012l0,0h.012v.012l0,0h.012v.011l0,0h.012v.012l0,0h.011v.012l0,0h.013v.012l0,0h.013v.012l0,0h.013v.013l0,0h.012v.012l0,0h.013v.012l0,0h.014v.013l0,0h.013v.012l0,0h.013v.012l0,0h.013v.013l0,0h.013v.012l0,0h.013v.013l0,0h.013v.013l0,0h.014v.013l0,0h.013v.014l0,0h.013v.013l0,0h.014v.013l0,0h.014v.013l0,0h.014v.014l0,0h.014v.014l0,0h.014v.014l0,0h.014v.013l0,0h.014v.014l0,0h.014v.014l0,0h.014v.014l0,0h.014v.014l0,0h.014v.013l0,0h.015v.014l0,0h.015v.014h.016v.015h.016v.014l0,0H521v.014h.016v.014l0,0h.015v.015h.016v.016h.015v.015h.016v.015h.017v.015h.016v.015h.017v.015h.016v.016h.016v.015h.017v.016h.017v.016h.016v.015h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.017v.016h.016v.016h.016v.016h78.805l-3.292-3.182Z",
    transform: "translate(-354.033 -294.134)",
    fill: "#437ffa"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustSayYesMonetta);
export default __webpack_public_path__ + "static/media/justSayYesMonetta.c1027cff009e50b364b77b74278d8a7b.svg";
export { ForwardRef as ReactComponent };